var H = function() {
  return H = Object.assign || function(e) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, H.apply(this, arguments);
};
function gi(t, e) {
  var n = {};
  for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}
function it(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n) return n.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function ct(t, e) {
  var n = typeof Symbol == "function" && t[Symbol.iterator];
  if (!n) return t;
  var r = n.call(t), i, o = [], s;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (s) throw s.error;
    }
  }
  return o;
}
function Et(t, e, n) {
  if (arguments.length === 2) for (var r = 0, i = e.length, o; r < i; r++)
    (o || !(r in e)) && (o || (o = Array.prototype.slice.call(e, 0, r)), o[r] = e[r]);
  return t.concat(o || Array.prototype.slice.call(e));
}
var lt;
(function(t) {
  t.Start = "xstate.start", t.Stop = "xstate.stop", t.Raise = "xstate.raise", t.Send = "xstate.send", t.Cancel = "xstate.cancel", t.NullEvent = "", t.Assign = "xstate.assign", t.After = "xstate.after", t.DoneState = "done.state", t.DoneInvoke = "done.invoke", t.Log = "xstate.log", t.Init = "xstate.init", t.Invoke = "xstate.invoke", t.ErrorExecution = "error.execution", t.ErrorCommunication = "error.communication", t.ErrorPlatform = "error.platform", t.ErrorCustom = "xstate.error", t.Update = "xstate.update", t.Pure = "xstate.pure", t.Choose = "xstate.choose";
})(lt || (lt = {}));
var Ve;
(function(t) {
  t.Parent = "#_parent", t.Internal = "#_internal";
})(Ve || (Ve = {}));
var Zr = lt.Start, vi = lt.Stop, wr = lt.Raise, _r = lt.Send, is = lt.Cancel, Ic = lt.NullEvent, Jr = lt.Assign;
lt.After;
lt.DoneState;
var os = lt.Log, Dc = lt.Init, Qr = lt.Invoke;
lt.ErrorExecution;
var Xi = lt.ErrorPlatform, kc = lt.ErrorCustom, ss = lt.Update, Lc = lt.Choose, $c = lt.Pure, as = ".", Yi = {}, ti = "xstate.guard", Mc = "", Fn;
function yi(t, e, n) {
  n === void 0 && (n = as);
  var r = wn(t, n), i = wn(e, n);
  return st(i) ? st(r) ? i === r : !1 : st(r) ? r in i : Object.keys(r).every(function(o) {
    return o in i ? yi(r[o], i[o]) : !1;
  });
}
function cs(t) {
  try {
    return st(t) || typeof t == "number" ? "".concat(t) : t.type;
  } catch {
    throw new Error("Events must be strings or objects with a string event.type property.");
  }
}
function ei(t, e) {
  try {
    return Qe(t) ? t : t.toString().split(e);
  } catch {
    throw new Error("'".concat(t, "' is not a valid state path."));
  }
}
function Hc(t) {
  return typeof t == "object" && "value" in t && "context" in t && "event" in t && "_event" in t;
}
function wn(t, e) {
  if (Hc(t))
    return t.value;
  if (Qe(t))
    return sr(t);
  if (typeof t != "string")
    return t;
  var n = ei(t, e);
  return sr(n);
}
function sr(t) {
  if (t.length === 1)
    return t[0];
  for (var e = {}, n = e, r = 0; r < t.length - 1; r++)
    r === t.length - 2 ? n[t[r]] = t[r + 1] : (n[t[r]] = {}, n = n[t[r]]);
  return e;
}
function mn(t, e) {
  for (var n = {}, r = Object.keys(t), i = 0; i < r.length; i++) {
    var o = r[i];
    n[o] = e(t[o], o, t, i);
  }
  return n;
}
function Zi(t, e, n) {
  var r, i, o = {};
  try {
    for (var s = it(Object.keys(t)), a = s.next(); !a.done; a = s.next()) {
      var c = a.value, u = t[c];
      n(u) && (o[c] = e(u, c, t));
    }
  } catch (p) {
    r = {
      error: p
    };
  } finally {
    try {
      a && !a.done && (i = s.return) && i.call(s);
    } finally {
      if (r) throw r.error;
    }
  }
  return o;
}
var jc = function(t) {
  return function(e) {
    var n, r, i = e;
    try {
      for (var o = it(t), s = o.next(); !s.done; s = o.next()) {
        var a = s.value;
        i = i[a];
      }
    } catch (c) {
      n = {
        error: c
      };
    } finally {
      try {
        s && !s.done && (r = o.return) && r.call(o);
      } finally {
        if (n) throw n.error;
      }
    }
    return i;
  };
};
function Uc(t, e) {
  return function(n) {
    var r, i, o = n;
    try {
      for (var s = it(t), a = s.next(); !a.done; a = s.next()) {
        var c = a.value;
        o = o[e][c];
      }
    } catch (u) {
      r = {
        error: u
      };
    } finally {
      try {
        a && !a.done && (i = s.return) && i.call(s);
      } finally {
        if (r) throw r.error;
      }
    }
    return o;
  };
}
function Qn(t) {
  if (!t)
    return [[]];
  if (st(t))
    return [[t]];
  var e = vt(Object.keys(t).map(function(n) {
    var r = t[n];
    return typeof r != "string" && (!r || !Object.keys(r).length) ? [[n]] : Qn(t[n]).map(function(i) {
      return [n].concat(i);
    });
  }));
  return e;
}
function vt(t) {
  var e;
  return (e = []).concat.apply(e, Et([], ct(t), !1));
}
function ls(t) {
  return Qe(t) ? t : [t];
}
function qt(t) {
  return t === void 0 ? [] : ls(t);
}
function ar(t, e, n) {
  var r, i;
  if (ft(t))
    return t(e, n.data);
  var o = {};
  try {
    for (var s = it(Object.keys(t)), a = s.next(); !a.done; a = s.next()) {
      var c = a.value, u = t[c];
      ft(u) ? o[c] = u(e, n.data) : o[c] = u;
    }
  } catch (p) {
    r = {
      error: p
    };
  } finally {
    try {
      a && !a.done && (i = s.return) && i.call(s);
    } finally {
      if (r) throw r.error;
    }
  }
  return o;
}
function Fc(t) {
  return /^(done|error)\./.test(t);
}
function Ji(t) {
  return !!(t instanceof Promise || t !== null && (ft(t) || typeof t == "object") && ft(t.then));
}
function Bc(t) {
  return t !== null && typeof t == "object" && "transition" in t && typeof t.transition == "function";
}
function us(t, e) {
  var n, r, i = ct([[], []], 2), o = i[0], s = i[1];
  try {
    for (var a = it(t), c = a.next(); !c.done; c = a.next()) {
      var u = c.value;
      e(u) ? o.push(u) : s.push(u);
    }
  } catch (p) {
    n = {
      error: p
    };
  } finally {
    try {
      c && !c.done && (r = a.return) && r.call(a);
    } finally {
      if (n) throw n.error;
    }
  }
  return [o, s];
}
function fs(t, e) {
  return mn(t.states, function(n, r) {
    if (n) {
      var i = (st(e) ? void 0 : e[r]) || (n ? n.current : void 0);
      if (i)
        return {
          current: i,
          states: fs(n, i)
        };
    }
  });
}
function zc(t, e) {
  return {
    current: e,
    states: fs(t, e)
  };
}
function Qi(t, e, n, r) {
  var i = t && n.reduce(function(o, s) {
    var a, c, u = s.assignment, p = {
      state: r,
      action: s,
      _event: e
    }, f = {};
    if (ft(u))
      f = u(o, e.data, p);
    else
      try {
        for (var l = it(Object.keys(u)), d = l.next(); !d.done; d = l.next()) {
          var h = d.value, v = u[h];
          f[h] = ft(v) ? v(o, e.data, p) : v;
        }
      } catch (m) {
        a = {
          error: m
        };
      } finally {
        try {
          d && !d.done && (c = l.return) && c.call(l);
        } finally {
          if (a) throw a.error;
        }
      }
    return Object.assign({}, o, f);
  }, t);
  return i;
}
var qc = function() {
};
function Qe(t) {
  return Array.isArray(t);
}
function ft(t) {
  return typeof t == "function";
}
function st(t) {
  return typeof t == "string";
}
function ds(t, e) {
  if (t)
    return st(t) ? {
      type: ti,
      name: t,
      predicate: e ? e[t] : void 0
    } : ft(t) ? {
      type: ti,
      name: t.name,
      predicate: t
    } : t;
}
function Wc(t) {
  try {
    return "subscribe" in t && ft(t.subscribe);
  } catch {
    return !1;
  }
}
var Ee = /* @__PURE__ */ (function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
})();
Fn = {}, Fn[Ee] = function() {
  return this;
}, Fn[Symbol.observable] = function() {
  return this;
};
function Ge(t) {
  return !!t && "__xstatenode" in t;
}
function Vc(t) {
  return !!t && typeof t.send == "function";
}
var Gc = /* @__PURE__ */ (function() {
  var t = 0;
  return function() {
    return t++, t.toString(16);
  };
})();
function mi(t, e) {
  return st(t) || typeof t == "number" ? H({
    type: t
  }, e) : t;
}
function At(t, e) {
  if (!st(t) && "$$type" in t && t.$$type === "scxml")
    return t;
  var n = mi(t);
  return H({
    name: n.type,
    data: n,
    $$type: "scxml",
    type: "external"
  }, e);
}
function Me(t, e) {
  var n = ls(e).map(function(r) {
    return typeof r > "u" || typeof r == "string" || Ge(r) ? {
      target: r,
      event: t
    } : H(H({}, r), {
      event: t
    });
  });
  return n;
}
function Kc(t) {
  if (!(t === void 0 || t === Mc))
    return qt(t);
}
function ps(t, e, n, r, i) {
  var o = t.options.guards, s = {
    state: i,
    cond: e,
    _event: r
  };
  if (e.type === ti)
    return (o?.[e.name] || e.predicate)(n, r.data, s);
  var a = o?.[e.type];
  if (!a)
    throw new Error("Guard '".concat(e.type, "' is not implemented on machine '").concat(t.id, "'."));
  return a(n, r.data, s);
}
function hs(t) {
  return typeof t == "string" ? {
    type: t
  } : t;
}
function ni(t, e, n) {
  if (typeof t == "object")
    return t;
  var r = function() {
  };
  return {
    next: t,
    error: e || r,
    complete: n || r
  };
}
function Bn(t, e) {
  return "".concat(t, ":invocation[").concat(e, "]");
}
var cr = /* @__PURE__ */ At({
  type: Dc
});
function ri(t, e) {
  return e && e[t] || void 0;
}
function Rn(t, e) {
  var n;
  if (st(t) || typeof t == "number") {
    var r = ri(t, e);
    ft(r) ? n = {
      type: t,
      exec: r
    } : r ? n = r : n = {
      type: t,
      exec: void 0
    };
  } else if (ft(t))
    n = {
      // Convert action to string if unnamed
      type: t.name || t.toString(),
      exec: t
    };
  else {
    var r = ri(t.type, e);
    if (ft(r))
      n = H(H({}, t), {
        exec: r
      });
    else if (r) {
      var i = r.type || t.type;
      n = H(H(H({}, r), t), {
        type: i
      });
    } else
      n = t;
  }
  return n;
}
var lr = function(t, e) {
  if (!t)
    return [];
  var n = Qe(t) ? t : [t];
  return n.map(function(r) {
    return Rn(r, e);
  });
};
function Ei(t) {
  var e = Rn(t);
  return H(H({
    id: st(t) ? t : e.id
  }, e), {
    type: e.type
  });
}
function gs(t) {
  return st(t) ? {
    type: wr,
    event: t
  } : Nn(t, {
    to: Ve.Internal
  });
}
function Xc(t) {
  return {
    type: wr,
    _event: At(t.event)
  };
}
function Nn(t, e) {
  return {
    to: e ? e.to : void 0,
    type: _r,
    event: ft(t) ? t : mi(t),
    delay: e ? e.delay : void 0,
    id: e && e.id !== void 0 ? e.id : ft(t) ? t.name : cs(t)
  };
}
function Yc(t, e, n, r) {
  var i = {
    _event: n
  }, o = At(ft(t.event) ? t.event(e, n.data, i) : t.event), s;
  if (st(t.delay)) {
    var a = r && r[t.delay];
    s = ft(a) ? a(e, n.data, i) : a;
  } else
    s = ft(t.delay) ? t.delay(e, n.data, i) : t.delay;
  var c = ft(t.to) ? t.to(e, n.data, i) : t.to;
  return H(H({}, t), {
    to: c,
    _event: o,
    event: o.data,
    delay: s
  });
}
function Zc(t, e) {
  return Nn(t, H(H({}, e), {
    to: Ve.Parent
  }));
}
var Jc = function(t, e, n) {
  return H(H({}, t), {
    value: st(t.expr) ? t.expr : t.expr(e, n.data, {
      _event: n
    })
  });
}, Qc = function(t) {
  return {
    type: is,
    sendId: t
  };
};
function tl(t) {
  var e = Ei(t);
  return {
    type: lt.Start,
    activity: e,
    exec: void 0
  };
}
function el(t) {
  var e = ft(t) ? t : Ei(t);
  return {
    type: lt.Stop,
    activity: e,
    exec: void 0
  };
}
function nl(t, e, n) {
  var r = ft(t.activity) ? t.activity(e, n.data) : t.activity, i = typeof r == "string" ? {
    id: r
  } : r, o = {
    type: lt.Stop,
    activity: i
  };
  return o;
}
var rl = function(t) {
  return {
    type: Jr,
    assignment: t
  };
};
function il(t, e) {
  var n = e ? "#".concat(e) : "";
  return "".concat(lt.After, "(").concat(t, ")").concat(n);
}
function zn(t, e) {
  var n = "".concat(lt.DoneState, ".").concat(t), r = {
    type: n,
    data: e
  };
  return r.toString = function() {
    return n;
  }, r;
}
function tr(t, e) {
  var n = "".concat(lt.DoneInvoke, ".").concat(t), r = {
    type: n,
    data: e
  };
  return r.toString = function() {
    return n;
  }, r;
}
function En(t, e) {
  var n = "".concat(lt.ErrorPlatform, ".").concat(t), r = {
    type: n,
    data: e
  };
  return r.toString = function() {
    return n;
  }, r;
}
function ol(t) {
  return {
    type: lt.Pure,
    get: t
  };
}
function sl(t, e) {
  return Nn(function(n, r) {
    return r;
  }, H(H({}, e), {
    to: t
  }));
}
function vs(t) {
  return {
    type: lt.Choose,
    conds: t
  };
}
function ii(t, e, n, r, i, o) {
  o === void 0 && (o = !1);
  var s = ct(o ? [[], i] : us(i, function(l) {
    return l.type === Jr;
  }), 2), a = s[0], c = s[1], u = a.length ? Qi(n, r, a, e) : n, p = o ? [n] : void 0, f = vt(c.map(function(l) {
    var d;
    switch (l.type) {
      case wr:
        return Xc(l);
      case _r:
        var h = Yc(l, u, r, t.options.delays);
        return h;
      case os:
        return Jc(l, u, r);
      case Lc: {
        var v = l, m = (d = v.conds.find(function(D) {
          var L = ds(D.cond, t.options.guards);
          return !L || ps(t, L, u, r, e);
        })) === null || d === void 0 ? void 0 : d.actions;
        if (!m)
          return [];
        var S = ct(ii(t, e, u, r, lr(qt(m), t.options.actions), o), 2), y = S[0], x = S[1];
        return u = x, p?.push(u), y;
      }
      case $c: {
        var m = l.get(u, r.data);
        if (!m)
          return [];
        var T = ct(ii(t, e, u, r, lr(qt(m), t.options.actions), o), 2), b = T[0], A = T[1];
        return u = A, p?.push(u), b;
      }
      case vi:
        return nl(l, u, r);
      case Jr: {
        u = Qi(u, r, [l], e), p?.push(u);
        break;
      }
      default:
        var R = Rn(l, t.options.actions), O = R.exec;
        if (O && p) {
          var P = p.length - 1;
          R = H(H({}, R), {
            exec: function(D) {
              for (var L = [], $ = 1; $ < arguments.length; $++)
                L[$ - 1] = arguments[$];
              O.apply(void 0, Et([p[P]], ct(L), !1));
            }
          });
        }
        return R;
    }
  }).filter(function(l) {
    return !!l;
  }));
  return [f, u];
}
var ur = [], Sn = function(t, e) {
  ur.push(t);
  var n = e(t);
  return ur.pop(), n;
}, al = function(t) {
  return t(ur[ur.length - 1]);
};
function ys(t) {
  var e;
  return e = {
    id: t,
    send: function() {
    },
    subscribe: function() {
      return {
        unsubscribe: function() {
        }
      };
    },
    getSnapshot: function() {
    },
    toJSON: function() {
      return {
        id: t
      };
    }
  }, e[Ee] = function() {
    return this;
  }, e;
}
function cl(t, e, n, r) {
  var i, o = hs(t.src), s = (i = e?.options.services) === null || i === void 0 ? void 0 : i[o.type], a = t.data ? ar(t.data, n, r) : void 0, c = s ? ms(s, t.id, a) : ys(t.id);
  return c.meta = t, c;
}
function ms(t, e, n) {
  var r = ys(e);
  if (r.deferred = !0, Ge(t)) {
    var i = r.state = Sn(void 0, function() {
      return (n ? t.withContext(n) : t).initialState;
    });
    r.getSnapshot = function() {
      return i;
    };
  }
  return r;
}
function ll(t) {
  try {
    return typeof t.send == "function";
  } catch {
    return !1;
  }
}
function ul(t) {
  return ll(t) && "id" in t;
}
function fl(t) {
  var e;
  return H((e = {
    subscribe: function() {
      return {
        unsubscribe: function() {
        }
      };
    },
    id: "anonymous",
    getSnapshot: function() {
    }
  }, e[Ee] = function() {
    return this;
  }, e), t);
}
var fr = function(t) {
  return t.type === "atomic" || t.type === "final";
};
function Ke(t) {
  return Object.keys(t.states).map(function(e) {
    return t.states[e];
  }).filter(function(e) {
    return e.type !== "history";
  });
}
function Es(t) {
  var e = [t];
  return fr(t) ? e : e.concat(vt(Ke(t).map(Es)));
}
function Fe(t, e) {
  var n, r, i, o, s, a, c, u, p = new Set(t), f = oi(p), l = new Set(e);
  try {
    for (var d = it(l), h = d.next(); !h.done; h = d.next())
      for (var v = h.value, m = v.parent; m && !l.has(m); )
        l.add(m), m = m.parent;
  } catch (P) {
    n = {
      error: P
    };
  } finally {
    try {
      h && !h.done && (r = d.return) && r.call(d);
    } finally {
      if (n) throw n.error;
    }
  }
  var S = oi(l);
  try {
    for (var y = it(l), x = y.next(); !x.done; x = y.next()) {
      var v = x.value;
      if (v.type === "compound" && (!S.get(v) || !S.get(v).length))
        f.get(v) ? f.get(v).forEach(function(D) {
          return l.add(D);
        }) : v.initialStateNodes.forEach(function(D) {
          return l.add(D);
        });
      else if (v.type === "parallel")
        try {
          for (var T = (s = void 0, it(Ke(v))), b = T.next(); !b.done; b = T.next()) {
            var A = b.value;
            l.has(A) || (l.add(A), f.get(A) ? f.get(A).forEach(function(D) {
              return l.add(D);
            }) : A.initialStateNodes.forEach(function(D) {
              return l.add(D);
            }));
          }
        } catch (D) {
          s = {
            error: D
          };
        } finally {
          try {
            b && !b.done && (a = T.return) && a.call(T);
          } finally {
            if (s) throw s.error;
          }
        }
    }
  } catch (P) {
    i = {
      error: P
    };
  } finally {
    try {
      x && !x.done && (o = y.return) && o.call(y);
    } finally {
      if (i) throw i.error;
    }
  }
  try {
    for (var R = it(l), O = R.next(); !O.done; O = R.next())
      for (var v = O.value, m = v.parent; m && !l.has(m); )
        l.add(m), m = m.parent;
  } catch (P) {
    c = {
      error: P
    };
  } finally {
    try {
      O && !O.done && (u = R.return) && u.call(R);
    } finally {
      if (c) throw c.error;
    }
  }
  return l;
}
function Ss(t, e) {
  var n = e.get(t);
  if (!n)
    return {};
  if (t.type === "compound") {
    var r = n[0];
    if (r) {
      if (fr(r))
        return r.key;
    } else
      return {};
  }
  var i = {};
  return n.forEach(function(o) {
    i[o.key] = Ss(o, e);
  }), i;
}
function oi(t) {
  var e, n, r = /* @__PURE__ */ new Map();
  try {
    for (var i = it(t), o = i.next(); !o.done; o = i.next()) {
      var s = o.value;
      r.has(s) || r.set(s, []), s.parent && (r.has(s.parent) || r.set(s.parent, []), r.get(s.parent).push(s));
    }
  } catch (a) {
    e = {
      error: a
    };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return r;
}
function dl(t, e) {
  var n = Fe([t], e);
  return Ss(t, oi(n));
}
function er(t, e) {
  return Array.isArray(t) ? t.some(function(n) {
    return n === e;
  }) : t instanceof Set ? t.has(e) : !1;
}
function pl(t) {
  return Et([], ct(new Set(vt(Et([], ct(t.map(function(e) {
    return e.ownEvents;
  })), !1)))), !1);
}
function _n(t, e) {
  return e.type === "compound" ? Ke(e).some(function(n) {
    return n.type === "final" && er(t, n);
  }) : e.type === "parallel" ? Ke(e).every(function(n) {
    return _n(t, n);
  }) : !1;
}
function hl(t) {
  return t === void 0 && (t = []), t.reduce(function(e, n) {
    return n.meta !== void 0 && (e[n.id] = n.meta), e;
  }, {});
}
function to(t) {
  return new Set(vt(t.map(function(e) {
    return e.tags;
  })));
}
function bs(t, e) {
  if (t === e)
    return !0;
  if (t === void 0 || e === void 0)
    return !1;
  if (st(t) || st(e))
    return t === e;
  var n = Object.keys(t), r = Object.keys(e);
  return n.length === r.length && n.every(function(i) {
    return bs(t[i], e[i]);
  });
}
function gl(t) {
  return typeof t != "object" || t === null ? !1 : "value" in t && "_event" in t;
}
function vl(t, e) {
  var n = t.exec, r = H(H({}, t), {
    exec: n !== void 0 ? function() {
      return n(e.context, e.event, {
        action: t,
        state: e,
        _event: e._event
      });
    } : void 0
  });
  return r;
}
var ne = (
  /** @class */
  /* @__PURE__ */ (function() {
    function t(e) {
      var n = this, r;
      this.actions = [], this.activities = Yi, this.meta = {}, this.events = [], this.value = e.value, this.context = e.context, this._event = e._event, this._sessionid = e._sessionid, this.event = this._event.data, this.historyValue = e.historyValue, this.history = e.history, this.actions = e.actions || [], this.activities = e.activities || Yi, this.meta = hl(e.configuration), this.events = e.events || [], this.matches = this.matches.bind(this), this.toStrings = this.toStrings.bind(this), this.configuration = e.configuration, this.transitions = e.transitions, this.children = e.children, this.done = !!e.done, this.tags = (r = Array.isArray(e.tags) ? new Set(e.tags) : e.tags) !== null && r !== void 0 ? r : /* @__PURE__ */ new Set(), this.machine = e.machine, Object.defineProperty(this, "nextEvents", {
        get: function() {
          return pl(n.configuration);
        }
      });
    }
    return t.from = function(e, n) {
      if (e instanceof t)
        return e.context !== n ? new t({
          value: e.value,
          context: n,
          _event: e._event,
          _sessionid: null,
          historyValue: e.historyValue,
          history: e.history,
          actions: [],
          activities: e.activities,
          events: [],
          configuration: [],
          transitions: [],
          children: {}
        }) : e;
      var r = cr;
      return new t({
        value: e,
        context: n,
        _event: r,
        _sessionid: null,
        historyValue: void 0,
        history: void 0,
        actions: [],
        activities: void 0,
        events: [],
        configuration: [],
        transitions: [],
        children: {}
      });
    }, t.create = function(e) {
      return new t(e);
    }, t.inert = function(e, n) {
      if (e instanceof t) {
        if (!e.actions.length)
          return e;
        var r = cr;
        return new t({
          value: e.value,
          context: n,
          _event: r,
          _sessionid: null,
          historyValue: e.historyValue,
          history: e.history,
          activities: e.activities,
          configuration: e.configuration,
          transitions: [],
          children: {}
        });
      }
      return t.from(e, n);
    }, t.prototype.toStrings = function(e, n) {
      var r = this;
      if (e === void 0 && (e = this.value), n === void 0 && (n = "."), st(e))
        return [e];
      var i = Object.keys(e);
      return i.concat.apply(i, Et([], ct(i.map(function(o) {
        return r.toStrings(e[o], n).map(function(s) {
          return o + n + s;
        });
      })), !1));
    }, t.prototype.toJSON = function() {
      var e = this;
      e.configuration, e.transitions;
      var n = e.tags;
      e.machine;
      var r = gi(e, ["configuration", "transitions", "tags", "machine"]);
      return H(H({}, r), {
        tags: Array.from(n)
      });
    }, t.prototype.matches = function(e) {
      return yi(e, this.value);
    }, t.prototype.hasTag = function(e) {
      return this.tags.has(e);
    }, t.prototype.can = function(e) {
      var n;
      qc(!!this.machine);
      var r = (n = this.machine) === null || n === void 0 ? void 0 : n.getTransitionData(this, e);
      return !!r?.transitions.length && // Check that at least one transition is not forbidden
      r.transitions.some(function(i) {
        return i.target !== void 0 || i.actions.length;
      });
    }, t;
  })()
), yl = {
  deferEvents: !1
}, eo = (
  /** @class */
  /* @__PURE__ */ (function() {
    function t(e) {
      this.processingEvent = !1, this.queue = [], this.initialized = !1, this.options = H(H({}, yl), e);
    }
    return t.prototype.initialize = function(e) {
      if (this.initialized = !0, e) {
        if (!this.options.deferEvents) {
          this.schedule(e);
          return;
        }
        this.process(e);
      }
      this.flushEvents();
    }, t.prototype.schedule = function(e) {
      if (!this.initialized || this.processingEvent) {
        this.queue.push(e);
        return;
      }
      if (this.queue.length !== 0)
        throw new Error("Event queue should be empty when it is not processing events");
      this.process(e), this.flushEvents();
    }, t.prototype.clear = function() {
      this.queue = [];
    }, t.prototype.flushEvents = function() {
      for (var e = this.queue.shift(); e; )
        this.process(e), e = this.queue.shift();
    }, t.prototype.process = function(e) {
      this.processingEvent = !0;
      try {
        e();
      } catch (n) {
        throw this.clear(), n;
      } finally {
        this.processingEvent = !1;
      }
    }, t;
  })()
), $r = /* @__PURE__ */ new Map(), ml = 0, qn = {
  bookId: function() {
    return "x:".concat(ml++);
  },
  register: function(t, e) {
    return $r.set(t, e), t;
  },
  get: function(t) {
    return $r.get(t);
  },
  free: function(t) {
    $r.delete(t);
  }
};
function Si() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
}
function El() {
  var t = Si();
  if (t && "__xstate__" in t)
    return t.__xstate__;
}
function Sl(t) {
  if (Si()) {
    var e = El();
    e && e.register(t);
  }
}
function bl(t, e) {
  e === void 0 && (e = {});
  var n = t.initialState, r = /* @__PURE__ */ new Set(), i = [], o = !1, s = function() {
    if (!o) {
      for (o = !0; i.length > 0; ) {
        var u = i.shift();
        n = t.transition(n, u, c), r.forEach(function(p) {
          return p.next(n);
        });
      }
      o = !1;
    }
  }, a = fl({
    id: e.id,
    send: function(u) {
      i.push(u), s();
    },
    getSnapshot: function() {
      return n;
    },
    subscribe: function(u, p, f) {
      var l = ni(u, p, f);
      return r.add(l), l.next(n), {
        unsubscribe: function() {
          r.delete(l);
        }
      };
    }
  }), c = {
    parent: e.parent,
    self: a,
    id: e.id || "anonymous",
    observers: r
  };
  return n = t.start ? t.start(c) : n, a;
}
var si = {
  sync: !1,
  autoForward: !1
}, Pt;
(function(t) {
  t[t.NotStarted = 0] = "NotStarted", t[t.Running = 1] = "Running", t[t.Stopped = 2] = "Stopped";
})(Pt || (Pt = {}));
var xl = (
  /** @class */
  /* @__PURE__ */ (function() {
    function t(e, n) {
      var r = this;
      n === void 0 && (n = t.defaultOptions), this.machine = e, this.delayedEventsMap = {}, this.listeners = /* @__PURE__ */ new Set(), this.contextListeners = /* @__PURE__ */ new Set(), this.stopListeners = /* @__PURE__ */ new Set(), this.doneListeners = /* @__PURE__ */ new Set(), this.eventListeners = /* @__PURE__ */ new Set(), this.sendListeners = /* @__PURE__ */ new Set(), this.initialized = !1, this.status = Pt.NotStarted, this.children = /* @__PURE__ */ new Map(), this.forwardTo = /* @__PURE__ */ new Set(), this.init = this.start, this.send = function(p, f) {
        if (Qe(p))
          return r.batch(p), r.state;
        var l = At(mi(p, f));
        if (r.status === Pt.Stopped)
          return r.state;
        if (r.status !== Pt.Running && !r.options.deferEvents)
          throw new Error('Event "'.concat(l.name, '" was sent to uninitialized service "').concat(
            r.machine.id,
            `". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.
Event: `
          ).concat(JSON.stringify(l.data)));
        return r.scheduler.schedule(function() {
          r.forward(l);
          var d = r.nextState(l);
          r.update(d, l);
        }), r._state;
      }, this.sendTo = function(p, f) {
        var l = r.parent && (f === Ve.Parent || r.parent.id === f), d = l ? r.parent : st(f) ? r.children.get(f) || qn.get(f) : Vc(f) ? f : void 0;
        if (!d) {
          if (!l)
            throw new Error("Unable to send event to child '".concat(f, "' from service '").concat(r.id, "'."));
          return;
        }
        "machine" in d ? d.send(H(H({}, p), {
          name: p.name === kc ? "".concat(En(r.id)) : p.name,
          origin: r.sessionId
        })) : d.send(p.data);
      };
      var i = H(H({}, t.defaultOptions), n), o = i.clock, s = i.logger, a = i.parent, c = i.id, u = c !== void 0 ? c : e.id;
      this.id = u, this.logger = s, this.clock = o, this.parent = a, this.options = i, this.scheduler = new eo({
        deferEvents: this.options.deferEvents
      }), this.sessionId = qn.bookId();
    }
    return Object.defineProperty(t.prototype, "initialState", {
      get: function() {
        var e = this;
        return this._initialState ? this._initialState : Sn(this, function() {
          return e._initialState = e.machine.initialState, e._initialState;
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "state", {
      get: function() {
        return this._state;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.execute = function(e, n) {
      var r, i;
      try {
        for (var o = it(e.actions), s = o.next(); !s.done; s = o.next()) {
          var a = s.value;
          this.exec(a, e, n);
        }
      } catch (c) {
        r = {
          error: c
        };
      } finally {
        try {
          s && !s.done && (i = o.return) && i.call(o);
        } finally {
          if (r) throw r.error;
        }
      }
    }, t.prototype.update = function(e, n) {
      var r, i, o, s, a, c, u, p, f = this;
      if (e._sessionid = this.sessionId, this._state = e, this.options.execute && this.execute(this.state), this.children.forEach(function(P) {
        f.state.children[P.id] = P;
      }), this.devTools && this.devTools.send(n.data, e), e.event)
        try {
          for (var l = it(this.eventListeners), d = l.next(); !d.done; d = l.next()) {
            var h = d.value;
            h(e.event);
          }
        } catch (P) {
          r = {
            error: P
          };
        } finally {
          try {
            d && !d.done && (i = l.return) && i.call(l);
          } finally {
            if (r) throw r.error;
          }
        }
      try {
        for (var v = it(this.listeners), m = v.next(); !m.done; m = v.next()) {
          var h = m.value;
          h(e, e.event);
        }
      } catch (P) {
        o = {
          error: P
        };
      } finally {
        try {
          m && !m.done && (s = v.return) && s.call(v);
        } finally {
          if (o) throw o.error;
        }
      }
      try {
        for (var S = it(this.contextListeners), y = S.next(); !y.done; y = S.next()) {
          var x = y.value;
          x(this.state.context, this.state.history ? this.state.history.context : void 0);
        }
      } catch (P) {
        a = {
          error: P
        };
      } finally {
        try {
          y && !y.done && (c = S.return) && c.call(S);
        } finally {
          if (a) throw a.error;
        }
      }
      var T = _n(e.configuration || [], this.machine);
      if (this.state.configuration && T) {
        var b = e.configuration.find(function(P) {
          return P.type === "final" && P.parent === f.machine;
        }), A = b && b.doneData ? ar(b.doneData, e.context, n) : void 0;
        try {
          for (var R = it(this.doneListeners), O = R.next(); !O.done; O = R.next()) {
            var h = O.value;
            h(tr(this.id, A));
          }
        } catch (P) {
          u = {
            error: P
          };
        } finally {
          try {
            O && !O.done && (p = R.return) && p.call(R);
          } finally {
            if (u) throw u.error;
          }
        }
        this.stop();
      }
    }, t.prototype.onTransition = function(e) {
      return this.listeners.add(e), this.status === Pt.Running && e(this.state, this.state.event), this;
    }, t.prototype.subscribe = function(e, n, r) {
      var i = this;
      if (!e)
        return {
          unsubscribe: function() {
          }
        };
      var o, s = r;
      return typeof e == "function" ? o = e : (o = e.next.bind(e), s = e.complete.bind(e)), this.listeners.add(o), this.status !== Pt.NotStarted && o(this.state), s && (this.status === Pt.Stopped ? s() : this.onDone(s)), {
        unsubscribe: function() {
          o && i.listeners.delete(o), s && i.doneListeners.delete(s);
        }
      };
    }, t.prototype.onEvent = function(e) {
      return this.eventListeners.add(e), this;
    }, t.prototype.onSend = function(e) {
      return this.sendListeners.add(e), this;
    }, t.prototype.onChange = function(e) {
      return this.contextListeners.add(e), this;
    }, t.prototype.onStop = function(e) {
      return this.stopListeners.add(e), this;
    }, t.prototype.onDone = function(e) {
      return this.doneListeners.add(e), this;
    }, t.prototype.off = function(e) {
      return this.listeners.delete(e), this.eventListeners.delete(e), this.sendListeners.delete(e), this.stopListeners.delete(e), this.doneListeners.delete(e), this.contextListeners.delete(e), this;
    }, t.prototype.start = function(e) {
      var n = this;
      if (this.status === Pt.Running)
        return this;
      this.machine._init(), qn.register(this.sessionId, this), this.initialized = !0, this.status = Pt.Running;
      var r = e === void 0 ? this.initialState : Sn(this, function() {
        return gl(e) ? n.machine.resolveState(e) : n.machine.resolveState(ne.from(e, n.machine.context));
      });
      return this.options.devTools && this.attachDev(), this.scheduler.initialize(function() {
        n.update(r, cr);
      }), this;
    }, t.prototype.stop = function() {
      var e, n, r, i, o, s, a, c, u, p, f = this;
      try {
        for (var l = it(this.listeners), d = l.next(); !d.done; d = l.next()) {
          var h = d.value;
          this.listeners.delete(h);
        }
      } catch (O) {
        e = {
          error: O
        };
      } finally {
        try {
          d && !d.done && (n = l.return) && n.call(l);
        } finally {
          if (e) throw e.error;
        }
      }
      try {
        for (var v = it(this.stopListeners), m = v.next(); !m.done; m = v.next()) {
          var h = m.value;
          h(), this.stopListeners.delete(h);
        }
      } catch (O) {
        r = {
          error: O
        };
      } finally {
        try {
          m && !m.done && (i = v.return) && i.call(v);
        } finally {
          if (r) throw r.error;
        }
      }
      try {
        for (var S = it(this.contextListeners), y = S.next(); !y.done; y = S.next()) {
          var h = y.value;
          this.contextListeners.delete(h);
        }
      } catch (O) {
        o = {
          error: O
        };
      } finally {
        try {
          y && !y.done && (s = S.return) && s.call(S);
        } finally {
          if (o) throw o.error;
        }
      }
      try {
        for (var x = it(this.doneListeners), T = x.next(); !T.done; T = x.next()) {
          var h = T.value;
          this.doneListeners.delete(h);
        }
      } catch (O) {
        a = {
          error: O
        };
      } finally {
        try {
          T && !T.done && (c = x.return) && c.call(x);
        } finally {
          if (a) throw a.error;
        }
      }
      if (!this.initialized)
        return this;
      Et([], ct(this.state.configuration), !1).sort(function(O, P) {
        return P.order - O.order;
      }).forEach(function(O) {
        var P, D;
        try {
          for (var L = it(O.definition.exit), $ = L.next(); !$.done; $ = L.next()) {
            var q = $.value;
            f.exec(q, f.state);
          }
        } catch (Y) {
          P = {
            error: Y
          };
        } finally {
          try {
            $ && !$.done && (D = L.return) && D.call(L);
          } finally {
            if (P) throw P.error;
          }
        }
      }), this.children.forEach(function(O) {
        ft(O.stop) && O.stop();
      }), this.children.clear();
      try {
        for (var b = it(Object.keys(this.delayedEventsMap)), A = b.next(); !A.done; A = b.next()) {
          var R = A.value;
          this.clock.clearTimeout(this.delayedEventsMap[R]);
        }
      } catch (O) {
        u = {
          error: O
        };
      } finally {
        try {
          A && !A.done && (p = b.return) && p.call(b);
        } finally {
          if (u) throw u.error;
        }
      }
      return this.scheduler.clear(), this.scheduler = new eo({
        deferEvents: this.options.deferEvents
      }), this.initialized = !1, this.status = Pt.Stopped, this._initialState = void 0, qn.free(this.sessionId), this;
    }, t.prototype.batch = function(e) {
      var n = this;
      if (!(this.status === Pt.NotStarted && this.options.deferEvents)) {
        if (this.status !== Pt.Running)
          throw new Error(
            // tslint:disable-next-line:max-line-length
            "".concat(e.length, ' event(s) were sent to uninitialized service "').concat(this.machine.id, '". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.')
          );
      }
      this.scheduler.schedule(function() {
        var r, i, o = n.state, s = !1, a = [], c = function(l) {
          var d = At(l);
          n.forward(d), o = Sn(n, function() {
            return n.machine.transition(o, d);
          }), a.push.apply(a, Et([], ct(o.actions.map(function(h) {
            return vl(h, o);
          })), !1)), s = s || !!o.changed;
        };
        try {
          for (var u = it(e), p = u.next(); !p.done; p = u.next()) {
            var f = p.value;
            c(f);
          }
        } catch (l) {
          r = {
            error: l
          };
        } finally {
          try {
            p && !p.done && (i = u.return) && i.call(u);
          } finally {
            if (r) throw r.error;
          }
        }
        o.changed = s, o.actions = a, n.update(o, At(e[e.length - 1]));
      });
    }, t.prototype.sender = function(e) {
      return this.send.bind(this, e);
    }, t.prototype.nextState = function(e) {
      var n = this, r = At(e);
      if (r.name.indexOf(Xi) === 0 && !this.state.nextEvents.some(function(o) {
        return o.indexOf(Xi) === 0;
      }))
        throw r.data.data;
      var i = Sn(this, function() {
        return n.machine.transition(n.state, r);
      });
      return i;
    }, t.prototype.forward = function(e) {
      var n, r;
      try {
        for (var i = it(this.forwardTo), o = i.next(); !o.done; o = i.next()) {
          var s = o.value, a = this.children.get(s);
          if (!a)
            throw new Error("Unable to forward event '".concat(e, "' from interpreter '").concat(this.id, "' to nonexistant child '").concat(s, "'."));
          a.send(e);
        }
      } catch (c) {
        n = {
          error: c
        };
      } finally {
        try {
          o && !o.done && (r = i.return) && r.call(i);
        } finally {
          if (n) throw n.error;
        }
      }
    }, t.prototype.defer = function(e) {
      var n = this;
      this.delayedEventsMap[e.id] = this.clock.setTimeout(function() {
        e.to ? n.sendTo(e._event, e.to) : n.send(e._event);
      }, e.delay);
    }, t.prototype.cancel = function(e) {
      this.clock.clearTimeout(this.delayedEventsMap[e]), delete this.delayedEventsMap[e];
    }, t.prototype.exec = function(e, n, r) {
      r === void 0 && (r = this.machine.options.actions);
      var i = n.context, o = n._event, s = e.exec || ri(e.type, r), a = ft(s) ? s : s ? s.exec : e.exec;
      if (a)
        try {
          return a(i, o.data, {
            action: e,
            state: this.state,
            _event: o
          });
        } catch (T) {
          throw this.parent && this.parent.send({
            type: "xstate.error",
            data: T
          }), T;
        }
      switch (e.type) {
        case _r:
          var c = e;
          if (typeof c.delay == "number") {
            this.defer(c);
            return;
          } else
            c.to ? this.sendTo(c._event, c.to) : this.send(c._event);
          break;
        case is:
          this.cancel(e.sendId);
          break;
        case Zr: {
          if (this.status !== Pt.Running)
            return;
          var u = e.activity;
          if (!this.state.activities[u.id || u.type])
            break;
          if (u.type === lt.Invoke) {
            var p = hs(u.src), f = this.machine.options.services ? this.machine.options.services[p.type] : void 0, l = u.id, d = u.data, h = "autoForward" in u ? u.autoForward : !!u.forward;
            if (!f)
              return;
            var v = d ? ar(d, i, o) : void 0;
            if (typeof f == "string")
              return;
            var m = ft(f) ? f(i, o.data, {
              data: v,
              src: p,
              meta: u.meta
            }) : f;
            if (!m)
              return;
            var S = void 0;
            Ge(m) && (m = v ? m.withContext(v) : m, S = {
              autoForward: h
            }), this.spawn(m, l, S);
          } else
            this.spawnActivity(u);
          break;
        }
        case vi: {
          this.stopChild(e.activity.id);
          break;
        }
        case os:
          var y = e.label, x = e.value;
          y ? this.logger(y, x) : this.logger(x);
          break;
      }
    }, t.prototype.removeChild = function(e) {
      var n;
      this.children.delete(e), this.forwardTo.delete(e), (n = this.state) === null || n === void 0 || delete n.children[e];
    }, t.prototype.stopChild = function(e) {
      var n = this.children.get(e);
      n && (this.removeChild(e), ft(n.stop) && n.stop());
    }, t.prototype.spawn = function(e, n, r) {
      if (Ji(e))
        return this.spawnPromise(Promise.resolve(e), n);
      if (ft(e))
        return this.spawnCallback(e, n);
      if (ul(e))
        return this.spawnActor(e, n);
      if (Wc(e))
        return this.spawnObservable(e, n);
      if (Ge(e))
        return this.spawnMachine(e, H(H({}, r), {
          id: n
        }));
      if (Bc(e))
        return this.spawnBehavior(e, n);
      throw new Error('Unable to spawn entity "'.concat(n, '" of type "').concat(typeof e, '".'));
    }, t.prototype.spawnMachine = function(e, n) {
      var r = this;
      n === void 0 && (n = {});
      var i = new t(e, H(H({}, this.options), {
        parent: this,
        id: n.id || e.id
      })), o = H(H({}, si), n);
      o.sync && i.onTransition(function(a) {
        r.send(ss, {
          state: a,
          id: i.id
        });
      });
      var s = i;
      return this.children.set(i.id, s), o.autoForward && this.forwardTo.add(i.id), i.onDone(function(a) {
        r.removeChild(i.id), r.send(At(a, {
          origin: i.id
        }));
      }).start(), s;
    }, t.prototype.spawnBehavior = function(e, n) {
      var r = bl(e, {
        id: n,
        parent: this
      });
      return this.children.set(n, r), r;
    }, t.prototype.spawnPromise = function(e, n) {
      var r, i = this, o = !1, s;
      e.then(function(c) {
        o || (s = c, i.removeChild(n), i.send(At(tr(n, c), {
          origin: n
        })));
      }, function(c) {
        if (!o) {
          i.removeChild(n);
          var u = En(n, c);
          try {
            i.send(At(u, {
              origin: n
            }));
          } catch {
            i.devTools && i.devTools.send(u, i.state), i.machine.strict && i.stop();
          }
        }
      });
      var a = (r = {
        id: n,
        send: function() {
        },
        subscribe: function(c, u, p) {
          var f = ni(c, u, p), l = !1;
          return e.then(function(d) {
            l || (f.next(d), !l && f.complete());
          }, function(d) {
            l || f.error(d);
          }), {
            unsubscribe: function() {
              return l = !0;
            }
          };
        },
        stop: function() {
          o = !0;
        },
        toJSON: function() {
          return {
            id: n
          };
        },
        getSnapshot: function() {
          return s;
        }
      }, r[Ee] = function() {
        return this;
      }, r);
      return this.children.set(n, a), a;
    }, t.prototype.spawnCallback = function(e, n) {
      var r, i = this, o = !1, s = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set(), c, u = function(l) {
        c = l, a.forEach(function(d) {
          return d(l);
        }), !o && i.send(At(l, {
          origin: n
        }));
      }, p;
      try {
        p = e(u, function(l) {
          s.add(l);
        });
      } catch (l) {
        this.send(En(n, l));
      }
      if (Ji(p))
        return this.spawnPromise(p, n);
      var f = (r = {
        id: n,
        send: function(l) {
          return s.forEach(function(d) {
            return d(l);
          });
        },
        subscribe: function(l) {
          var d = ni(l);
          return a.add(d.next), {
            unsubscribe: function() {
              a.delete(d.next);
            }
          };
        },
        stop: function() {
          o = !0, ft(p) && p();
        },
        toJSON: function() {
          return {
            id: n
          };
        },
        getSnapshot: function() {
          return c;
        }
      }, r[Ee] = function() {
        return this;
      }, r);
      return this.children.set(n, f), f;
    }, t.prototype.spawnObservable = function(e, n) {
      var r, i = this, o, s = e.subscribe(function(c) {
        o = c, i.send(At(c, {
          origin: n
        }));
      }, function(c) {
        i.removeChild(n), i.send(At(En(n, c), {
          origin: n
        }));
      }, function() {
        i.removeChild(n), i.send(At(tr(n), {
          origin: n
        }));
      }), a = (r = {
        id: n,
        send: function() {
        },
        subscribe: function(c, u, p) {
          return e.subscribe(c, u, p);
        },
        stop: function() {
          return s.unsubscribe();
        },
        getSnapshot: function() {
          return o;
        },
        toJSON: function() {
          return {
            id: n
          };
        }
      }, r[Ee] = function() {
        return this;
      }, r);
      return this.children.set(n, a), a;
    }, t.prototype.spawnActor = function(e, n) {
      return this.children.set(n, e), e;
    }, t.prototype.spawnActivity = function(e) {
      var n = this.machine.options && this.machine.options.activities ? this.machine.options.activities[e.type] : void 0;
      if (n) {
        var r = n(this.state.context, e);
        this.spawnEffect(e.id, r);
      }
    }, t.prototype.spawnEffect = function(e, n) {
      var r;
      this.children.set(e, (r = {
        id: e,
        send: function() {
        },
        subscribe: function() {
          return {
            unsubscribe: function() {
            }
          };
        },
        stop: n || void 0,
        getSnapshot: function() {
        },
        toJSON: function() {
          return {
            id: e
          };
        }
      }, r[Ee] = function() {
        return this;
      }, r));
    }, t.prototype.attachDev = function() {
      var e = Si();
      if (this.options.devTools && e) {
        if (e.__REDUX_DEVTOOLS_EXTENSION__) {
          var n = typeof this.options.devTools == "object" ? this.options.devTools : void 0;
          this.devTools = e.__REDUX_DEVTOOLS_EXTENSION__.connect(H(H({
            name: this.id,
            autoPause: !0,
            stateSanitizer: function(r) {
              return {
                value: r.value,
                context: r.context,
                actions: r.actions
              };
            }
          }, n), {
            features: H({
              jump: !1,
              skip: !1
            }, n ? n.features : void 0)
          }), this.machine), this.devTools.init(this.state);
        }
        Sl(this);
      }
    }, t.prototype.toJSON = function() {
      return {
        id: this.id
      };
    }, t.prototype[Ee] = function() {
      return this;
    }, t.prototype.getSnapshot = function() {
      return this.status === Pt.NotStarted ? this.initialState : this._state;
    }, t.defaultOptions = {
      execute: !0,
      deferEvents: !0,
      clock: {
        setTimeout: function(e, n) {
          return setTimeout(e, n);
        },
        clearTimeout: function(e) {
          return clearTimeout(e);
        }
      },
      logger: /* @__PURE__ */ (() => {
      }).bind(console),
      devTools: !1
    }, t.interpret = ws, t;
  })()
), wl = function(t) {
  return st(t) ? H(H({}, si), {
    name: t
  }) : H(H(H({}, si), {
    name: Gc()
  }), t);
};
function xs(t, e) {
  var n = wl(e);
  return al(function(r) {
    return r ? r.spawn(t, n.name, n) : ms(t, n.name);
  });
}
function ws(t, e) {
  var n = new xl(t, e);
  return n;
}
function _l(t) {
  if (typeof t == "string") {
    var e = {
      type: t
    };
    return e.toString = function() {
      return t;
    }, e;
  }
  return t;
}
function Wn(t) {
  return H(H({
    type: Qr
  }, t), {
    toJSON: function() {
      t.onDone, t.onError;
      var e = gi(t, ["onDone", "onError"]);
      return H(H({}, e), {
        type: Qr,
        src: _l(t.src)
      });
    }
  });
}
var Vn = "", ai = "#", Mr = "*", He = {}, je = function(t) {
  return t[0] === ai;
}, Tl = function() {
  return {
    actions: {},
    guards: {},
    services: {},
    activities: {},
    delays: {}
  };
}, Rl = (
  /** @class */
  /* @__PURE__ */ (function() {
    function t(e, n, r, i) {
      var o = this;
      r === void 0 && (r = "context" in e ? e.context : void 0);
      var s;
      this.config = e, this._context = r, this.order = -1, this.__xstatenode = !0, this.__cache = {
        events: void 0,
        relativeValue: /* @__PURE__ */ new Map(),
        initialStateValue: void 0,
        initialState: void 0,
        on: void 0,
        transitions: void 0,
        candidates: {},
        delayedTransitions: void 0
      }, this.idMap = {}, this.tags = [], this.options = Object.assign(Tl(), n), this.parent = i?.parent, this.key = this.config.key || i?.key || this.config.id || "(machine)", this.machine = this.parent ? this.parent.machine : this, this.path = this.parent ? this.parent.path.concat(this.key) : [], this.delimiter = this.config.delimiter || (this.parent ? this.parent.delimiter : as), this.id = this.config.id || Et([this.machine.key], ct(this.path), !1).join(this.delimiter), this.version = this.parent ? this.parent.version : this.config.version, this.type = this.config.type || (this.config.parallel ? "parallel" : this.config.states && Object.keys(this.config.states).length ? "compound" : this.config.history ? "history" : "atomic"), this.schema = this.parent ? this.machine.schema : (s = this.config.schema) !== null && s !== void 0 ? s : {}, this.description = this.config.description, this.initial = this.config.initial, this.states = this.config.states ? mn(this.config.states, function(u, p) {
        var f, l = new t(u, {}, void 0, {
          parent: o,
          key: p
        });
        return Object.assign(o.idMap, H((f = {}, f[l.id] = l, f), l.idMap)), l;
      }) : He;
      var a = 0;
      function c(u) {
        var p, f;
        u.order = a++;
        try {
          for (var l = it(Ke(u)), d = l.next(); !d.done; d = l.next()) {
            var h = d.value;
            c(h);
          }
        } catch (v) {
          p = {
            error: v
          };
        } finally {
          try {
            d && !d.done && (f = l.return) && f.call(l);
          } finally {
            if (p) throw p.error;
          }
        }
      }
      c(this), this.history = this.config.history === !0 ? "shallow" : this.config.history || !1, this._transient = !!this.config.always || (this.config.on ? Array.isArray(this.config.on) ? this.config.on.some(function(u) {
        var p = u.event;
        return p === Vn;
      }) : Vn in this.config.on : !1), this.strict = !!this.config.strict, this.onEntry = qt(this.config.entry || this.config.onEntry).map(function(u) {
        return Rn(u);
      }), this.onExit = qt(this.config.exit || this.config.onExit).map(function(u) {
        return Rn(u);
      }), this.meta = this.config.meta, this.doneData = this.type === "final" ? this.config.data : void 0, this.invoke = qt(this.config.invoke).map(function(u, p) {
        var f, l;
        if (Ge(u)) {
          var d = Bn(o.id, p);
          return o.machine.options.services = H((f = {}, f[d] = u, f), o.machine.options.services), Wn({
            src: d,
            id: d
          });
        } else if (st(u.src)) {
          var d = u.id || Bn(o.id, p);
          return Wn(H(H({}, u), {
            id: d,
            src: u.src
          }));
        } else if (Ge(u.src) || ft(u.src)) {
          var d = u.id || Bn(o.id, p);
          return o.machine.options.services = H((l = {}, l[d] = u.src, l), o.machine.options.services), Wn(H(H({
            id: d
          }, u), {
            src: d
          }));
        } else {
          var h = u.src;
          return Wn(H(H({
            id: Bn(o.id, p)
          }, u), {
            src: h
          }));
        }
      }), this.activities = qt(this.config.activities).concat(this.invoke).map(function(u) {
        return Ei(u);
      }), this.transition = this.transition.bind(this), this.tags = qt(this.config.tags);
    }
    return t.prototype._init = function() {
      this.__cache.transitions || Es(this).forEach(function(e) {
        return e.on;
      });
    }, t.prototype.withConfig = function(e, n) {
      var r = this.options, i = r.actions, o = r.activities, s = r.guards, a = r.services, c = r.delays;
      return new t(this.config, {
        actions: H(H({}, i), e.actions),
        activities: H(H({}, o), e.activities),
        guards: H(H({}, s), e.guards),
        services: H(H({}, a), e.services),
        delays: H(H({}, c), e.delays)
      }, n ?? this.context);
    }, t.prototype.withContext = function(e) {
      return new t(this.config, this.options, e);
    }, Object.defineProperty(t.prototype, "context", {
      get: function() {
        return ft(this._context) ? this._context() : this._context;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "definition", {
      /**
       * The well-structured state node definition.
       */
      get: function() {
        return {
          id: this.id,
          key: this.key,
          version: this.version,
          context: this.context,
          type: this.type,
          initial: this.initial,
          history: this.history,
          states: mn(this.states, function(e) {
            return e.definition;
          }),
          on: this.on,
          transitions: this.transitions,
          entry: this.onEntry,
          exit: this.onExit,
          activities: this.activities || [],
          meta: this.meta,
          order: this.order || -1,
          data: this.doneData,
          invoke: this.invoke,
          description: this.description,
          tags: this.tags
        };
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.toJSON = function() {
      return this.definition;
    }, Object.defineProperty(t.prototype, "on", {
      /**
       * The mapping of events to transitions.
       */
      get: function() {
        if (this.__cache.on)
          return this.__cache.on;
        var e = this.transitions;
        return this.__cache.on = e.reduce(function(n, r) {
          return n[r.eventType] = n[r.eventType] || [], n[r.eventType].push(r), n;
        }, {});
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "after", {
      get: function() {
        return this.__cache.delayedTransitions || (this.__cache.delayedTransitions = this.getDelayedTransitions(), this.__cache.delayedTransitions);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "transitions", {
      /**
       * All the transitions that can be taken from this state node.
       */
      get: function() {
        return this.__cache.transitions || (this.__cache.transitions = this.formatTransitions(), this.__cache.transitions);
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.getCandidates = function(e) {
      if (this.__cache.candidates[e])
        return this.__cache.candidates[e];
      var n = e === Vn, r = this.transitions.filter(function(i) {
        var o = i.eventType === e;
        return n ? o : o || i.eventType === Mr;
      });
      return this.__cache.candidates[e] = r, r;
    }, t.prototype.getDelayedTransitions = function() {
      var e = this, n = this.config.after;
      if (!n)
        return [];
      var r = function(o, s) {
        var a = ft(o) ? "".concat(e.id, ":delay[").concat(s, "]") : o, c = il(a, e.id);
        return e.onEntry.push(Nn(c, {
          delay: o
        })), e.onExit.push(Qc(c)), c;
      }, i = Qe(n) ? n.map(function(o, s) {
        var a = r(o.delay, s);
        return H(H({}, o), {
          event: a
        });
      }) : vt(Object.keys(n).map(function(o, s) {
        var a = n[o], c = st(a) ? {
          target: a
        } : a, u = isNaN(+o) ? o : +o, p = r(u, s);
        return qt(c).map(function(f) {
          return H(H({}, f), {
            event: p,
            delay: u
          });
        });
      }));
      return i.map(function(o) {
        var s = o.delay;
        return H(H({}, e.formatTransition(o)), {
          delay: s
        });
      });
    }, t.prototype.getStateNodes = function(e) {
      var n, r = this;
      if (!e)
        return [];
      var i = e instanceof ne ? e.value : wn(e, this.delimiter);
      if (st(i)) {
        var o = this.getStateNode(i).initial;
        return o !== void 0 ? this.getStateNodes((n = {}, n[i] = o, n)) : [this, this.states[i]];
      }
      var s = Object.keys(i), a = [this];
      return a.push.apply(a, Et([], ct(vt(s.map(function(c) {
        return r.getStateNode(c).getStateNodes(i[c]);
      }))), !1)), a;
    }, t.prototype.handles = function(e) {
      var n = cs(e);
      return this.events.includes(n);
    }, t.prototype.resolveState = function(e) {
      var n = e instanceof ne ? e : ne.create(e), r = Array.from(Fe([], this.getStateNodes(n.value)));
      return new ne(H(H({}, n), {
        value: this.resolve(n.value),
        configuration: r,
        done: _n(r, this),
        tags: to(r),
        machine: this.machine
      }));
    }, t.prototype.transitionLeafNode = function(e, n, r) {
      var i = this.getStateNode(e), o = i.next(n, r);
      return !o || !o.transitions.length ? this.next(n, r) : o;
    }, t.prototype.transitionCompoundNode = function(e, n, r) {
      var i = Object.keys(e), o = this.getStateNode(i[0]), s = o._transition(e[i[0]], n, r);
      return !s || !s.transitions.length ? this.next(n, r) : s;
    }, t.prototype.transitionParallelNode = function(e, n, r) {
      var i, o, s = {};
      try {
        for (var a = it(Object.keys(e)), c = a.next(); !c.done; c = a.next()) {
          var u = c.value, p = e[u];
          if (p) {
            var f = this.getStateNode(u), l = f._transition(p, n, r);
            l && (s[u] = l);
          }
        }
      } catch (y) {
        i = {
          error: y
        };
      } finally {
        try {
          c && !c.done && (o = a.return) && o.call(a);
        } finally {
          if (i) throw i.error;
        }
      }
      var d = Object.keys(s).map(function(y) {
        return s[y];
      }), h = vt(d.map(function(y) {
        return y.transitions;
      })), v = d.some(function(y) {
        return y.transitions.length > 0;
      });
      if (!v)
        return this.next(n, r);
      var m = vt(d.map(function(y) {
        return y.entrySet;
      })), S = vt(Object.keys(s).map(function(y) {
        return s[y].configuration;
      }));
      return {
        transitions: h,
        entrySet: m,
        exitSet: vt(d.map(function(y) {
          return y.exitSet;
        })),
        configuration: S,
        source: n,
        actions: vt(Object.keys(s).map(function(y) {
          return s[y].actions;
        }))
      };
    }, t.prototype._transition = function(e, n, r) {
      return st(e) ? this.transitionLeafNode(e, n, r) : Object.keys(e).length === 1 ? this.transitionCompoundNode(e, n, r) : this.transitionParallelNode(e, n, r);
    }, t.prototype.getTransitionData = function(e, n) {
      return this._transition(e.value, e, At(n));
    }, t.prototype.next = function(e, n) {
      var r, i, o = this, s = n.name, a = [], c = [], u;
      try {
        for (var p = it(this.getCandidates(s)), f = p.next(); !f.done; f = p.next()) {
          var l = f.value, d = l.cond, h = l.in, v = e.context, m = h ? st(h) && je(h) ? (
            // Check if in state by ID
            e.matches(wn(this.getStateNodeById(h).path, this.delimiter))
          ) : (
            // Check if in state by relative grandparent
            yi(wn(h, this.delimiter), jc(this.path.slice(0, -2))(e.value))
          ) : !0, S = !1;
          try {
            S = !d || ps(this.machine, d, v, n, e);
          } catch (b) {
            throw new Error("Unable to evaluate guard '".concat(d.name || d.type, "' in transition for event '").concat(s, "' in state node '").concat(this.id, `':
`).concat(b.message));
          }
          if (S && m) {
            l.target !== void 0 && (c = l.target), a.push.apply(a, Et([], ct(l.actions), !1)), u = l;
            break;
          }
        }
      } catch (b) {
        r = {
          error: b
        };
      } finally {
        try {
          f && !f.done && (i = p.return) && i.call(p);
        } finally {
          if (r) throw r.error;
        }
      }
      if (u) {
        if (!c.length)
          return {
            transitions: [u],
            entrySet: [],
            exitSet: [],
            configuration: e.value ? [this] : [],
            source: e,
            actions: a
          };
        var y = vt(c.map(function(b) {
          return o.getRelativeStateNodes(b, e.historyValue);
        })), x = !!u.internal, T = x ? [] : vt(y.map(function(b) {
          return o.nodesFromChild(b);
        }));
        return {
          transitions: [u],
          entrySet: T,
          exitSet: x ? [] : [this],
          configuration: y,
          source: e,
          actions: a
        };
      }
    }, t.prototype.nodesFromChild = function(e) {
      if (e.escapes(this))
        return [];
      for (var n = [], r = e; r && r !== this; )
        n.push(r), r = r.parent;
      return n.push(this), n;
    }, t.prototype.escapes = function(e) {
      if (this === e)
        return !1;
      for (var n = this.parent; n; ) {
        if (n === e)
          return !1;
        n = n.parent;
      }
      return !0;
    }, t.prototype.getActions = function(e, n, r, i) {
      var o, s, a, c, u = Fe([], i ? this.getStateNodes(i.value) : [this]), p = e.configuration.length ? Fe(u, e.configuration) : u;
      try {
        for (var f = it(p), l = f.next(); !l.done; l = f.next()) {
          var d = l.value;
          er(u, d) || e.entrySet.push(d);
        }
      } catch (R) {
        o = {
          error: R
        };
      } finally {
        try {
          l && !l.done && (s = f.return) && s.call(f);
        } finally {
          if (o) throw o.error;
        }
      }
      try {
        for (var h = it(u), v = h.next(); !v.done; v = h.next()) {
          var d = v.value;
          (!er(p, d) || er(e.exitSet, d.parent)) && e.exitSet.push(d);
        }
      } catch (R) {
        a = {
          error: R
        };
      } finally {
        try {
          v && !v.done && (c = h.return) && c.call(h);
        } finally {
          if (a) throw a.error;
        }
      }
      var m = vt(e.entrySet.map(function(R) {
        var O = [];
        if (R.type !== "final")
          return O;
        var P = R.parent;
        if (!P.parent)
          return O;
        O.push(
          zn(R.id, R.doneData),
          // TODO: deprecate - final states should not emit done events for their own state.
          zn(P.id, R.doneData ? ar(R.doneData, n, r) : void 0)
        );
        var D = P.parent;
        return D.type === "parallel" && Ke(D).every(function(L) {
          return _n(e.configuration, L);
        }) && O.push(zn(D.id)), O;
      }));
      e.exitSet.sort(function(R, O) {
        return O.order - R.order;
      }), e.entrySet.sort(function(R, O) {
        return R.order - O.order;
      });
      var S = new Set(e.entrySet), y = new Set(e.exitSet), x = ct([vt(Array.from(S).map(function(R) {
        return Et(Et([], ct(R.activities.map(function(O) {
          return tl(O);
        })), !1), ct(R.onEntry), !1);
      })).concat(m.map(gs)), vt(Array.from(y).map(function(R) {
        return Et(Et([], ct(R.onExit), !1), ct(R.activities.map(function(O) {
          return el(O);
        })), !1);
      }))], 2), T = x[0], b = x[1], A = lr(b.concat(e.actions).concat(T), this.machine.options.actions);
      return A;
    }, t.prototype.transition = function(e, n, r) {
      e === void 0 && (e = this.initialState);
      var i = At(n), o;
      if (e instanceof ne)
        o = r === void 0 ? e : this.resolveState(ne.from(e, r));
      else {
        var s = st(e) ? this.resolve(sr(this.getResolvedPath(e))) : this.resolve(e), a = r ?? this.machine.context;
        o = this.resolveState(ne.from(s, a));
      }
      if (this.strict && !this.events.includes(i.name) && !Fc(i.name))
        throw new Error("Machine '".concat(this.id, "' does not accept event '").concat(i.name, "'"));
      var c = this._transition(o.value, o, i) || {
        transitions: [],
        configuration: [],
        entrySet: [],
        exitSet: [],
        source: o,
        actions: []
      }, u = Fe([], this.getStateNodes(o.value)), p = c.configuration.length ? Fe(u, c.configuration) : u;
      return c.configuration = Et([], ct(p), !1), this.resolveTransition(c, o, o.context, i);
    }, t.prototype.resolveRaisedTransition = function(e, n, r) {
      var i, o = e.actions;
      return e = this.transition(e, n), e._event = r, e.event = r.data, (i = e.actions).unshift.apply(i, Et([], ct(o), !1)), e;
    }, t.prototype.resolveTransition = function(e, n, r, i) {
      var o, s, a = this;
      i === void 0 && (i = cr);
      var c = e.configuration, u = !n || e.transitions.length > 0, p = u ? dl(this.machine, c) : void 0, f = n ? n.historyValue ? n.historyValue : e.source ? this.machine.historyValue(n.value) : void 0 : void 0, l = this.getActions(e, r, i, n), d = n ? H({}, n.activities) : {};
      try {
        for (var h = it(l), v = h.next(); !v.done; v = h.next()) {
          var m = v.value;
          m.type === Zr ? d[m.activity.id || m.activity.type] = m : m.type === vi && (d[m.activity.id || m.activity.type] = !1);
        }
      } catch (V) {
        o = {
          error: V
        };
      } finally {
        try {
          v && !v.done && (s = h.return) && s.call(h);
        } finally {
          if (o) throw o.error;
        }
      }
      var S = ct(ii(this, n, r, i, l, this.machine.config.preserveActionOrder), 2), y = S[0], x = S[1], T = ct(us(y, function(V) {
        return V.type === wr || V.type === _r && V.to === Ve.Internal;
      }), 2), b = T[0], A = T[1], R = y.filter(function(V) {
        var ot;
        return V.type === Zr && ((ot = V.activity) === null || ot === void 0 ? void 0 : ot.type) === Qr;
      }), O = R.reduce(function(V, ot) {
        return V[ot.activity.id] = cl(ot.activity, a.machine, x, i), V;
      }, n ? H({}, n.children) : {}), P = u ? e.configuration : n ? n.configuration : [], D = _n(P, this), L = new ne({
        value: p || n.value,
        context: x,
        _event: i,
        // Persist _sessionid between states
        _sessionid: n ? n._sessionid : null,
        historyValue: p ? f ? zc(f, p) : void 0 : n ? n.historyValue : void 0,
        history: !p || e.source ? n : void 0,
        actions: p ? A : [],
        activities: p ? d : n ? n.activities : {},
        events: [],
        configuration: P,
        transitions: e.transitions,
        children: O,
        done: D,
        tags: to(P),
        machine: this
      }), $ = r !== x;
      L.changed = i.name === ss || $;
      var q = L.history;
      q && delete q.history;
      var Y = !D && (this._transient || c.some(function(V) {
        return V._transient;
      }));
      if (!u && (!Y || i.name === Vn))
        return L;
      var G = L;
      if (!D)
        for (Y && (G = this.resolveRaisedTransition(G, {
          type: Ic
        }, i)); b.length; ) {
          var nt = b.shift();
          G = this.resolveRaisedTransition(G, nt._event, i);
        }
      var J = G.changed || (q ? !!G.actions.length || $ || typeof q.value != typeof G.value || !bs(G.value, q.value) : void 0);
      return G.changed = J, G.history = q, G;
    }, t.prototype.getStateNode = function(e) {
      if (je(e))
        return this.machine.getStateNodeById(e);
      if (!this.states)
        throw new Error("Unable to retrieve child state '".concat(e, "' from '").concat(this.id, "'; no child states exist."));
      var n = this.states[e];
      if (!n)
        throw new Error("Child state '".concat(e, "' does not exist on '").concat(this.id, "'"));
      return n;
    }, t.prototype.getStateNodeById = function(e) {
      var n = je(e) ? e.slice(ai.length) : e;
      if (n === this.id)
        return this;
      var r = this.machine.idMap[n];
      if (!r)
        throw new Error("Child state node '#".concat(n, "' does not exist on machine '").concat(this.id, "'"));
      return r;
    }, t.prototype.getStateNodeByPath = function(e) {
      if (typeof e == "string" && je(e))
        try {
          return this.getStateNodeById(e.slice(1));
        } catch {
        }
      for (var n = ei(e, this.delimiter).slice(), r = this; n.length; ) {
        var i = n.shift();
        if (!i.length)
          break;
        r = r.getStateNode(i);
      }
      return r;
    }, t.prototype.resolve = function(e) {
      var n, r = this;
      if (!e)
        return this.initialStateValue || He;
      switch (this.type) {
        case "parallel":
          return mn(this.initialStateValue, function(o, s) {
            return o ? r.getStateNode(s).resolve(e[s] || o) : He;
          });
        case "compound":
          if (st(e)) {
            var i = this.getStateNode(e);
            return i.type === "parallel" || i.type === "compound" ? (n = {}, n[e] = i.initialStateValue, n) : e;
          }
          return Object.keys(e).length ? mn(e, function(o, s) {
            return o ? r.getStateNode(s).resolve(o) : He;
          }) : this.initialStateValue || {};
        default:
          return e || He;
      }
    }, t.prototype.getResolvedPath = function(e) {
      if (je(e)) {
        var n = this.machine.idMap[e.slice(ai.length)];
        if (!n)
          throw new Error("Unable to find state node '".concat(e, "'"));
        return n.path;
      }
      return ei(e, this.delimiter);
    }, Object.defineProperty(t.prototype, "initialStateValue", {
      get: function() {
        var e;
        if (this.__cache.initialStateValue)
          return this.__cache.initialStateValue;
        var n;
        if (this.type === "parallel")
          n = Zi(this.states, function(r) {
            return r.initialStateValue || He;
          }, function(r) {
            return r.type !== "history";
          });
        else if (this.initial !== void 0) {
          if (!this.states[this.initial])
            throw new Error("Initial state '".concat(this.initial, "' not found on '").concat(this.key, "'"));
          n = fr(this.states[this.initial]) ? this.initial : (e = {}, e[this.initial] = this.states[this.initial].initialStateValue, e);
        } else
          n = {};
        return this.__cache.initialStateValue = n, this.__cache.initialStateValue;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.getInitialState = function(e, n) {
      this._init();
      var r = this.getStateNodes(e);
      return this.resolveTransition({
        configuration: r,
        entrySet: r,
        exitSet: [],
        transitions: [],
        source: void 0,
        actions: []
      }, void 0, n ?? this.machine.context, void 0);
    }, Object.defineProperty(t.prototype, "initialState", {
      /**
       * The initial State instance, which includes all actions to be executed from
       * entering the initial state.
       */
      get: function() {
        var e = this.initialStateValue;
        if (!e)
          throw new Error("Cannot retrieve initial state from simple state '".concat(this.id, "'."));
        return this.getInitialState(e);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "target", {
      /**
       * The target state value of the history state node, if it exists. This represents the
       * default state value to transition to if no history value exists yet.
       */
      get: function() {
        var e;
        if (this.type === "history") {
          var n = this.config;
          st(n.target) ? e = je(n.target) ? sr(this.machine.getStateNodeById(n.target).path.slice(this.path.length - 1)) : n.target : e = n.target;
        }
        return e;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.getRelativeStateNodes = function(e, n, r) {
      return r === void 0 && (r = !0), r ? e.type === "history" ? e.resolveHistory(n) : e.initialStateNodes : [e];
    }, Object.defineProperty(t.prototype, "initialStateNodes", {
      get: function() {
        var e = this;
        if (fr(this))
          return [this];
        if (this.type === "compound" && !this.initial)
          return [this];
        var n = Qn(this.initialStateValue);
        return vt(n.map(function(r) {
          return e.getFromRelativePath(r);
        }));
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.getFromRelativePath = function(e) {
      if (!e.length)
        return [this];
      var n = ct(e), r = n[0], i = n.slice(1);
      if (!this.states)
        throw new Error("Cannot retrieve subPath '".concat(r, "' from node with no states"));
      var o = this.getStateNode(r);
      if (o.type === "history")
        return o.resolveHistory();
      if (!this.states[r])
        throw new Error("Child state '".concat(r, "' does not exist on '").concat(this.id, "'"));
      return this.states[r].getFromRelativePath(i);
    }, t.prototype.historyValue = function(e) {
      if (Object.keys(this.states).length)
        return {
          current: e || this.initialStateValue,
          states: Zi(this.states, function(n, r) {
            if (!e)
              return n.historyValue();
            var i = st(e) ? void 0 : e[r];
            return n.historyValue(i || n.initialStateValue);
          }, function(n) {
            return !n.history;
          })
        };
    }, t.prototype.resolveHistory = function(e) {
      var n = this;
      if (this.type !== "history")
        return [this];
      var r = this.parent;
      if (!e) {
        var i = this.target;
        return i ? vt(Qn(i).map(function(s) {
          return r.getFromRelativePath(s);
        })) : r.initialStateNodes;
      }
      var o = Uc(r.path, "states")(e).current;
      return st(o) ? [r.getStateNode(o)] : vt(Qn(o).map(function(s) {
        return n.history === "deep" ? r.getFromRelativePath(s) : [r.states[s[0]]];
      }));
    }, Object.defineProperty(t.prototype, "stateIds", {
      /**
       * All the state node IDs of this state node and its descendant state nodes.
       */
      get: function() {
        var e = this, n = vt(Object.keys(this.states).map(function(r) {
          return e.states[r].stateIds;
        }));
        return [this.id].concat(n);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "events", {
      /**
       * All the event types accepted by this state node and its descendants.
       */
      get: function() {
        var e, n, r, i;
        if (this.__cache.events)
          return this.__cache.events;
        var o = this.states, s = new Set(this.ownEvents);
        if (o)
          try {
            for (var a = it(Object.keys(o)), c = a.next(); !c.done; c = a.next()) {
              var u = c.value, p = o[u];
              if (p.states)
                try {
                  for (var f = (r = void 0, it(p.events)), l = f.next(); !l.done; l = f.next()) {
                    var d = l.value;
                    s.add("".concat(d));
                  }
                } catch (h) {
                  r = {
                    error: h
                  };
                } finally {
                  try {
                    l && !l.done && (i = f.return) && i.call(f);
                  } finally {
                    if (r) throw r.error;
                  }
                }
            }
          } catch (h) {
            e = {
              error: h
            };
          } finally {
            try {
              c && !c.done && (n = a.return) && n.call(a);
            } finally {
              if (e) throw e.error;
            }
          }
        return this.__cache.events = Array.from(s);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "ownEvents", {
      /**
       * All the events that have transitions directly from this state node.
       *
       * Excludes any inert events.
       */
      get: function() {
        var e = new Set(this.transitions.filter(function(n) {
          return !(!n.target && !n.actions.length && n.internal);
        }).map(function(n) {
          return n.eventType;
        }));
        return Array.from(e);
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.resolveTarget = function(e) {
      var n = this;
      if (e !== void 0)
        return e.map(function(r) {
          if (!st(r))
            return r;
          var i = r[0] === n.delimiter;
          if (i && !n.parent)
            return n.getStateNodeByPath(r.slice(1));
          var o = i ? n.key + r : r;
          if (n.parent)
            try {
              var s = n.parent.getStateNodeByPath(o);
              return s;
            } catch (a) {
              throw new Error("Invalid transition definition for state node '".concat(n.id, `':
`).concat(a.message));
            }
          else
            return n.getStateNodeByPath(o);
        });
    }, t.prototype.formatTransition = function(e) {
      var n = this, r = Kc(e.target), i = "internal" in e ? e.internal : r ? r.some(function(c) {
        return st(c) && c[0] === n.delimiter;
      }) : !0, o = this.machine.options.guards, s = this.resolveTarget(r), a = H(H({}, e), {
        actions: lr(qt(e.actions)),
        cond: ds(e.cond, o),
        target: s,
        source: this,
        internal: i,
        eventType: e.event,
        toJSON: function() {
          return H(H({}, a), {
            target: a.target ? a.target.map(function(c) {
              return "#".concat(c.id);
            }) : void 0,
            source: "#".concat(n.id)
          });
        }
      });
      return a;
    }, t.prototype.formatTransitions = function() {
      var e, n, r = this, i;
      if (!this.config.on)
        i = [];
      else if (Array.isArray(this.config.on))
        i = this.config.on;
      else {
        var o = this.config.on, s = Mr, a = o[s], c = a === void 0 ? [] : a, u = gi(o, [typeof s == "symbol" ? s : s + ""]);
        i = vt(Object.keys(u).map(function(y) {
          var x = Me(y, u[y]);
          return x;
        }).concat(Me(Mr, c)));
      }
      var p = this.config.always ? Me("", this.config.always) : [], f = this.config.onDone ? Me(String(zn(this.id)), this.config.onDone) : [], l = vt(this.invoke.map(function(y) {
        var x = [];
        return y.onDone && x.push.apply(x, Et([], ct(Me(String(tr(y.id)), y.onDone)), !1)), y.onError && x.push.apply(x, Et([], ct(Me(String(En(y.id)), y.onError)), !1)), x;
      })), d = this.after, h = vt(Et(Et(Et(Et([], ct(f), !1), ct(l), !1), ct(i), !1), ct(p), !1).map(function(y) {
        return qt(y).map(function(x) {
          return r.formatTransition(x);
        });
      }));
      try {
        for (var v = it(d), m = v.next(); !m.done; m = v.next()) {
          var S = m.value;
          h.push(S);
        }
      } catch (y) {
        e = {
          error: y
        };
      } finally {
        try {
          m && !m.done && (n = v.return) && n.call(v);
        } finally {
          if (e) throw e.error;
        }
      }
      return h;
    }, t;
  })()
);
function Tr(t, e) {
  return new Rl(t, e);
}
var ut = rl, Cn = Nn, Ut = Zc, gn = sl;
function no(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function ro(t) {
  var e, n;
  return no(t) === !1 ? !1 : (e = t.constructor, e === void 0 ? !0 : (n = e.prototype, !(no(n) === !1 || n.hasOwnProperty("isPrototypeOf") === !1)));
}
var Ft = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ie(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function Cl(t) {
  if (Object.prototype.hasOwnProperty.call(t, "__esModule")) return t;
  var e = t.default;
  if (typeof e == "function") {
    var n = function r() {
      var i = !1;
      try {
        i = this instanceof r;
      } catch {
      }
      return i ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    n.prototype = e.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(t).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(t, r);
    Object.defineProperty(n, r, i.get ? i : {
      enumerable: !0,
      get: function() {
        return t[r];
      }
    });
  }), n;
}
var nr = { exports: {} }, Ol = nr.exports, io;
function Al() {
  return io || (io = 1, (function(t) {
    (function(e, n) {
      t.exports = n();
    })(Ol, function() {
      var e = Object.prototype.toString;
      function n(f, l) {
        return f == null ? !1 : Object.prototype.hasOwnProperty.call(f, l);
      }
      function r(f) {
        if (!f || s(f) && f.length === 0)
          return !0;
        if (typeof f != "string") {
          for (var l in f)
            if (n(f, l))
              return !1;
          return !0;
        }
        return !1;
      }
      function i(f) {
        return e.call(f);
      }
      function o(f) {
        return typeof f == "object" && i(f) === "[object Object]";
      }
      var s = Array.isArray || function(f) {
        return e.call(f) === "[object Array]";
      };
      function a(f) {
        return typeof f == "boolean" || i(f) === "[object Boolean]";
      }
      function c(f) {
        var l = parseInt(f);
        return l.toString() === f ? l : f;
      }
      function u(f) {
        f = f || {};
        var l = function(S) {
          return Object.keys(l).reduce(function(y, x) {
            return x === "create" || typeof l[x] == "function" && (y[x] = l[x].bind(l, S)), y;
          }, {});
        }, d;
        f.includeInheritedProps ? d = function() {
          return !0;
        } : d = function(S, y) {
          return typeof y == "number" && Array.isArray(S) || n(S, y);
        };
        function h(S, y) {
          if (d(S, y))
            return S[y];
        }
        var v;
        f.includeInheritedProps ? v = function(S, y) {
          typeof y != "string" && typeof y != "number" && (y = String(y));
          var x = h(S, y);
          if (y === "__proto__" || y === "prototype" || y === "constructor" && typeof x == "function")
            throw new Error("For security reasons, object's magic properties cannot be set");
          return x;
        } : v = function(S, y) {
          return h(S, y);
        };
        function m(S, y, x, T) {
          if (typeof y == "number" && (y = [y]), !y || y.length === 0)
            return S;
          if (typeof y == "string")
            return m(S, y.split(".").map(c), x, T);
          var b = y[0], A = v(S, b);
          return y.length === 1 ? ((A === void 0 || !T) && (S[b] = x), A) : (A === void 0 && (typeof y[1] == "number" ? S[b] = [] : S[b] = {}), m(S[b], y.slice(1), x, T));
        }
        return l.has = function(S, y) {
          if (typeof y == "number" ? y = [y] : typeof y == "string" && (y = y.split(".")), !y || y.length === 0)
            return !!S;
          for (var x = 0; x < y.length; x++) {
            var T = c(y[x]);
            if (typeof T == "number" && s(S) && T < S.length || (f.includeInheritedProps ? T in Object(S) : n(S, T)))
              S = S[T];
            else
              return !1;
          }
          return !0;
        }, l.ensureExists = function(S, y, x) {
          return m(S, y, x, !0);
        }, l.set = function(S, y, x, T) {
          return m(S, y, x, T);
        }, l.insert = function(S, y, x, T) {
          var b = l.get(S, y);
          T = ~~T, s(b) || (b = [], l.set(S, y, b)), b.splice(T, 0, x);
        }, l.empty = function(S, y) {
          if (!r(y) && S != null) {
            var x, T;
            if (x = l.get(S, y)) {
              if (typeof x == "string")
                return l.set(S, y, "");
              if (a(x))
                return l.set(S, y, !1);
              if (typeof x == "number")
                return l.set(S, y, 0);
              if (s(x))
                x.length = 0;
              else if (o(x))
                for (T in x)
                  d(x, T) && delete x[T];
              else
                return l.set(S, y, null);
            }
          }
        }, l.push = function(S, y) {
          var x = l.get(S, y);
          s(x) || (x = [], l.set(S, y, x)), x.push.apply(x, Array.prototype.slice.call(arguments, 2));
        }, l.coalesce = function(S, y, x) {
          for (var T, b = 0, A = y.length; b < A; b++)
            if ((T = l.get(S, y[b])) !== void 0)
              return T;
          return x;
        }, l.get = function(S, y, x) {
          if (typeof y == "number" && (y = [y]), !y || y.length === 0)
            return S;
          if (S == null)
            return x;
          if (typeof y == "string")
            return l.get(S, y.split("."), x);
          var T = c(y[0]), b = v(S, T);
          return b === void 0 ? x : y.length === 1 ? b : l.get(S[T], y.slice(1), x);
        }, l.del = function(y, x) {
          if (typeof x == "number" && (x = [x]), y == null || r(x))
            return y;
          if (typeof x == "string")
            return l.del(y, x.split("."));
          var T = c(x[0]);
          if (v(y, T), !d(y, T))
            return y;
          if (x.length === 1)
            s(y) ? y.splice(T, 1) : delete y[T];
          else
            return l.del(y[T], x.slice(1));
          return y;
        }, l;
      }
      var p = u();
      return p.create = u, p.withInheritedProps = u({ includeInheritedProps: !0 }), p;
    });
  })(nr)), nr.exports;
}
var Nl = Al();
const Pl = /* @__PURE__ */ Ie(Nl);
var ze = Object.prototype.hasOwnProperty;
function Xt(t) {
  if (ci(t))
    return !1;
  if (!t || Xe(t) && t.length === 0)
    return !0;
  if (!_s(t)) {
    for (var e in t)
      if (ze.call(t, e))
        return !1;
    return !0;
  }
  return !1;
}
function ci(t) {
  return typeof t == "number";
}
function _s(t) {
  return typeof t == "string";
}
function Xe(t) {
  return Array.isArray(t);
}
function li(t, e) {
  for (var n in e)
    ze.call(e, n) && (t[n] = e[n]);
  return t;
}
function Il(t) {
  var e = parseInt(t);
  return e.toString() === t ? e : t;
}
function dr(t, e, n) {
  return t == null ? e ? n ? [] : {} : t : Xe(t) ? t.slice() : li({}, t);
}
function pr(t, e) {
  if (t !== e && ro(t) && ro(e)) {
    var n = {};
    for (var r in t)
      ze.call(t, r) && (ze.call(e, r) ? n[r] = pr(t[r], e[r]) : n[r] = t[r]);
    for (r in e)
      ze.call(e, r) && (n[r] = pr(t[r], e[r]));
    return n;
  }
  return e;
}
function se(t, e, n, r) {
  if (ci(n) && (n = [n]), Xt(n))
    return e;
  if (_s(n))
    return se(t, e, n.split(".").map(Il), r);
  var i = n[0];
  return (!t || t === e) && (t = dr(e, !0, ci(i))), n.length === 1 ? r(t, i) : (e != null && (e = e[i]), t[i] = se(t[i], e, n.slice(1), r), t);
}
var Lt = {};
Lt.set = function(e, n, r, i) {
  return Xt(r) ? i : se(e, n, r, function(o, s) {
    return o[s] = i, o;
  });
};
Lt.update = function(e, n, r, i) {
  return Xt(r) ? i(dr(n)) : se(e, n, r, function(o, s) {
    return o[s] = i(o[s]), o;
  });
};
Lt.push = function(e, n, r) {
  var i = Array.prototype.slice.call(arguments, 3);
  return Xt(r) ? Xe(n) ? n.concat(i) : i : se(e, n, r, function(o, s) {
    return Xe(o[s]) ? o[s] = o[s].concat(i) : o[s] = i, o;
  });
};
Lt.insert = function(e, n, r, i, o) {
  if (o = ~~o, Xt(r)) {
    if (!Xe(n))
      return [i];
    var s = n.slice(0, o);
    return s.push(i), s.concat(n.slice(o));
  }
  return se(e, n, r, function(a, c) {
    var u = a[c];
    if (!Xe(u)) {
      if (u != null && typeof u < "u")
        throw new Error("Expected " + r + "to be an array. Instead got " + typeof r);
      u = [];
    }
    var p = u.slice(0, o);
    return p.push(i), a[c] = p.concat(u.slice(o)), a;
  });
};
Lt.del = function(e, n, r) {
  if (!Xt(r))
    return se(e, n, r, function(i, o) {
      return Array.isArray(i) ? i[o] !== void 0 && i.splice(o, 1) : ze.call(i, o) && delete i[o], i;
    });
};
Lt.assign = function(e, n, r, i) {
  return Xt(r) ? Xt(i) ? n : li(dr(n), i) : se(e, n, r, function(o, s) {
    i = Object(i);
    var a = dr(o[s], !0);
    return li(a, i), o[s] = a, o;
  });
};
Lt.merge = function(e, n, r, i) {
  return Xt(r) ? Xt(i) ? n : pr(n, i) : se(e, n, r, function(o, s) {
    return i = Object(i), o[s] = pr(o[s], i), o;
  });
};
var Dl = Lt.set.bind(null, null), rr = Lt.update.bind(null, null);
Lt.push.bind(null, null);
Lt.insert.bind(null, null);
Lt.del.bind(null, null);
Lt.assign.bind(null, null);
Lt.merge.bind(null, null);
var kl = Pl.get;
const Ct = [];
for (let t = 0; t < 256; ++t)
  Ct.push((t + 256).toString(16).slice(1));
function Ll(t, e = 0) {
  return (Ct[t[e + 0]] + Ct[t[e + 1]] + Ct[t[e + 2]] + Ct[t[e + 3]] + "-" + Ct[t[e + 4]] + Ct[t[e + 5]] + "-" + Ct[t[e + 6]] + Ct[t[e + 7]] + "-" + Ct[t[e + 8]] + Ct[t[e + 9]] + "-" + Ct[t[e + 10]] + Ct[t[e + 11]] + Ct[t[e + 12]] + Ct[t[e + 13]] + Ct[t[e + 14]] + Ct[t[e + 15]]).toLowerCase();
}
const $l = new Uint8Array(16);
function Ml() {
  return crypto.getRandomValues($l);
}
function Hl(t, e, n) {
  return crypto.randomUUID ? crypto.randomUUID() : jl(t);
}
function jl(t, e, n) {
  t = t || {};
  const r = t.random ?? t.rng?.() ?? Ml();
  if (r.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, Ll(r);
}
var bn = { exports: {} };
bn.exports;
var oo;
function Ul() {
  return oo || (oo = 1, (function(t, e) {
    var n = 200, r = "__lodash_hash_undefined__", i = 1, o = 2, s = 9007199254740991, a = "[object Arguments]", c = "[object Array]", u = "[object AsyncFunction]", p = "[object Boolean]", f = "[object Date]", l = "[object Error]", d = "[object Function]", h = "[object GeneratorFunction]", v = "[object Map]", m = "[object Number]", S = "[object Null]", y = "[object Object]", x = "[object Promise]", T = "[object Proxy]", b = "[object RegExp]", A = "[object Set]", R = "[object String]", O = "[object Symbol]", P = "[object Undefined]", D = "[object WeakMap]", L = "[object ArrayBuffer]", $ = "[object DataView]", q = "[object Float32Array]", Y = "[object Float64Array]", G = "[object Int8Array]", nt = "[object Int16Array]", J = "[object Int32Array]", V = "[object Uint8Array]", ot = "[object Uint8ClampedArray]", Q = "[object Uint16Array]", et = "[object Uint32Array]", rt = /[\\^$.*+?()[\]{}|]/g, gt = /^\[object .+?Constructor\]$/, xt = /^(?:0|[1-9]\d*)$/, U = {};
    U[q] = U[Y] = U[G] = U[nt] = U[J] = U[V] = U[ot] = U[Q] = U[et] = !0, U[a] = U[c] = U[L] = U[p] = U[$] = U[f] = U[l] = U[d] = U[v] = U[m] = U[y] = U[b] = U[A] = U[R] = U[D] = !1;
    var W = typeof Ft == "object" && Ft && Ft.Object === Object && Ft, tt = typeof self == "object" && self && self.Object === Object && self, pt = W || tt || Function("return this")(), _t = e && !e.nodeType && e, Dt = _t && !0 && t && !t.nodeType && t, Zt = Dt && Dt.exports === _t, Nt = Zt && W.process, kt = (function() {
      try {
        return Nt && Nt.binding && Nt.binding("util");
      } catch {
      }
    })(), Jt = kt && kt.isTypedArray;
    function ke(E, _) {
      for (var k = -1, B = E == null ? 0 : E.length, ht = 0, X = []; ++k < B; ) {
        var mt = E[k];
        _(mt, k, E) && (X[ht++] = mt);
      }
      return X;
    }
    function fe(E, _) {
      for (var k = -1, B = _.length, ht = E.length; ++k < B; )
        E[ht + k] = _[k];
      return E;
    }
    function rn(E, _) {
      for (var k = -1, B = E == null ? 0 : E.length; ++k < B; )
        if (_(E[k], k, E))
          return !0;
      return !1;
    }
    function on(E, _) {
      for (var k = -1, B = Array(E); ++k < E; )
        B[k] = _(k);
      return B;
    }
    function sn(E) {
      return function(_) {
        return E(_);
      };
    }
    function de(E, _) {
      return E.has(_);
    }
    function pe(E, _) {
      return E?.[_];
    }
    function an(E) {
      var _ = -1, k = Array(E.size);
      return E.forEach(function(B, ht) {
        k[++_] = [ht, B];
      }), k;
    }
    function cn(E, _) {
      return function(k) {
        return E(_(k));
      };
    }
    function ln(E) {
      var _ = -1, k = Array(E.size);
      return E.forEach(function(B) {
        k[++_] = B;
      }), k;
    }
    var un = Array.prototype, Le = Function.prototype, he = Object.prototype, Qt = pt["__core-js_shared__"], xe = Le.toString, C = he.hasOwnProperty, j = (function() {
      var E = /[^.]+$/.exec(Qt && Qt.keys && Qt.keys.IE_PROTO || "");
      return E ? "Symbol(src)_1." + E : "";
    })(), g = he.toString, w = RegExp(
      "^" + xe.call(C).replace(rt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    ), I = Zt ? pt.Buffer : void 0, N = pt.Symbol, M = pt.Uint8Array, F = he.propertyIsEnumerable, z = un.splice, K = N ? N.toStringTag : void 0, Z = Object.getOwnPropertySymbols, at = I ? I.isBuffer : void 0, dt = cn(Object.keys, Object), bt = $e(pt, "DataView"), Tt = $e(pt, "Map"), Gt = $e(pt, "Promise"), fn = $e(pt, "Set"), Dr = $e(pt, "WeakMap"), dn = $e(Object, "create"), Ha = Te(bt), ja = Te(Tt), Ua = Te(Gt), Fa = Te(fn), Ba = Te(Dr), Hi = N ? N.prototype : void 0, kr = Hi ? Hi.valueOf : void 0;
    function we(E) {
      var _ = -1, k = E == null ? 0 : E.length;
      for (this.clear(); ++_ < k; ) {
        var B = E[_];
        this.set(B[0], B[1]);
      }
    }
    function za() {
      this.__data__ = dn ? dn(null) : {}, this.size = 0;
    }
    function qa(E) {
      var _ = this.has(E) && delete this.__data__[E];
      return this.size -= _ ? 1 : 0, _;
    }
    function Wa(E) {
      var _ = this.__data__;
      if (dn) {
        var k = _[E];
        return k === r ? void 0 : k;
      }
      return C.call(_, E) ? _[E] : void 0;
    }
    function Va(E) {
      var _ = this.__data__;
      return dn ? _[E] !== void 0 : C.call(_, E);
    }
    function Ga(E, _) {
      var k = this.__data__;
      return this.size += this.has(E) ? 0 : 1, k[E] = dn && _ === void 0 ? r : _, this;
    }
    we.prototype.clear = za, we.prototype.delete = qa, we.prototype.get = Wa, we.prototype.has = Va, we.prototype.set = Ga;
    function te(E) {
      var _ = -1, k = E == null ? 0 : E.length;
      for (this.clear(); ++_ < k; ) {
        var B = E[_];
        this.set(B[0], B[1]);
      }
    }
    function Ka() {
      this.__data__ = [], this.size = 0;
    }
    function Xa(E) {
      var _ = this.__data__, k = $n(_, E);
      if (k < 0)
        return !1;
      var B = _.length - 1;
      return k == B ? _.pop() : z.call(_, k, 1), --this.size, !0;
    }
    function Ya(E) {
      var _ = this.__data__, k = $n(_, E);
      return k < 0 ? void 0 : _[k][1];
    }
    function Za(E) {
      return $n(this.__data__, E) > -1;
    }
    function Ja(E, _) {
      var k = this.__data__, B = $n(k, E);
      return B < 0 ? (++this.size, k.push([E, _])) : k[B][1] = _, this;
    }
    te.prototype.clear = Ka, te.prototype.delete = Xa, te.prototype.get = Ya, te.prototype.has = Za, te.prototype.set = Ja;
    function _e(E) {
      var _ = -1, k = E == null ? 0 : E.length;
      for (this.clear(); ++_ < k; ) {
        var B = E[_];
        this.set(B[0], B[1]);
      }
    }
    function Qa() {
      this.size = 0, this.__data__ = {
        hash: new we(),
        map: new (Tt || te)(),
        string: new we()
      };
    }
    function tc(E) {
      var _ = Mn(this, E).delete(E);
      return this.size -= _ ? 1 : 0, _;
    }
    function ec(E) {
      return Mn(this, E).get(E);
    }
    function nc(E) {
      return Mn(this, E).has(E);
    }
    function rc(E, _) {
      var k = Mn(this, E), B = k.size;
      return k.set(E, _), this.size += k.size == B ? 0 : 1, this;
    }
    _e.prototype.clear = Qa, _e.prototype.delete = tc, _e.prototype.get = ec, _e.prototype.has = nc, _e.prototype.set = rc;
    function Ln(E) {
      var _ = -1, k = E == null ? 0 : E.length;
      for (this.__data__ = new _e(); ++_ < k; )
        this.add(E[_]);
    }
    function ic(E) {
      return this.__data__.set(E, r), this;
    }
    function oc(E) {
      return this.__data__.has(E);
    }
    Ln.prototype.add = Ln.prototype.push = ic, Ln.prototype.has = oc;
    function ge(E) {
      var _ = this.__data__ = new te(E);
      this.size = _.size;
    }
    function sc() {
      this.__data__ = new te(), this.size = 0;
    }
    function ac(E) {
      var _ = this.__data__, k = _.delete(E);
      return this.size = _.size, k;
    }
    function cc(E) {
      return this.__data__.get(E);
    }
    function lc(E) {
      return this.__data__.has(E);
    }
    function uc(E, _) {
      var k = this.__data__;
      if (k instanceof te) {
        var B = k.__data__;
        if (!Tt || B.length < n - 1)
          return B.push([E, _]), this.size = ++k.size, this;
        k = this.__data__ = new _e(B);
      }
      return k.set(E, _), this.size = k.size, this;
    }
    ge.prototype.clear = sc, ge.prototype.delete = ac, ge.prototype.get = cc, ge.prototype.has = lc, ge.prototype.set = uc;
    function fc(E, _) {
      var k = Hn(E), B = !k && Rc(E), ht = !k && !B && Lr(E), X = !k && !B && !ht && Gi(E), mt = k || B || ht || X, wt = mt ? on(E.length, String) : [], Rt = wt.length;
      for (var yt in E)
        C.call(E, yt) && !(mt && // Safari 9 has enumerable `arguments.length` in strict mode.
        (yt == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        ht && (yt == "offset" || yt == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        X && (yt == "buffer" || yt == "byteLength" || yt == "byteOffset") || // Skip index properties.
        bc(yt, Rt))) && wt.push(yt);
      return wt;
    }
    function $n(E, _) {
      for (var k = E.length; k--; )
        if (zi(E[k][0], _))
          return k;
      return -1;
    }
    function dc(E, _, k) {
      var B = _(E);
      return Hn(E) ? B : fe(B, k(E));
    }
    function pn(E) {
      return E == null ? E === void 0 ? P : S : K && K in Object(E) ? Ec(E) : Tc(E);
    }
    function ji(E) {
      return hn(E) && pn(E) == a;
    }
    function Ui(E, _, k, B, ht) {
      return E === _ ? !0 : E == null || _ == null || !hn(E) && !hn(_) ? E !== E && _ !== _ : pc(E, _, k, B, Ui, ht);
    }
    function pc(E, _, k, B, ht, X) {
      var mt = Hn(E), wt = Hn(_), Rt = mt ? c : ve(E), yt = wt ? c : ve(_);
      Rt = Rt == a ? y : Rt, yt = yt == a ? y : yt;
      var $t = Rt == y, Bt = yt == y, Ot = Rt == yt;
      if (Ot && Lr(E)) {
        if (!Lr(_))
          return !1;
        mt = !0, $t = !1;
      }
      if (Ot && !$t)
        return X || (X = new ge()), mt || Gi(E) ? Fi(E, _, k, B, ht, X) : yc(E, _, Rt, k, B, ht, X);
      if (!(k & i)) {
        var Ht = $t && C.call(E, "__wrapped__"), jt = Bt && C.call(_, "__wrapped__");
        if (Ht || jt) {
          var ye = Ht ? E.value() : E, ee = jt ? _.value() : _;
          return X || (X = new ge()), ht(ye, ee, k, B, X);
        }
      }
      return Ot ? (X || (X = new ge()), mc(E, _, k, B, ht, X)) : !1;
    }
    function hc(E) {
      if (!Vi(E) || wc(E))
        return !1;
      var _ = qi(E) ? w : gt;
      return _.test(Te(E));
    }
    function gc(E) {
      return hn(E) && Wi(E.length) && !!U[pn(E)];
    }
    function vc(E) {
      if (!_c(E))
        return dt(E);
      var _ = [];
      for (var k in Object(E))
        C.call(E, k) && k != "constructor" && _.push(k);
      return _;
    }
    function Fi(E, _, k, B, ht, X) {
      var mt = k & i, wt = E.length, Rt = _.length;
      if (wt != Rt && !(mt && Rt > wt))
        return !1;
      var yt = X.get(E);
      if (yt && X.get(_))
        return yt == _;
      var $t = -1, Bt = !0, Ot = k & o ? new Ln() : void 0;
      for (X.set(E, _), X.set(_, E); ++$t < wt; ) {
        var Ht = E[$t], jt = _[$t];
        if (B)
          var ye = mt ? B(jt, Ht, $t, _, E, X) : B(Ht, jt, $t, E, _, X);
        if (ye !== void 0) {
          if (ye)
            continue;
          Bt = !1;
          break;
        }
        if (Ot) {
          if (!rn(_, function(ee, Re) {
            if (!de(Ot, Re) && (Ht === ee || ht(Ht, ee, k, B, X)))
              return Ot.push(Re);
          })) {
            Bt = !1;
            break;
          }
        } else if (!(Ht === jt || ht(Ht, jt, k, B, X))) {
          Bt = !1;
          break;
        }
      }
      return X.delete(E), X.delete(_), Bt;
    }
    function yc(E, _, k, B, ht, X, mt) {
      switch (k) {
        case $:
          if (E.byteLength != _.byteLength || E.byteOffset != _.byteOffset)
            return !1;
          E = E.buffer, _ = _.buffer;
        case L:
          return !(E.byteLength != _.byteLength || !X(new M(E), new M(_)));
        case p:
        case f:
        case m:
          return zi(+E, +_);
        case l:
          return E.name == _.name && E.message == _.message;
        case b:
        case R:
          return E == _ + "";
        case v:
          var wt = an;
        case A:
          var Rt = B & i;
          if (wt || (wt = ln), E.size != _.size && !Rt)
            return !1;
          var yt = mt.get(E);
          if (yt)
            return yt == _;
          B |= o, mt.set(E, _);
          var $t = Fi(wt(E), wt(_), B, ht, X, mt);
          return mt.delete(E), $t;
        case O:
          if (kr)
            return kr.call(E) == kr.call(_);
      }
      return !1;
    }
    function mc(E, _, k, B, ht, X) {
      var mt = k & i, wt = Bi(E), Rt = wt.length, yt = Bi(_), $t = yt.length;
      if (Rt != $t && !mt)
        return !1;
      for (var Bt = Rt; Bt--; ) {
        var Ot = wt[Bt];
        if (!(mt ? Ot in _ : C.call(_, Ot)))
          return !1;
      }
      var Ht = X.get(E);
      if (Ht && X.get(_))
        return Ht == _;
      var jt = !0;
      X.set(E, _), X.set(_, E);
      for (var ye = mt; ++Bt < Rt; ) {
        Ot = wt[Bt];
        var ee = E[Ot], Re = _[Ot];
        if (B)
          var Ki = mt ? B(Re, ee, Ot, _, E, X) : B(ee, Re, Ot, E, _, X);
        if (!(Ki === void 0 ? ee === Re || ht(ee, Re, k, B, X) : Ki)) {
          jt = !1;
          break;
        }
        ye || (ye = Ot == "constructor");
      }
      if (jt && !ye) {
        var jn = E.constructor, Un = _.constructor;
        jn != Un && "constructor" in E && "constructor" in _ && !(typeof jn == "function" && jn instanceof jn && typeof Un == "function" && Un instanceof Un) && (jt = !1);
      }
      return X.delete(E), X.delete(_), jt;
    }
    function Bi(E) {
      return dc(E, Ac, Sc);
    }
    function Mn(E, _) {
      var k = E.__data__;
      return xc(_) ? k[typeof _ == "string" ? "string" : "hash"] : k.map;
    }
    function $e(E, _) {
      var k = pe(E, _);
      return hc(k) ? k : void 0;
    }
    function Ec(E) {
      var _ = C.call(E, K), k = E[K];
      try {
        E[K] = void 0;
        var B = !0;
      } catch {
      }
      var ht = g.call(E);
      return B && (_ ? E[K] = k : delete E[K]), ht;
    }
    var Sc = Z ? function(E) {
      return E == null ? [] : (E = Object(E), ke(Z(E), function(_) {
        return F.call(E, _);
      }));
    } : Nc, ve = pn;
    (bt && ve(new bt(new ArrayBuffer(1))) != $ || Tt && ve(new Tt()) != v || Gt && ve(Gt.resolve()) != x || fn && ve(new fn()) != A || Dr && ve(new Dr()) != D) && (ve = function(E) {
      var _ = pn(E), k = _ == y ? E.constructor : void 0, B = k ? Te(k) : "";
      if (B)
        switch (B) {
          case Ha:
            return $;
          case ja:
            return v;
          case Ua:
            return x;
          case Fa:
            return A;
          case Ba:
            return D;
        }
      return _;
    });
    function bc(E, _) {
      return _ = _ ?? s, !!_ && (typeof E == "number" || xt.test(E)) && E > -1 && E % 1 == 0 && E < _;
    }
    function xc(E) {
      var _ = typeof E;
      return _ == "string" || _ == "number" || _ == "symbol" || _ == "boolean" ? E !== "__proto__" : E === null;
    }
    function wc(E) {
      return !!j && j in E;
    }
    function _c(E) {
      var _ = E && E.constructor, k = typeof _ == "function" && _.prototype || he;
      return E === k;
    }
    function Tc(E) {
      return g.call(E);
    }
    function Te(E) {
      if (E != null) {
        try {
          return xe.call(E);
        } catch {
        }
        try {
          return E + "";
        } catch {
        }
      }
      return "";
    }
    function zi(E, _) {
      return E === _ || E !== E && _ !== _;
    }
    var Rc = ji(/* @__PURE__ */ (function() {
      return arguments;
    })()) ? ji : function(E) {
      return hn(E) && C.call(E, "callee") && !F.call(E, "callee");
    }, Hn = Array.isArray;
    function Cc(E) {
      return E != null && Wi(E.length) && !qi(E);
    }
    var Lr = at || Pc;
    function Oc(E, _) {
      return Ui(E, _);
    }
    function qi(E) {
      if (!Vi(E))
        return !1;
      var _ = pn(E);
      return _ == d || _ == h || _ == u || _ == T;
    }
    function Wi(E) {
      return typeof E == "number" && E > -1 && E % 1 == 0 && E <= s;
    }
    function Vi(E) {
      var _ = typeof E;
      return E != null && (_ == "object" || _ == "function");
    }
    function hn(E) {
      return E != null && typeof E == "object";
    }
    var Gi = Jt ? sn(Jt) : gc;
    function Ac(E) {
      return Cc(E) ? fc(E) : vc(E);
    }
    function Nc() {
      return [];
    }
    function Pc() {
      return !1;
    }
    t.exports = Oc;
  })(bn, bn.exports)), bn.exports;
}
var Fl = Ul();
const xn = /* @__PURE__ */ Ie(Fl), Bl = "EXPERIENCE_STARTED", so = "SHOW", Ce = "STOP_EXPERIENCE", Se = {
  NAVIGATION: "navigation",
  DISMISSED: "dismissed"
}, zl = "EXTENDED_EVENT", Ts = "START_STEP", bi = "STOP_STEP", Rs = "UPDATE_STEP", Cs = "SET_STEP_CONTAINER_TARGET", Os = "UPDATE_STEP_CONTENT", ql = "RECOVER_STEP", Wl = "AUTO_RECOVER_STEP", Vl = "PARENT_RECOVER_STEP", Gl = "ERROR", Kl = "STEP_INTERACTION", Xl = "STEP_SEEN", As = "UPDATE_ROOT_STYLE", Yl = "RELOAD", Ns = "STEP_STOPPED", Zl = "EXPERIENCE_DISMISSED", Jl = "EXPERIENCE_SNOOZED", Ql = "FORWARD_TO_PARENT", Ps = "TRANSITION_TO_END", Is = "ACTIONS_STARTED", Ds = "ACTIONS_FINISHED", tu = "experience.begin", eu = "experience.end", xi = "step.prebegin", wi = "step.begin", ks = "step.prerender", Ls = "step.postrender", hr = "step.end", $s = "step.error", Ms = "step.container_change", Hs = "RUN_HOOKS", nu = "RUN_HOOKS_DONE", _i = "START_THEME_REMOVAL_LISTENER", js = "STOP_THEME_REMOVAL_LISTENER", ru = "GLOBAL_CONTAINER_REMOVED", Ti = "STEP_CONTAINER_REMOVED", Tn = "appcues-experience-container", Pn = "APPCUES-EXPERIENCE-CONTAINER", In = "APPCUES-EXPERIENCE-CONTAINER-BUILDER", Us = "data-appcues-container-id", Rr = "RUN_TRAITS_DONE", Fs = "RUN_TRAITS_ERROR", iu = "BIND_ACTIONS_ERROR", ou = () => {
  const t = /* @__PURE__ */ new Map(), e = (i) => {
    const { observerInstance: o } = t.get(i);
    if (o) return;
    const s = { childList: !0, subtree: !0 }, a = (...p) => {
      const { callbacks: f } = t.get(i);
      f.forEach((l) => l(...p));
    }, c = new MutationObserver(a);
    c.observe(i, s);
    const { callbacks: u } = t.get(i);
    t.set(i, {
      callbacks: u,
      observerInstance: c
    });
  }, n = (i, o) => {
    const s = t.get(i);
    if (s) {
      const { callbacks: a, observerInstance: c } = s, u = a.filter((p) => p !== o);
      if (u.length > 0) {
        t.set(i, {
          callbacks: u,
          observerInstance: c
        });
        return;
      }
      c.disconnect(), t.delete(i);
    }
  };
  return (i, o) => {
    const { callbacks: s = [], observerInstance: a = null } = t.get(i) ?? {};
    return t.set(i, {
      observerInstance: a,
      callbacks: [...s, o]
    }), e(i), () => n(i, o);
  };
}, Be = ou(), su = (t, ...e) => {
  e.forEach(
    (n) => t.addEventListener(n, (r) => {
      r.stopPropagation();
    })
  );
}, ao = "|shadow-root|", co = "|iframe|", Ye = (t, e) => {
  try {
    return t.includes(ao) || t.includes(co) ? t.split(ao).flatMap((n) => n.split(co)).reduce((n, r) => n === null ? [...e.querySelectorAll(r)] : n.flatMap((i) => i.shadowRoot ? [...i.shadowRoot.querySelectorAll(r)] : i.tagName === "IFRAME" ? [
      ...i.contentDocument.querySelectorAll(r)
    ] : []), null) ?? [] : e.querySelectorAll(t);
  } catch {
    return [];
  }
}, au = (t, e) => {
  const n = Ye(t, e);
  return n.length > 0 ? n[0] : null;
}, De = (t) => `appcues-container-${t}`, lo = (t, e, n) => {
  try {
    if (t.contentDocument && t.contentDocument.body && t.contentDocument.body.children.length > 0) {
      if (n()) return;
      e(t.contentDocument.body);
    } else {
      const r = () => {
        try {
          const i = t.contentDocument;
          if (!i || !i.body || n()) return;
          e(i.body);
        } catch {
        }
      };
      t.addEventListener("load", r, { once: !0 });
    }
  } catch {
  }
}, cu = (t, e) => {
  t.forEach((n) => {
    n.type === "childList" && n.addedNodes.forEach((r) => {
      r.nodeType === 1 && r.tagName === "IFRAME" && e(r);
    });
  });
}, lu = ({
  getTarget: t,
  onInserted: e,
  getWindowReference: n
}) => {
  const r = n().document;
  let i = [];
  const o = () => {
    i.forEach((d) => d()), i = [];
  }, s = () => {
    const d = t();
    return d.length === 1 ? (e(d[0]), o(), !0) : !1;
  };
  if (s())
    return () => {
    };
  const c = (d) => {
    d.some((h) => h.addedNodes.length > 0) && (cu(d, (h) => {
      lo(
        h,
        (v) => i.push(Be(v, c)),
        s
      );
    }), s());
  };
  i.push(Be(r.body, c));
  let u;
  const p = r.createNodeIterator(
    r.body,
    NodeFilter.SHOW_ELEMENT,
    (d) => d.shadowRoot && d.nodeName !== Pn && d.nodeName !== In ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT
  );
  for (; (u = p.nextNode()) !== null; )
    i.push(Be(u.shadowRoot, c));
  let f;
  const l = r.createNodeIterator(
    r.body,
    NodeFilter.SHOW_ELEMENT,
    (d) => d.tagName === "IFRAME" ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT
  );
  for (; (f = l.nextNode()) !== null; )
    lo(
      f,
      // eslint-disable-next-line no-loop-func
      (d) => i.push(Be(d, c)),
      s
    );
  return () => o();
}, Ri = ({
  getTarget: t,
  onRemoved: e,
  getWindowReference: n
}) => {
  const r = n().document;
  let [i] = t(), o;
  const s = (a) => {
    if (!a.some((p) => p.removedNodes.length > 0))
      return;
    const c = t(), u = i ? c[0] !== i : !1;
    [i] = c, (c.length === 0 || u || !i.isConnected) && (e(), o());
  };
  return o = i && i.getRootNode().nodeType === Node.DOCUMENT_FRAGMENT_NODE ? Be(i.getRootNode(), s) : Be(r.body, s), () => o();
}, uu = (t) => {
  let e = 0;
  for (let n = 0; n < t.length && !(t[n].nodeName !== Pn || t[n].nodeName !== In); n++)
    e = n;
  return t.slice(e + 1);
}, fu = (t, e = document) => {
  try {
    const n = /^((body\s(>?\s?))?)(?<tagName>[\da-z]+):nth-child\((?<index>\d+)\)(?<remainingSelector>.*)/i, r = t.match(n), i = e.body.firstChild?.nodeName === Pn || e.body.firstChild?.nodeName === In;
    if (!r || !i) return [];
    const { tagName: o, index: s, remainingSelector: a } = r.groups, c = Number.parseInt(s, 10) - 1, u = uu([
      ...e.body.children
    ]), p = u[c]?.nodeName === o.toUpperCase() ? u[c] : null;
    return a ? (
      // adding * here to the string because
      // the remaining selector can be something like
      // > p:nth-of-type(1).
      // But selectors starting with > without a parent sentence first or *
      // would fail, because it is not a valid css selector.
      // * means the parentElement, which is the element
      // we are applying the querySelectorAll.
      p ? Ye(`* ${a}`, p) : []
    ) : [p];
  } catch {
    return [];
  }
}, Bs = (t, { step: e, stepContainer: n, checkOutsideContainer: r, getWindowReference: i }) => {
  const o = De(e.id);
  let s = [];
  if (r) {
    const c = i().document, u = fu(t, c), p = u.length > 0 ? u : Ye(t, c.documentElement);
    p.length > 0 && (s = [...s, ...p]);
  }
  if (!n)
    return s;
  let a = au(
    `[${Us}=${o}]`,
    n
  );
  return a && (a = Ye(t, a)), a = a ?? [], a.length > 0 && (s = [...s, ...a]), s;
}, du = [
  "keypress",
  "keydown",
  "keyup",
  "click",
  "dblclick",
  "input",
  "change",
  "submit"
], zs = ({
  accountId: t,
  id: e,
  theme: n,
  getWindowReference: r
}) => {
  const o = r().document.createElement(Tn);
  return n && o.setAttribute("themeId", n), o.setAttribute("accountId", t), o.setAttribute("id", De(e)), su(o, ...du), o;
}, pu = (t) => ({ experience: e }) => {
  const { theme: n, themeSystem: r, accountId: i, id: o } = e;
  if (!i) return;
  const s = t("getWindowReference"), a = s().document, c = zs({
    accountId: i,
    id: o,
    // a defined themeSystem value means the theme is an open-builder theme and so we don't need to load it via the legacy theme system
    ...!r && { theme: n },
    getWindowReference: s
  });
  a.body.append(c);
}, hu = (t) => ({ experience: e }) => {
  const r = t("getWindowReference")().document, i = De(e.id);
  Ye(
    `#${i}`,
    r.documentElement
  ).forEach((s) => r.body.removeChild(s));
}, gu = ({ getRoot: t }) => {
  const e = t();
  e.parentElement && e.remove();
}, vu = ({ getRoot: t }) => vs([
  {
    cond: "hasCustomContainer",
    actions: [
      () => {
        gu({ getRoot: t });
      }
    ]
  }
]), yu = (t) => ({ experience: e }) => (n, r) => {
  r(({ type: i }) => {
    if (i !== _i) return;
    const o = t("getWindowReference"), s = o().document, a = De(e.id);
    Ri({
      getTarget: () => Ye(
        `#${a}`,
        s.documentElement
      ),
      onRemoved: () => {
        n(ru);
      },
      getWindowReference: o
    });
  });
}, mu = ({ getRoot: t, getWindowReference: e }) => () => (
  // eslint-disable-next-line unicorn/consistent-function-scoping
  (n, r) => {
    let i;
    r(({ type: o }) => {
      if (o === js && i) {
        i();
        return;
      }
      o === _i && (i && i(), i = Ri({
        getTarget: () => [t()],
        onRemoved: () => {
          n(Ti);
        },
        getWindowReference: e
      }));
    });
  }
), qs = Cn(_i, {
  to: "themeRemovalService"
}), Eu = Cn(js, {
  to: "themeRemovalService"
});
var Hr = { exports: {} }, uo;
function Su() {
  return uo || (uo = 1, (function(t) {
    (function() {
      function e(g, w, I) {
        return g.call.apply(g.bind, arguments);
      }
      function n(g, w, I) {
        if (!g) throw Error();
        if (2 < arguments.length) {
          var N = Array.prototype.slice.call(arguments, 2);
          return function() {
            var M = Array.prototype.slice.call(arguments);
            return Array.prototype.unshift.apply(M, N), g.apply(w, M);
          };
        }
        return function() {
          return g.apply(w, arguments);
        };
      }
      function r(g, w, I) {
        return r = Function.prototype.bind && Function.prototype.bind.toString().indexOf("native code") != -1 ? e : n, r.apply(null, arguments);
      }
      var i = Date.now || function() {
        return +/* @__PURE__ */ new Date();
      };
      function o(g, w) {
        this.a = g, this.o = w || g, this.c = this.o.document;
      }
      var s = !!window.FontFace;
      function a(g, w, I, N) {
        if (w = g.c.createElement(w), I) for (var M in I) I.hasOwnProperty(M) && (M == "style" ? w.style.cssText = I[M] : w.setAttribute(M, I[M]));
        return N && w.appendChild(g.c.createTextNode(N)), w;
      }
      function c(g, w, I) {
        g = g.c.getElementsByTagName(w)[0], g || (g = document.documentElement), g.insertBefore(I, g.lastChild);
      }
      function u(g) {
        g.parentNode && g.parentNode.removeChild(g);
      }
      function p(g, w, I) {
        w = w || [], I = I || [];
        for (var N = g.className.split(/\s+/), M = 0; M < w.length; M += 1) {
          for (var F = !1, z = 0; z < N.length; z += 1) if (w[M] === N[z]) {
            F = !0;
            break;
          }
          F || N.push(w[M]);
        }
        for (w = [], M = 0; M < N.length; M += 1) {
          for (F = !1, z = 0; z < I.length; z += 1) if (N[M] === I[z]) {
            F = !0;
            break;
          }
          F || w.push(N[M]);
        }
        g.className = w.join(" ").replace(/\s+/g, " ").replace(/^\s+|\s+$/, "");
      }
      function f(g, w) {
        for (var I = g.className.split(/\s+/), N = 0, M = I.length; N < M; N++) if (I[N] == w) return !0;
        return !1;
      }
      function l(g) {
        return g.o.location.hostname || g.a.location.hostname;
      }
      function d(g, w, I) {
        function N() {
          K && M && F && (K(z), K = null);
        }
        w = a(g, "link", { rel: "stylesheet", href: w, media: "all" });
        var M = !1, F = !0, z = null, K = I || null;
        s ? (w.onload = function() {
          M = !0, N();
        }, w.onerror = function() {
          M = !0, z = Error("Stylesheet failed to load"), N();
        }) : setTimeout(function() {
          M = !0, N();
        }, 0), c(g, "head", w);
      }
      function h(g, w, I, N) {
        var M = g.c.getElementsByTagName("head")[0];
        if (M) {
          var F = a(g, "script", { src: w }), z = !1;
          return F.onload = F.onreadystatechange = function() {
            z || this.readyState && this.readyState != "loaded" && this.readyState != "complete" || (z = !0, I && I(null), F.onload = F.onreadystatechange = null, F.parentNode.tagName == "HEAD" && M.removeChild(F));
          }, M.appendChild(F), setTimeout(function() {
            z || (z = !0, I && I(Error("Script load timeout")));
          }, N || 5e3), F;
        }
        return null;
      }
      function v() {
        this.a = 0, this.c = null;
      }
      function m(g) {
        return g.a++, function() {
          g.a--, y(g);
        };
      }
      function S(g, w) {
        g.c = w, y(g);
      }
      function y(g) {
        g.a == 0 && g.c && (g.c(), g.c = null);
      }
      function x(g) {
        this.a = g || "-";
      }
      x.prototype.c = function(g) {
        for (var w = [], I = 0; I < arguments.length; I++) w.push(arguments[I].replace(/[\W_]+/g, "").toLowerCase());
        return w.join(this.a);
      };
      function T(g, w) {
        this.c = g, this.f = 4, this.a = "n";
        var I = (w || "n4").match(/^([nio])([1-9])$/i);
        I && (this.a = I[1], this.f = parseInt(I[2], 10));
      }
      function b(g) {
        return O(g) + " " + (g.f + "00") + " 300px " + A(g.c);
      }
      function A(g) {
        var w = [];
        g = g.split(/,\s*/);
        for (var I = 0; I < g.length; I++) {
          var N = g[I].replace(/['"]/g, "");
          N.indexOf(" ") != -1 || /^\d/.test(N) ? w.push("'" + N + "'") : w.push(N);
        }
        return w.join(",");
      }
      function R(g) {
        return g.a + g.f;
      }
      function O(g) {
        var w = "normal";
        return g.a === "o" ? w = "oblique" : g.a === "i" && (w = "italic"), w;
      }
      function P(g) {
        var w = 4, I = "n", N = null;
        return g && ((N = g.match(/(normal|oblique|italic)/i)) && N[1] && (I = N[1].substr(0, 1).toLowerCase()), (N = g.match(/([1-9]00|normal|bold)/i)) && N[1] && (/bold/i.test(N[1]) ? w = 7 : /[1-9]00/.test(N[1]) && (w = parseInt(N[1].substr(0, 1), 10)))), I + w;
      }
      function D(g, w) {
        this.c = g, this.f = g.o.document.documentElement, this.h = w, this.a = new x("-"), this.j = w.events !== !1, this.g = w.classes !== !1;
      }
      function L(g) {
        g.g && p(g.f, [g.a.c("wf", "loading")]), q(g, "loading");
      }
      function $(g) {
        if (g.g) {
          var w = f(g.f, g.a.c("wf", "active")), I = [], N = [g.a.c("wf", "loading")];
          w || I.push(g.a.c("wf", "inactive")), p(g.f, I, N);
        }
        q(g, "inactive");
      }
      function q(g, w, I) {
        g.j && g.h[w] && (I ? g.h[w](I.c, R(I)) : g.h[w]());
      }
      function Y() {
        this.c = {};
      }
      function G(g, w, I) {
        var N = [], M;
        for (M in w) if (w.hasOwnProperty(M)) {
          var F = g.c[M];
          F && N.push(F(w[M], I));
        }
        return N;
      }
      function nt(g, w) {
        this.c = g, this.f = w, this.a = a(this.c, "span", { "aria-hidden": "true" }, this.f);
      }
      function J(g) {
        c(g.c, "body", g.a);
      }
      function V(g) {
        return "display:block;position:absolute;top:-9999px;left:-9999px;font-size:300px;width:auto;height:auto;line-height:normal;margin:0;padding:0;font-variant:normal;white-space:nowrap;font-family:" + A(g.c) + ";" + ("font-style:" + O(g) + ";font-weight:" + (g.f + "00") + ";");
      }
      function ot(g, w, I, N, M, F) {
        this.g = g, this.j = w, this.a = N, this.c = I, this.f = M || 3e3, this.h = F || void 0;
      }
      ot.prototype.start = function() {
        var g = this.c.o.document, w = this, I = i(), N = new Promise(function(z, K) {
          function Z() {
            i() - I >= w.f ? K() : g.fonts.load(b(w.a), w.h).then(function(at) {
              1 <= at.length ? z() : setTimeout(Z, 25);
            }, function() {
              K();
            });
          }
          Z();
        }), M = null, F = new Promise(function(z, K) {
          M = setTimeout(K, w.f);
        });
        Promise.race([F, N]).then(function() {
          M && (clearTimeout(M), M = null), w.g(w.a);
        }, function() {
          w.j(w.a);
        });
      };
      function Q(g, w, I, N, M, F, z) {
        this.v = g, this.B = w, this.c = I, this.a = N, this.s = z || "BESbswy", this.f = {}, this.w = M || 3e3, this.u = F || null, this.m = this.j = this.h = this.g = null, this.g = new nt(this.c, this.s), this.h = new nt(this.c, this.s), this.j = new nt(this.c, this.s), this.m = new nt(this.c, this.s), g = new T(this.a.c + ",serif", R(this.a)), g = V(g), this.g.a.style.cssText = g, g = new T(this.a.c + ",sans-serif", R(this.a)), g = V(g), this.h.a.style.cssText = g, g = new T("serif", R(this.a)), g = V(g), this.j.a.style.cssText = g, g = new T("sans-serif", R(this.a)), g = V(g), this.m.a.style.cssText = g, J(this.g), J(this.h), J(this.j), J(this.m);
      }
      var et = { D: "serif", C: "sans-serif" }, rt = null;
      function gt() {
        if (rt === null) {
          var g = /AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent);
          rt = !!g && (536 > parseInt(g[1], 10) || parseInt(g[1], 10) === 536 && 11 >= parseInt(g[2], 10));
        }
        return rt;
      }
      Q.prototype.start = function() {
        this.f.serif = this.j.a.offsetWidth, this.f["sans-serif"] = this.m.a.offsetWidth, this.A = i(), U(this);
      };
      function xt(g, w, I) {
        for (var N in et) if (et.hasOwnProperty(N) && w === g.f[et[N]] && I === g.f[et[N]]) return !0;
        return !1;
      }
      function U(g) {
        var w = g.g.a.offsetWidth, I = g.h.a.offsetWidth, N;
        (N = w === g.f.serif && I === g.f["sans-serif"]) || (N = gt() && xt(g, w, I)), N ? i() - g.A >= g.w ? gt() && xt(g, w, I) && (g.u === null || g.u.hasOwnProperty(g.a.c)) ? tt(g, g.v) : tt(g, g.B) : W(g) : tt(g, g.v);
      }
      function W(g) {
        setTimeout(r(function() {
          U(this);
        }, g), 50);
      }
      function tt(g, w) {
        setTimeout(r(function() {
          u(this.g.a), u(this.h.a), u(this.j.a), u(this.m.a), w(this.a);
        }, g), 0);
      }
      function pt(g, w, I) {
        this.c = g, this.a = w, this.f = 0, this.m = this.j = !1, this.s = I;
      }
      var _t = null;
      pt.prototype.g = function(g) {
        var w = this.a;
        w.g && p(w.f, [w.a.c("wf", g.c, R(g).toString(), "active")], [w.a.c("wf", g.c, R(g).toString(), "loading"), w.a.c("wf", g.c, R(g).toString(), "inactive")]), q(w, "fontactive", g), this.m = !0, Dt(this);
      }, pt.prototype.h = function(g) {
        var w = this.a;
        if (w.g) {
          var I = f(w.f, w.a.c("wf", g.c, R(g).toString(), "active")), N = [], M = [w.a.c("wf", g.c, R(g).toString(), "loading")];
          I || N.push(w.a.c("wf", g.c, R(g).toString(), "inactive")), p(w.f, N, M);
        }
        q(w, "fontinactive", g), Dt(this);
      };
      function Dt(g) {
        --g.f == 0 && g.j && (g.m ? (g = g.a, g.g && p(g.f, [g.a.c("wf", "active")], [g.a.c("wf", "loading"), g.a.c("wf", "inactive")]), q(g, "active")) : $(g.a));
      }
      function Zt(g) {
        this.j = g, this.a = new Y(), this.h = 0, this.f = this.g = !0;
      }
      Zt.prototype.load = function(g) {
        this.c = new o(this.j, g.context || this.j), this.g = g.events !== !1, this.f = g.classes !== !1, kt(this, new D(this.c, g), g);
      };
      function Nt(g, w, I, N, M) {
        var F = --g.h == 0;
        (g.f || g.g) && setTimeout(function() {
          var z = M || null, K = N || null || {};
          if (I.length === 0 && F) $(w.a);
          else {
            w.f += I.length, F && (w.j = F);
            var Z, at = [];
            for (Z = 0; Z < I.length; Z++) {
              var dt = I[Z], bt = K[dt.c], Tt = w.a, Gt = dt;
              if (Tt.g && p(Tt.f, [Tt.a.c("wf", Gt.c, R(Gt).toString(), "loading")]), q(Tt, "fontloading", Gt), Tt = null, _t === null) if (window.FontFace) {
                var Gt = /Gecko.*Firefox\/(\d+)/.exec(window.navigator.userAgent), fn = /OS X.*Version\/10\..*Safari/.exec(window.navigator.userAgent) && /Apple/.exec(window.navigator.vendor);
                _t = Gt ? 42 < parseInt(Gt[1], 10) : !fn;
              } else _t = !1;
              _t ? Tt = new ot(r(w.g, w), r(w.h, w), w.c, dt, w.s, bt) : Tt = new Q(r(w.g, w), r(w.h, w), w.c, dt, w.s, z, bt), at.push(Tt);
            }
            for (Z = 0; Z < at.length; Z++) at[Z].start();
          }
        }, 0);
      }
      function kt(g, w, I) {
        var M = [], N = I.timeout;
        L(w);
        var M = G(g.a, I, g.c), F = new pt(g.c, w, N);
        for (g.h = M.length, w = 0, I = M.length; w < I; w++) M[w].load(function(z, K, Z) {
          Nt(g, F, z, K, Z);
        });
      }
      function Jt(g, w) {
        this.c = g, this.a = w;
      }
      Jt.prototype.load = function(g) {
        function w() {
          if (F["__mti_fntLst" + N]) {
            var z = F["__mti_fntLst" + N](), K = [], Z;
            if (z) for (var at = 0; at < z.length; at++) {
              var dt = z[at].fontfamily;
              z[at].fontStyle != null && z[at].fontWeight != null ? (Z = z[at].fontStyle + z[at].fontWeight, K.push(new T(dt, Z))) : K.push(new T(dt));
            }
            g(K);
          } else setTimeout(function() {
            w();
          }, 50);
        }
        var I = this, N = I.a.projectId, M = I.a.version;
        if (N) {
          var F = I.c.o;
          h(this.c, (I.a.api || "https://fast.fonts.net/jsapi") + "/" + N + ".js" + (M ? "?v=" + M : ""), function(z) {
            z ? g([]) : (F["__MonotypeConfiguration__" + N] = function() {
              return I.a;
            }, w());
          }).id = "__MonotypeAPIScript__" + N;
        } else g([]);
      };
      function ke(g, w) {
        this.c = g, this.a = w;
      }
      ke.prototype.load = function(g) {
        var w, I, N = this.a.urls || [], M = this.a.families || [], F = this.a.testStrings || {}, z = new v();
        for (w = 0, I = N.length; w < I; w++) d(this.c, N[w], m(z));
        var K = [];
        for (w = 0, I = M.length; w < I; w++) if (N = M[w].split(":"), N[1]) for (var Z = N[1].split(","), at = 0; at < Z.length; at += 1) K.push(new T(N[0], Z[at]));
        else K.push(new T(N[0]));
        S(z, function() {
          g(K, F);
        });
      };
      function fe(g, w) {
        g ? this.c = g : this.c = rn, this.a = [], this.f = [], this.g = w || "";
      }
      var rn = "https://fonts.googleapis.com/css";
      function on(g, w) {
        for (var I = w.length, N = 0; N < I; N++) {
          var M = w[N].split(":");
          M.length == 3 && g.f.push(M.pop());
          var F = "";
          M.length == 2 && M[1] != "" && (F = ":"), g.a.push(M.join(F));
        }
      }
      function sn(g) {
        if (g.a.length == 0) throw Error("No fonts to load!");
        if (g.c.indexOf("kit=") != -1) return g.c;
        for (var w = g.a.length, I = [], N = 0; N < w; N++) I.push(g.a[N].replace(/ /g, "+"));
        return w = g.c + "?family=" + I.join("%7C"), 0 < g.f.length && (w += "&subset=" + g.f.join(",")), 0 < g.g.length && (w += "&text=" + encodeURIComponent(g.g)), w;
      }
      function de(g) {
        this.f = g, this.a = [], this.c = {};
      }
      var pe = { latin: "BESbswy", "latin-ext": "çöüğş", cyrillic: "йяЖ", greek: "αβΣ", khmer: "កខគ", Hanuman: "កខគ" }, an = { thin: "1", extralight: "2", "extra-light": "2", ultralight: "2", "ultra-light": "2", light: "3", regular: "4", book: "4", medium: "5", "semi-bold": "6", semibold: "6", "demi-bold": "6", demibold: "6", bold: "7", "extra-bold": "8", extrabold: "8", "ultra-bold": "8", ultrabold: "8", black: "9", heavy: "9", l: "3", r: "4", b: "7" }, cn = { i: "i", italic: "i", n: "n", normal: "n" }, ln = /^(thin|(?:(?:extra|ultra)-?)?light|regular|book|medium|(?:(?:semi|demi|extra|ultra)-?)?bold|black|heavy|l|r|b|[1-9]00)?(n|i|normal|italic)?$/;
      function un(g) {
        for (var w = g.f.length, I = 0; I < w; I++) {
          var N = g.f[I].split(":"), M = N[0].replace(/\+/g, " "), F = ["n4"];
          if (2 <= N.length) {
            var z, K = N[1];
            if (z = [], K) for (var K = K.split(","), Z = K.length, at = 0; at < Z; at++) {
              var dt;
              if (dt = K[at], dt.match(/^[\w-]+$/)) {
                var bt = ln.exec(dt.toLowerCase());
                if (bt == null) dt = "";
                else {
                  if (dt = bt[2], dt = dt == null || dt == "" ? "n" : cn[dt], bt = bt[1], bt == null || bt == "") bt = "4";
                  else var Tt = an[bt], bt = Tt || (isNaN(bt) ? "4" : bt.substr(0, 1));
                  dt = [dt, bt].join("");
                }
              } else dt = "";
              dt && z.push(dt);
            }
            0 < z.length && (F = z), N.length == 3 && (N = N[2], z = [], N = N ? N.split(",") : z, 0 < N.length && (N = pe[N[0]]) && (g.c[M] = N));
          }
          for (g.c[M] || (N = pe[M]) && (g.c[M] = N), N = 0; N < F.length; N += 1) g.a.push(new T(M, F[N]));
        }
      }
      function Le(g, w) {
        this.c = g, this.a = w;
      }
      var he = { Arimo: !0, Cousine: !0, Tinos: !0 };
      Le.prototype.load = function(g) {
        var w = new v(), I = this.c, N = new fe(this.a.api, this.a.text), M = this.a.families;
        on(N, M);
        var F = new de(M);
        un(F), d(I, sn(N), m(w)), S(w, function() {
          g(F.a, F.c, he);
        });
      };
      function Qt(g, w) {
        this.c = g, this.a = w;
      }
      Qt.prototype.load = function(g) {
        var w = this.a.id, I = this.c.o;
        w ? h(this.c, (this.a.api || "https://use.typekit.net") + "/" + w + ".js", function(N) {
          if (N) g([]);
          else if (I.Typekit && I.Typekit.config && I.Typekit.config.fn) {
            N = I.Typekit.config.fn;
            for (var M = [], F = 0; F < N.length; F += 2) for (var z = N[F], K = N[F + 1], Z = 0; Z < K.length; Z++) M.push(new T(z, K[Z]));
            try {
              I.Typekit.load({ events: !1, classes: !1, async: !0 });
            } catch {
            }
            g(M);
          }
        }, 2e3) : g([]);
      };
      function xe(g, w) {
        this.c = g, this.f = w, this.a = [];
      }
      xe.prototype.load = function(g) {
        var w = this.f.id, I = this.c.o, N = this;
        w ? (I.__webfontfontdeckmodule__ || (I.__webfontfontdeckmodule__ = {}), I.__webfontfontdeckmodule__[w] = function(M, F) {
          for (var z = 0, K = F.fonts.length; z < K; ++z) {
            var Z = F.fonts[z];
            N.a.push(new T(Z.name, P("font-weight:" + Z.weight + ";font-style:" + Z.style)));
          }
          g(N.a);
        }, h(this.c, (this.f.api || "https://f.fontdeck.com/s/css/js/") + l(this.c) + "/" + w + ".js", function(M) {
          M && g([]);
        })) : g([]);
      };
      var C = new Zt(window);
      C.a.c.custom = function(g, w) {
        return new ke(w, g);
      }, C.a.c.fontdeck = function(g, w) {
        return new xe(w, g);
      }, C.a.c.monotype = function(g, w) {
        return new Jt(w, g);
      }, C.a.c.typekit = function(g, w) {
        return new Qt(w, g);
      }, C.a.c.google = function(g, w) {
        return new Le(w, g);
      };
      var j = { load: r(C.load, C) };
      t.exports ? t.exports = j : (window.WebFont = j, window.WebFontConfig && C.load(window.WebFontConfig));
    })();
  })(Hr)), Hr.exports;
}
var bu = Su();
const xu = /* @__PURE__ */ Ie(bu);
var Gn = { exports: {} }, fo;
function wu() {
  if (fo) return Gn.exports;
  fo = 1;
  function t(f, l) {
    var d = l && l.cache ? l.cache : p, h = l && l.serializer ? l.serializer : c, v = l && l.strategy ? l.strategy : o;
    return v(f, {
      cache: d,
      serializer: h
    });
  }
  function e(f) {
    return f == null || typeof f == "number" || typeof f == "boolean";
  }
  function n(f, l, d, h) {
    var v = e(h) ? h : d(h), m = l.get(v);
    return typeof m > "u" && (m = f.call(this, h), l.set(v, m)), m;
  }
  function r(f, l, d) {
    var h = Array.prototype.slice.call(arguments, 3), v = d(h), m = l.get(v);
    return typeof m > "u" && (m = f.apply(this, h), l.set(v, m)), m;
  }
  function i(f, l, d, h, v) {
    return d.bind(
      l,
      f,
      h,
      v
    );
  }
  function o(f, l) {
    var d = f.length === 1 ? n : r;
    return i(
      f,
      this,
      d,
      l.cache.create(),
      l.serializer
    );
  }
  function s(f, l) {
    var d = r;
    return i(
      f,
      this,
      d,
      l.cache.create(),
      l.serializer
    );
  }
  function a(f, l) {
    var d = n;
    return i(
      f,
      this,
      d,
      l.cache.create(),
      l.serializer
    );
  }
  function c() {
    return JSON.stringify(arguments);
  }
  function u() {
    this.cache = /* @__PURE__ */ Object.create(null);
  }
  u.prototype.has = function(f) {
    return f in this.cache;
  }, u.prototype.get = function(f) {
    return this.cache[f];
  }, u.prototype.set = function(f, l) {
    this.cache[f] = l;
  };
  var p = {
    create: function() {
      return new u();
    }
  };
  return Gn.exports = t, Gn.exports.strategies = {
    variadic: s,
    monadic: a
  }, Gn.exports;
}
var _u = wu();
const Tu = /* @__PURE__ */ Ie(_u), Ru = window.AppcuesBundleSettings?.VERSION === "dev" ? "https://fast.appcues.com/v1" : window.AppcuesBundleSettings?.GENERIC_BUNDLE_DOMAIN ? `${window.AppcuesBundleSettings.GENERIC_BUNDLE_DOMAIN}/v1` : "https://fast.appcues.com/v1", Cu = 9999;
let gr = {
  fastBaseUrl: null,
  // null means use default
  useAssetsPath: !1
  // when true, use simplified theme path format
};
const Ou = (t = {}) => {
  gr = { ...gr, ...t };
}, Au = () => gr.fastBaseUrl ?? Ru, po = () => gr.useAssetsPath;
function Nu(t) {
  return t.replace(/\/+$/, "");
}
const Pu = Tu(
  (t, e) => {
    const n = Au();
    if (po()) {
      const r = Nu(n);
      return fetch(
        `${r}/themes/${encodeURIComponent(t)}.json`
      ).then((i) => i.json());
    }
    return fetch(`${n}/accounts/${e}/styles/${t}`).then(
      (r) => r.json()
    );
  },
  {
    serializer: ([t, e]) => `${t}:${e}:${po()}`
  }
), Iu = (t, e) => {
  const n = {
    classes: !1
  };
  e != null && (n.custom = {
    urls: [e.general.headerFontUrl, e.general.bodyFontUrl]
  }), t && (n.typekit = {
    id: t
  }), Object.keys(n).length > 1 && xu.load(n);
}, ho = (t, e, n) => {
  if (!t) return;
  const i = (n.ownerDocument || document).createElement("style");
  i.innerHTML = `${t}`, e && i.classList.add(`theme-${e}`), n.shadowRoot.prepend(i);
}, Ws = async (t) => {
  const e = t.getAttribute("themeId"), n = t.getAttribute("accountId"), r = await Pu(e, n).catch(() => {
  }), { globalStyling: i, theme: o, typekitId: s } = r ?? {
    globalStyling: "",
    theme: {},
    typekitId: ""
  }, a = o?.json?.typekitId ?? s;
  Iu(a, o?.json), ho(o?.css, e, t), ho(i, e, t);
}, Du = async (t, e) => {
  await Ws(t), e && t.shadowRoot.querySelectorAll(
    `.theme-${e}`
  ).forEach((r) => r.remove());
}, ku = ut({
  step: ({ step: t }, e) => ({
    ...t,
    virtualizedContent: e.virtualizedContent
  })
}), Lu = (t) => ut({
  step: (e, n) => ({
    stepConfig: n.stepConfig,
    virtualizedContent: t(n.stepConfig)
  })
}), $u = ut({
  experience: (t, e) => e.experience,
  step: ({ step: t }, e) => ({
    ...t,
    ...e.stepConfig
  })
}), Mu = Ut(Bl), Hu = Ut(({ step: t }) => ({
  type: Ns,
  id: t.id
})), ju = (t, { styles: e, getRoot: n }) => {
  const r = n();
  r && Object.entries(e).forEach(([i, o]) => {
    i.startsWith("--") ? r.style.setProperty(i, o) : r.style[i] = o;
  });
}, Uu = (t) => (e) => {
  const { theme: n, themeSystem: r, id: i } = e.experience;
  if (r || !n) return;
  const a = t("getWindowReference")().document.documentElement.querySelector(
    `#${De(i)}`
  ), c = a.getAttribute("themeId");
  a?.setAttribute("themeId", n), Du(a, c);
}, Fu = (t) => ut({
  step: ({ step: e }) => {
    if (e.type !== "tooltip" || e.contentType === "application/json")
      return e;
    const n = Object.entries(e.actions).filter(
      ([, i]) => i.find((o) => o.on === "click")
    ).map(([i]) => i), r = e.traits.filter(({ config: i }) => i.targetId).map(({ config: i }) => i.targetId);
    return {
      ...e,
      virtualizedContent: t(e, {
        interactiveEls: n,
        focusableEls: r
      })
    };
  }
}), Bu = vs([
  {
    cond: (t, e) => e.errorEvent?.type === Ti,
    actions: [
      gs({
        type: Wl,
        isAutoRecoverEvent: !0
      })
    ]
  }
]), zu = ut({
  actionsRunning: !0
}), qu = ut({
  actionsRunning: !1
}), Wu = (t, e) => {
  const n = e.changedExperienceTraits && e.changedExperienceTraits.changedTraits.length > 0, r = e.changedExperienceTraits && (e.changedExperienceTraits.addedTraits.length > 0 || e.changedExperienceTraits.removedTraits.length > 0), i = e.changedStepTraits && e.changedStepTraits.changedTraits.length > 0, o = e.changedStepTraits && (e.changedStepTraits.addedTraits.length > 0 || e.changedStepTraits.removedTraits.length > 0);
  return r || o ? !1 : !!(n || i);
};
const Vu = "Key name should be string and callback a valid function", Vs = () => {
  const t = /* @__PURE__ */ new Map(), e = (r) => t.get(r);
  return {
    getCallback: e,
    registerCallback: (r, i) => {
      if (e(r), typeof r != "string" || typeof i != "function")
        throw new TypeError(Vu);
      t.set(r, i);
    }
  };
}, Gs = ({ getTrait: t, trait: e, ...n }) => {
  const r = t(e.type);
  r && r(n, e.config ?? {});
}, { getCallback: Ks, registerCallback: St } = Vs();
let Gu = (t = 21) => crypto.getRandomValues(new Uint8Array(t)).reduce((e, n) => (n &= 63, n < 36 ? e += n.toString(36) : n < 62 ? e += (n - 26).toString(36).toUpperCase() : n > 62 ? e += "-" : e += "_", e), "");
const Ku = ({
  experience: t,
  callback: e,
  step: n,
  findId: r,
  getContainer: i,
  getWindowReference: o
}) => {
  const s = (c, { forwardToParent: u = !1 } = {}) => {
    const p = ({ type: f, ...l }) => e(u ? {
      ...l,
      eventType: f,
      type: Ql
    } : { type: f, ...l });
    return {
      querySelector: (f) => Bs(f, {
        step: n,
        checkOutsideContainer: !1,
        stepContainer: i(),
        getWindowReference: o
      }),
      start: () => p({
        type: Ts,
        id: c.id
      }),
      stop: (f) => {
        p({
          type: bi,
          id: c.id,
          onStopped: f
        });
      },
      setStepContainerTarget: (f) => {
        p({
          type: Cs,
          id: c.id,
          container: f
        });
      },
      recover: ({ errorId: f }) => {
        p({
          type: ql,
          id: c.id,
          errorId: f
        });
      },
      dismissExperience: () => p({
        type: Zl
      }),
      snoozeExperience: () => p({
        type: Jl
      }),
      seen: () => p({
        type: Xl,
        id: c.id
      }),
      getConfig: () => c,
      interaction: (f, l) => p({
        type: Kl,
        id: c.id,
        interactionType: f,
        interactionData: l
      }),
      extendedEvent: (f, l) => p({
        type: zl,
        id: c.id,
        name: f,
        ...l
      })
    };
  }, a = t.steps.map(
    (c) => s(c, { forwardToParent: !!n })
  );
  return n ? {
    getRootNodeId: () => r(n.virtualizedContent),
    steps: a,
    step: s(n, { forwardToParent: !1 })
  } : {
    getRootNodeId: () => r(n.virtualizedContent),
    steps: a
  };
}, Ci = ({
  experience: t,
  step: e,
  overrideStyle: n,
  getContainer: r,
  getRoot: i,
  callback: o,
  get: s,
  getAction: a = () => null,
  handleNavigation: c
}) => {
  const { findId: u } = s("vNodeHandlers"), p = s("getWindowReference"), f = Ku({
    experience: t,
    step: e,
    callback: o,
    findId: u,
    getContainer: r,
    getWindowReference: p
  }), v = {
    getContainer: r,
    querySelector: (m) => Bs(m, {
      step: e,
      checkOutsideContainer: !0,
      stepContainer: r(),
      getWindowReference: p
    }),
    reportError: (m) => {
      const S = Gu();
      return o({
        type: Gl,
        message: m,
        errorId: S
      }), S;
    },
    onElementInserted: (m) => lu({ ...m, getWindowReference: p }),
    onElementRemoved: (m) => Ri({ ...m, getWindowReference: p }),
    ...f,
    stopExperience: () => o(Ce),
    getExperienceId: () => t.id,
    getWindowReference: p,
    sendEvent: s("sendEvent"),
    sendCustomEvent: s("sendCustomEvent"),
    showFlow: s("showFlow"),
    updateUserProfile: s("updateUserProfile"),
    handleNavigation: (m) => c({
      ...m,
      experienceId: t.id,
      stepId: e.id
    }),
    getAction: (m) => a(`${t.id}.${m}`) ?? a(`${e.id}.${m}`) ?? a(m)
  };
  return n ? {
    updateStyle: (y, x) => {
      n(y, x), o({
        type: Rs,
        id: e.id
      });
    },
    updateRootStyle: (y, x = {}) => {
      o({
        type: As,
        styles: y,
        options: x,
        getRoot: i
      });
    },
    ...v
  } : v;
}, go = "formData.", Xu = "a, button, video, input, textarea, select, form", Yu = (t, e) => {
  if (e.startsWith(go)) {
    const n = e.replace(go, "");
    return new FormData(t.target).get(n);
  }
  return kl(t, e);
}, { getCallback: re, registerCallback: ce } = Vs(), Xs = (t, e, n) => {
  const r = {
    target: e.target,
    detail: e.detail
  };
  return Object.entries(t).reduce(
    (i, [o, s]) => {
      const a = Yu(r, o);
      return a ? Dl(i, s, a) : i;
    },
    n
  );
}, Zu = ({
  step: t,
  experience: e,
  overrideStyle: n,
  getContainer: r,
  callback: i,
  get: o
}) => {
  const s = o("getWindowReference"), a = [];
  return Object.entries(t.actions ?? {}).forEach(([c, u]) => {
    if (!u.some((l) => l.config?.external)) return;
    let p;
    try {
      p = Array.from(
        s().document.querySelectorAll(c)
      );
    } catch {
      return;
    }
    if (p.length === 0) return;
    const f = {};
    u.forEach(
      ({ on: l, type: d, config: h, allowedKeys: v, mapEventToConfig: m }) => {
        if (!h?.external || l.startsWith("hooks/")) return;
        const S = re(`${e.id}.${d}`) ?? re(`${t.id}.${d}`) ?? re(d);
        f[l] || (f[l] = []), S && f[l].push([
          S,
          h,
          v,
          m
        ]);
      }
    ), Object.entries(f).forEach(([l, d]) => {
      const h = (v) => {
        i({ type: Is });
        const m = Ci({
          experience: e,
          step: t,
          overrideStyle: n,
          getContainer: r,
          callback: i,
          get: o,
          getAction: re
        });
        try {
          d.forEach(([S, y, x, T]) => {
            if (!(x && !x.includes(v.code)))
              if (T) {
                const b = {
                  ...y,
                  ...Xs(T, v, y)
                };
                S(b, m);
              } else
                S(y, m);
          });
        } catch {
          m.reportError(
            "something bad happened while running an action."
          );
        } finally {
          i({ type: Ds });
        }
      };
      p.forEach((v) => {
        v.addEventListener(l, h), a.push({ el: v, event: l, handler: h });
      });
    });
  }), () => {
    a.forEach(
      ({ el: c, event: u, handler: p }) => c.removeEventListener(u, p)
    );
  };
}, Ju = ({ overrideStyle: t, getContainer: e }, n) => () => (
  // eslint-disable-next-line unicorn/consistent-function-scoping
  ((r, i) => {
    let o = () => {
    };
    return i(({ type: s, step: a, experience: c }) => {
      if (s === Rr) {
        o();
        try {
          const { findId: u, traverseTree: p, injectHandlers: f } = n("vNodeHandlers"), l = JSON.parse(
            JSON.stringify(a.virtualizedContent)
          );
          p(l, (h) => {
            const v = u(h);
            if (!a.actions[v]) return;
            const m = {}, S = (T, b) => {
              r({
                type: Is
              });
              const A = Ci({
                experience: c,
                step: a,
                overrideStyle: t,
                getContainer: e,
                callback: r,
                get: n,
                getAction: re,
                handleNavigation: n("handleNavigation")
              });
              try {
                m[T].forEach(([R, O, P]) => {
                  if (P && b) {
                    const D = {
                      ...O,
                      ...Xs(
                        P,
                        b,
                        O
                      )
                    };
                    R(D, A);
                  } else
                    R(O, A);
                });
              } catch {
                A.reportError(
                  "something bad happened while running an action."
                );
              } finally {
                r({
                  type: Ds
                });
              }
            }, y = {}, x = a.actions[v].reduce(
              (T, {
                on: b,
                type: A,
                config: R,
                allowedKeys: O,
                mapEventToConfig: P,
                guardInteractiveChildren: D
              }) => {
                D && (y[b] = !0);
                const L = re(`${c.id}.${A}`) ?? re(`${a.id}.${A}`) ?? re(A);
                return m[b] || (m[b] = []), L && m[b].push([L, R, P]), b.startsWith("hooks/") ? T.hook[b.replace("hooks/", "")] = () => S(b) : T.on[b] = ($) => {
                  if (!(O && !O.includes($.code))) {
                    if (y[b]) {
                      const q = $.target.closest(
                        Xu
                      );
                      if (q && q !== $.currentTarget)
                        return;
                    }
                    $.preventDefault(), $.stopPropagation(), S(b, $);
                  }
                }, T;
              },
              {
                on: {},
                hook: {}
              }
            );
            h = f(h, x);
          }), r({
            type: Os,
            virtualizedContent: l
          }), o = Zu({
            step: a,
            experience: c,
            overrideStyle: t,
            getContainer: e,
            callback: r,
            get: n
          });
        } catch {
          r(iu);
        }
      }
    }), () => o();
  })
), Qu = ({ addHook: t }) => (e) => (n) => {
  const { step: r } = e;
  try {
    r.traits.forEach(
      (i) => Gs({
        getTrait: Ks,
        addHook: (o, s) => {
          t(o, { callback: s, traitId: i.id });
        },
        registerAction: (o, s) => {
          ce(`${r.id}.${i.type}.${o}`, s);
        },
        trait: i
      })
    ), n(Rr);
  } catch {
    n(Fs);
  }
}, tf = ({ applyOverridesToVnode: t }) => {
  let e = {};
  const n = (s) => (a, c) => {
    e[a] || (e[a] = {}), e[a][s] || (e[a][s] = {}), e[a][s] = {
      ...e[a][s],
      ...c
    };
  }, r = (s) => e[s], i = () => {
    e = {};
  }, o = ut(({ step: s }) => ({
    step: {
      ...s,
      virtualizedContent: t(
        s.virtualizedContent,
        r
      )
    }
  }));
  return {
    createOverrideCallback: n,
    getOverrides: r,
    applyOverrides: o,
    clearOverrides: i
  };
};
function ef(t, e) {
  return document.createElement(t, e);
}
function nf(t, e, n) {
  return document.createElementNS(t, e, n);
}
function rf() {
  return Oe(document.createDocumentFragment());
}
function of(t) {
  return document.createTextNode(t);
}
function sf(t) {
  return document.createComment(t);
}
function af(t, e, n) {
  if (ie(t)) {
    let r = t;
    for (; r && ie(r); )
      r = Oe(r).parent;
    t = r ?? t;
  }
  ie(e) && (e = Oe(e, t)), n && ie(n) && (n = Oe(n).firstChildNode), t.insertBefore(e, n);
}
function cf(t, e) {
  t.removeChild(e);
}
function lf(t, e) {
  ie(e) && (e = Oe(e, t)), t.appendChild(e);
}
function Ys(t) {
  if (ie(t)) {
    for (; t && ie(t); )
      t = Oe(t).parent;
    return t ?? null;
  }
  return t.parentNode;
}
function uf(t) {
  var e;
  if (ie(t)) {
    const n = Oe(t), r = Ys(n);
    if (r && n.lastChildNode) {
      const i = Array.from(r.childNodes), o = i.indexOf(n.lastChildNode);
      return (e = i[o + 1]) !== null && e !== void 0 ? e : null;
    }
    return null;
  }
  return t.nextSibling;
}
function ff(t) {
  return t.tagName;
}
function df(t, e) {
  t.textContent = e;
}
function pf(t) {
  return t.textContent;
}
function hf(t) {
  return t.nodeType === 1;
}
function gf(t) {
  return t.nodeType === 3;
}
function vf(t) {
  return t.nodeType === 8;
}
function ie(t) {
  return t.nodeType === 11;
}
function Oe(t, e) {
  var n, r, i;
  const o = t;
  return (n = o.parent) !== null && n !== void 0 || (o.parent = e ?? null), (r = o.firstChildNode) !== null && r !== void 0 || (o.firstChildNode = t.firstChild), (i = o.lastChildNode) !== null && i !== void 0 || (o.lastChildNode = t.lastChild), o;
}
const Oi = {
  createElement: ef,
  createElementNS: nf,
  createTextNode: of,
  createDocumentFragment: rf,
  createComment: sf,
  insertBefore: af,
  removeChild: cf,
  appendChild: lf,
  parentNode: Ys,
  nextSibling: uf,
  tagName: ff,
  setTextContent: df,
  getTextContent: pf,
  isElement: hf,
  isText: gf,
  isComment: vf,
  isDocumentFragment: ie
};
function It(t, e, n, r, i) {
  const o = e === void 0 ? void 0 : e.key;
  return { sel: t, data: e, children: n, text: r, elm: i, key: o };
}
const Ze = Array.isArray;
function Ae(t) {
  return typeof t == "string" || typeof t == "number" || t instanceof String || t instanceof Number;
}
const jr = It("", {}, [], void 0, void 0);
function vn(t, e) {
  var n, r;
  const i = t.key === e.key, o = ((n = t.data) === null || n === void 0 ? void 0 : n.is) === ((r = e.data) === null || r === void 0 ? void 0 : r.is), s = t.sel === e.sel, a = !t.sel && t.sel === e.sel ? typeof t.text == typeof e.text : !0;
  return s && i && o && a;
}
function yf() {
  throw new Error("The document fragment is not supported on this platform.");
}
function mf(t, e) {
  return t.isElement(e);
}
function Ef(t, e) {
  return t.isDocumentFragment(e);
}
function Sf(t, e, n) {
  var r;
  const i = {};
  for (let o = e; o <= n; ++o) {
    const s = (r = t[o]) === null || r === void 0 ? void 0 : r.key;
    s !== void 0 && (i[s] = o);
  }
  return i;
}
const bf = [
  "create",
  "update",
  "remove",
  "destroy",
  "pre",
  "post"
];
function Zs(t, e, n) {
  const r = {
    create: [],
    update: [],
    remove: [],
    destroy: [],
    pre: [],
    post: []
  }, i = e !== void 0 ? e : Oi;
  for (const h of bf)
    for (const v of t) {
      const m = v[h];
      m !== void 0 && r[h].push(m);
    }
  function o(h) {
    const v = h.id ? "#" + h.id : "", m = h.getAttribute("class"), S = m ? "." + m.split(" ").join(".") : "";
    return It(i.tagName(h).toLowerCase() + v + S, {}, [], void 0, h);
  }
  function s(h) {
    return It(void 0, {}, [], void 0, h);
  }
  function a(h, v) {
    return function() {
      if (--v === 0) {
        const S = i.parentNode(h);
        S !== null && i.removeChild(S, h);
      }
    };
  }
  function c(h, v) {
    var m, S, y, x, T;
    let b;
    const A = h.data, R = A?.hook;
    (m = R?.init) === null || m === void 0 || m.call(R, h);
    const O = h.children, P = h.sel;
    if (P === "!")
      (S = h.text) !== null && S !== void 0 || (h.text = ""), h.elm = i.createComment(h.text);
    else if (P === "")
      h.elm = i.createTextNode(h.text);
    else if (P !== void 0) {
      const D = P.indexOf("#"), L = P.indexOf(".", D), $ = D > 0 ? D : P.length, q = L > 0 ? L : P.length, Y = D !== -1 || L !== -1 ? P.slice(0, Math.min($, q)) : P, G = A?.ns, nt = G === void 0 ? i.createElement(Y, A) : i.createElementNS(G, Y, A);
      for (h.elm = nt, $ < q && nt.setAttribute("id", P.slice($ + 1, q)), L > 0 && nt.setAttribute("class", P.slice(q + 1).replace(/\./g, " ")), b = 0; b < r.create.length; ++b)
        r.create[b](jr, h);
      if (Ae(h.text) && (!Ze(O) || O.length === 0) && i.appendChild(nt, i.createTextNode(h.text)), Ze(O))
        for (b = 0; b < O.length; ++b) {
          const J = O[b];
          J != null && i.appendChild(nt, c(J, v));
        }
      R !== void 0 && ((y = R.create) === null || y === void 0 || y.call(R, jr, h), R.insert !== void 0 && v.push(h));
    } else if (!((x = n?.experimental) === null || x === void 0) && x.fragments && h.children) {
      for (h.elm = ((T = i.createDocumentFragment) !== null && T !== void 0 ? T : yf)(), b = 0; b < r.create.length; ++b)
        r.create[b](jr, h);
      for (b = 0; b < h.children.length; ++b) {
        const D = h.children[b];
        D != null && i.appendChild(h.elm, c(D, v));
      }
    } else
      h.elm = i.createTextNode(h.text);
    return h.elm;
  }
  function u(h, v, m, S, y, x) {
    for (; S <= y; ++S) {
      const T = m[S];
      T != null && i.insertBefore(h, c(T, x), v);
    }
  }
  function p(h) {
    var v, m;
    const S = h.data;
    if (S !== void 0) {
      (m = (v = S?.hook) === null || v === void 0 ? void 0 : v.destroy) === null || m === void 0 || m.call(v, h);
      for (let y = 0; y < r.destroy.length; ++y)
        r.destroy[y](h);
      if (h.children !== void 0)
        for (let y = 0; y < h.children.length; ++y) {
          const x = h.children[y];
          x != null && typeof x != "string" && p(x);
        }
    }
  }
  function f(h, v, m, S) {
    for (var y, x; m <= S; ++m) {
      let T;
      const b = v[m];
      if (b != null)
        if (b.sel !== void 0) {
          p(b), T = r.remove.length + 1;
          const A = a(b.elm, T);
          for (let O = 0; O < r.remove.length; ++O)
            r.remove[O](b, A);
          const R = (x = (y = b?.data) === null || y === void 0 ? void 0 : y.hook) === null || x === void 0 ? void 0 : x.remove;
          R !== void 0 ? R(b, A) : A();
        } else b.children ? (p(b), f(h, b.children, 0, b.children.length - 1)) : i.removeChild(h, b.elm);
    }
  }
  function l(h, v, m, S) {
    let y = 0, x = 0, T = v.length - 1, b = v[0], A = v[T], R = m.length - 1, O = m[0], P = m[R], D, L, $, q;
    for (; y <= T && x <= R; )
      b == null ? b = v[++y] : A == null ? A = v[--T] : O == null ? O = m[++x] : P == null ? P = m[--R] : vn(b, O) ? (d(b, O, S), b = v[++y], O = m[++x]) : vn(A, P) ? (d(A, P, S), A = v[--T], P = m[--R]) : vn(b, P) ? (d(b, P, S), i.insertBefore(h, b.elm, i.nextSibling(A.elm)), b = v[++y], P = m[--R]) : vn(A, O) ? (d(A, O, S), i.insertBefore(h, A.elm, b.elm), A = v[--T], O = m[++x]) : (D === void 0 && (D = Sf(v, y, T)), L = D[O.key], L === void 0 ? (i.insertBefore(h, c(O, S), b.elm), O = m[++x]) : D[P.key] === void 0 ? (i.insertBefore(h, c(P, S), i.nextSibling(A.elm)), P = m[--R]) : ($ = v[L], $.sel !== O.sel ? i.insertBefore(h, c(O, S), b.elm) : (d($, O, S), v[L] = void 0, i.insertBefore(h, $.elm, b.elm)), O = m[++x]));
    x <= R && (q = m[R + 1] == null ? null : m[R + 1].elm, u(h, q, m, x, R, S)), y <= T && f(h, v, y, T);
  }
  function d(h, v, m) {
    var S, y, x, T, b, A, R, O;
    const P = (S = v.data) === null || S === void 0 ? void 0 : S.hook;
    (y = P?.prepatch) === null || y === void 0 || y.call(P, h, v);
    const D = v.elm = h.elm;
    if (h === v)
      return;
    if (v.data !== void 0 || v.text !== void 0 && v.text !== h.text) {
      (x = v.data) !== null && x !== void 0 || (v.data = {}), (T = h.data) !== null && T !== void 0 || (h.data = {});
      for (let q = 0; q < r.update.length; ++q)
        r.update[q](h, v);
      (R = (A = (b = v.data) === null || b === void 0 ? void 0 : b.hook) === null || A === void 0 ? void 0 : A.update) === null || R === void 0 || R.call(A, h, v);
    }
    const L = h.children, $ = v.children;
    v.text === void 0 ? L !== void 0 && $ !== void 0 ? L !== $ && l(D, L, $, m) : $ !== void 0 ? (h.text !== void 0 && i.setTextContent(D, ""), u(D, null, $, 0, $.length - 1, m)) : L !== void 0 ? f(D, L, 0, L.length - 1) : h.text !== void 0 && i.setTextContent(D, "") : h.text !== v.text && (L !== void 0 && f(D, L, 0, L.length - 1), i.setTextContent(D, v.text)), (O = P?.postpatch) === null || O === void 0 || O.call(P, h, v);
  }
  return function(v, m) {
    let S, y, x;
    const T = [];
    for (S = 0; S < r.pre.length; ++S)
      r.pre[S]();
    for (mf(i, v) ? v = o(v) : Ef(i, v) && (v = s(v)), vn(v, m) ? d(v, m, T) : (y = v.elm, x = i.parentNode(y), c(m, T), x !== null && (i.insertBefore(x, m.elm, i.nextSibling(y)), f(x, [v], 0, 0))), S = 0; S < T.length; ++S)
      T[S].data.hook.insert(T[S]);
    for (S = 0; S < r.post.length; ++S)
      r.post[S]();
    return m;
  };
}
function Cr(t, e, n) {
  if (t.ns = "http://www.w3.org/2000/svg", n !== "foreignObject" && e !== void 0)
    for (let r = 0; r < e.length; ++r) {
      const i = e[r];
      if (typeof i == "string")
        continue;
      const o = i.data;
      o !== void 0 && Cr(o, i.children, i.sel);
    }
}
function ae(t, e, n) {
  let r = {}, i, o, s;
  if (n !== void 0 ? (e !== null && (r = e), Ze(n) ? i = n : Ae(n) ? o = n.toString() : n && n.sel && (i = [n])) : e != null && (Ze(e) ? i = e : Ae(e) ? o = e.toString() : e && e.sel ? i = [e] : r = e), i !== void 0)
    for (s = 0; s < i.length; ++s)
      Ae(i[s]) && (i[s] = It(void 0, void 0, void 0, i[s], void 0));
  return t.startsWith("svg") && (t.length === 3 || t[3] === "." || t[3] === "#") && Cr(r, i, t), It(t, r, i, o, void 0);
}
function ui(t) {
  let e, n;
  if (Ze(t) ? e = t : Ae(e) ? n = t : e && e.sel && (e = [t]), e !== void 0)
    for (let r = 0; r < e.length; ++r)
      Ae(e[r]) && (e[r] = It(void 0, void 0, void 0, e[r], void 0));
  return It(void 0, {}, e, n, void 0);
}
function ir(t, e) {
  var n;
  const r = (n = e.data) === null || n === void 0 ? void 0 : n.ns;
  t.data.fn = e.data.fn, t.data.args = e.data.args, e.data = t.data, e.children = t.children, e.text = t.text, e.elm = t.elm, r && Cr(e.data, e.children, e.sel);
}
function xf(t) {
  const e = t.data, n = e.fn(...e.args);
  ir(n, t);
}
function wf(t, e) {
  let n;
  const r = t.data, i = e.data, o = r.args, s = i.args;
  if (r.fn !== i.fn || o.length !== s.length) {
    ir(i.fn(...s), e);
    return;
  }
  for (n = 0; n < s.length; ++n)
    if (o[n] !== s[n]) {
      ir(i.fn(...s), e);
      return;
    }
  ir(t, e);
}
const _f = function(e, n, r, i) {
  return i === void 0 && (i = r, r = n, n = void 0), ae(e, {
    key: n,
    hook: { init: xf, prepatch: wf },
    fn: r,
    args: i
  });
};
function Tf(t, e) {
  const n = t.data.attachData;
  e.data.attachData.placeholder = n.placeholder, e.data.attachData.real = n.real, t.elm = t.data.attachData.real;
}
function Rf(t, e) {
  e.elm = e.data.attachData.placeholder;
}
function Cf(t) {
  t.elm !== void 0 && t.elm.parentNode.removeChild(t.elm), t.elm = t.data.attachData.real;
}
function Of(t, e) {
  const n = e.elm, r = e.data.attachData, i = document.createElement("span");
  e.elm = i, r.target.appendChild(n), r.real = n, r.placeholder = i;
}
function Af(t, e) {
  e.data === void 0 && (e.data = {}), e.data.hook === void 0 && (e.data.hook = {});
  const n = e.data, r = e.data.hook;
  return n.attachData = { target: t, placeholder: void 0, real: void 0 }, r.create = Of, r.prepatch = Tf, r.postpatch = Rf, r.destroy = Cf, e;
}
function Nf(t) {
  return t.slice(5).replace(/-([a-z])/g, (e, n) => n.toUpperCase());
}
function Js(t, e) {
  var n;
  const r = e !== void 0 ? e : Oi;
  let i;
  if (r.isElement(t)) {
    const o = t.id ? "#" + t.id : "", s = (n = t.getAttribute("class")) === null || n === void 0 ? void 0 : n.match(/[^\t\r\n\f ]+/g), a = s ? "." + s.join(".") : "", c = r.tagName(t).toLowerCase() + o + a, u = {}, p = {}, f = {}, l = [];
    let d, h, v;
    const m = t.attributes, S = t.childNodes;
    for (h = 0, v = m.length; h < v; h++)
      d = m[h].nodeName, d.startsWith("data-") ? p[Nf(d)] = m[h].nodeValue || "" : d !== "id" && d !== "class" && (u[d] = m[h].nodeValue);
    for (h = 0, v = S.length; h < v; h++)
      l.push(Js(S[h], e));
    return Object.keys(u).length > 0 && (f.attrs = u), Object.keys(p).length > 0 && (f.dataset = p), c.startsWith("svg") && (c.length === 3 || c[3] === "." || c[3] === "#") && Cr(f, l, c), It(c, f, l, void 0, t);
  } else return r.isText(t) ? (i = r.getTextContent(t), It(void 0, void 0, void 0, i, t)) : r.isComment(t) ? (i = r.getTextContent(t), It("!", {}, [], i, t)) : It("", {}, [], void 0, t);
}
const Pf = "http://www.w3.org/1999/xlink", If = "http://www.w3.org/2000/xmlns/", Df = "http://www.w3.org/XML/1998/namespace", vo = 58, kf = 120, Lf = 109;
function yo(t, e) {
  let n;
  const r = e.elm;
  let i = t.data.attrs, o = e.data.attrs;
  if (!(!i && !o) && i !== o) {
    i = i || {}, o = o || {};
    for (n in o) {
      const s = o[n];
      i[n] !== s && (s === !0 ? r.setAttribute(n, "") : s === !1 ? r.removeAttribute(n) : n.charCodeAt(0) !== kf ? r.setAttribute(n, s) : n.charCodeAt(3) === vo ? r.setAttributeNS(Df, n, s) : n.charCodeAt(5) === vo ? n.charCodeAt(1) === Lf ? r.setAttributeNS(If, n, s) : r.setAttributeNS(Pf, n, s) : r.setAttribute(n, s));
    }
    for (n in i)
      n in o || r.removeAttribute(n);
  }
}
const Qs = {
  create: yo,
  update: yo
};
function mo(t, e) {
  let n, r;
  const i = e.elm;
  let o = t.data.class, s = e.data.class;
  if (!(!o && !s) && o !== s) {
    o = o || {}, s = s || {};
    for (r in o)
      o[r] && !Object.prototype.hasOwnProperty.call(s, r) && i.classList.remove(r);
    for (r in s)
      n = s[r], n !== o[r] && i.classList[n ? "add" : "remove"](r);
  }
}
const ta = { create: mo, update: mo }, Eo = /[A-Z]/g;
function So(t, e) {
  const n = e.elm;
  let r = t.data.dataset, i = e.data.dataset, o;
  if (!r && !i || r === i)
    return;
  r = r || {}, i = i || {};
  const s = n.dataset;
  for (o in r)
    o in i || (s ? o in s && delete s[o] : n.removeAttribute("data-" + o.replace(Eo, "-$&").toLowerCase()));
  for (o in i)
    r[o] !== i[o] && (s ? s[o] = i[o] : n.setAttribute("data-" + o.replace(Eo, "-$&").toLowerCase(), i[o]));
}
const $f = {
  create: So,
  update: So
};
function ea(t, e, n) {
  if (typeof t == "function")
    t.call(e, n, e);
  else if (typeof t == "object")
    for (let r = 0; r < t.length; r++)
      ea(t[r], e, n);
}
function Mf(t, e) {
  const n = t.type, r = e.data.on;
  r && r[n] && ea(r[n], e, t);
}
function Hf() {
  return function t(e) {
    Mf(e, t.vnode);
  };
}
function Ur(t, e) {
  const n = t.data.on, r = t.listener, i = t.elm, o = e && e.data.on, s = e && e.elm;
  let a;
  if (n !== o) {
    if (n && r)
      if (o)
        for (a in n)
          o[a] || i.removeEventListener(a, r, !1);
      else
        for (a in n)
          i.removeEventListener(a, r, !1);
    if (o) {
      const c = e.listener = t.listener || Hf();
      if (c.vnode = e, n)
        for (a in o)
          n[a] || s.addEventListener(a, c, !1);
      else
        for (a in o)
          s.addEventListener(a, c, !1);
    }
  }
}
const na = {
  create: Ur,
  update: Ur,
  destroy: Ur
};
function bo(t, e) {
  let n, r, i;
  const o = e.elm;
  let s = t.data.props, a = e.data.props;
  if (!(!s && !a) && s !== a) {
    s = s || {}, a = a || {};
    for (n in a)
      r = a[n], i = s[n], i !== r && (n !== "value" || o[n] !== r) && (o[n] = r);
  }
}
const ra = { create: bo, update: bo }, xo = typeof window?.requestAnimationFrame == "function" ? window.requestAnimationFrame.bind(window) : setTimeout, jf = (t) => {
  xo(() => {
    xo(t);
  });
};
let fi = !1;
function Uf(t, e, n) {
  jf(() => {
    t[e] = n;
  });
}
function wo(t, e) {
  let n, r;
  const i = e.elm;
  let o = t.data.style, s = e.data.style;
  if (!o && !s || o === s)
    return;
  o = o || {}, s = s || {};
  const a = "delayed" in o;
  for (r in o)
    r in s || (r[0] === "-" && r[1] === "-" ? i.style.removeProperty(r) : i.style[r] = "");
  for (r in s)
    if (n = s[r], r === "delayed" && s.delayed)
      for (const c in s.delayed)
        n = s.delayed[c], (!a || n !== o.delayed[c]) && Uf(i.style, c, n);
    else r !== "remove" && n !== o[r] && (r[0] === "-" && r[1] === "-" ? i.style.setProperty(r, n) : i.style[r] = n);
}
function Ff(t) {
  let e, n;
  const r = t.elm, i = t.data.style;
  if (!(!i || !(e = i.destroy)))
    for (n in e)
      r.style[n] = e[n];
}
function Bf(t, e) {
  const n = t.data.style;
  if (!n || !n.remove) {
    e();
    return;
  }
  fi || (t.elm.offsetLeft, fi = !0);
  let r;
  const i = t.elm;
  let o = 0;
  const s = n.remove;
  let a = 0;
  const c = [];
  for (r in s)
    c.push(r), i.style[r] = s[r];
  const p = getComputedStyle(i)["transition-property"].split(", ");
  for (; o < p.length; ++o)
    c.indexOf(p[o]) !== -1 && a++;
  i.addEventListener("transitionend", (f) => {
    f.target === i && --a, a === 0 && e();
  });
}
function zf() {
  fi = !1;
}
const ia = {
  pre: zf,
  create: wo,
  update: wo,
  destroy: Ff,
  remove: Bf
};
function qf(t, ...e) {
  const n = Ai(e, []);
  return n.length === 1 && !n[0].sel && n[0].text ? It(void 0, void 0, void 0, n[0].text, void 0) : It(void 0, t ?? {}, n, void 0, void 0);
}
function Ai(t, e) {
  for (const n of t)
    n != null && n !== !1 && n !== "" && (Array.isArray(n) ? Ai(n, e) : typeof n == "string" || typeof n == "number" || typeof n == "boolean" ? e.push(It(void 0, void 0, void 0, String(n), void 0)) : e.push(n));
  return e;
}
function Wf(t, e, ...n) {
  const r = Ai(n, []);
  return typeof t == "function" ? t(e, r) : r.length === 1 && !r[0].sel && r[0].text ? ae(t, e, r[0].text) : ae(t, e, r);
}
const Vf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Fragment: qf,
  array: Ze,
  attachTo: Af,
  attributesModule: Qs,
  classModule: ta,
  datasetModule: $f,
  eventListenersModule: na,
  fragment: ui,
  h: ae,
  htmlDomApi: Oi,
  init: Zs,
  jsx: Wf,
  primitive: Ae,
  propsModule: ra,
  styleModule: ia,
  thunk: _f,
  toVNode: Js,
  vnode: It
}, Symbol.toStringTag, { value: "Module" })), Gf = (...t) => (e) => t.reduce((n, r) => r(n), e), _o = (t) => t.reduce(
  (e, { callback: n, context: r }) => e.then(() => n(r)),
  Promise.resolve()
), Kf = ({
  experience: t,
  onRender: e,
  onRenderReset: n,
  wrapContent: r,
  getWindowReference: i = () => window
}) => {
  let o = null, s = null;
  const a = () => {
    const x = i().document, T = De(t.id);
    return x.documentElement.querySelector(`#${T}`);
  }, c = () => s ? s.shadowRoot : null, u = () => o ? o.shadowRoot : null, f = Gf(
    (x) => (u() !== null || c() !== null || (o = a()), x),
    r,
    ({ step: { virtualizedContent: x } }) => {
      e(
        c() ?? u(),
        x
      );
    }
  );
  return {
    render: async (x) => new Promise((T) => {
      T(f(x));
    }),
    unmount: () => e(null, ae("!")),
    setContainer: (x, { container: T }) => {
      const { theme: b, themeSystem: A, accountId: R } = x.experience, { id: O } = x.step;
      s && s.remove(), s = zs({
        accountId: R,
        id: O,
        // a defined themeSystem value means the theme is an open-builder theme and so we don't need to load it via the legacy theme system
        ...!A && { theme: b },
        getWindowReference: i
      }), T.parentNode.replaceChild(s, T);
    },
    resetRender: () => {
      o = null, s && s.remove(), s = null, n();
    },
    getContainer: () => c() ?? u() ?? a().shadowRoot,
    getRoot: () => s ?? a(),
    hasCustomContainer: (x, T) => T.type === As && T.options?.forceUpdate || !!c()
  };
}, Xf = ({ container: t, nodes: e }, n = 0) => t.replace(/<% node %>/, e[n]), Yf = (t) => t.replaceAll("//twemoji.maxcdn.com/2/svg/", "//cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/"), Zf = (t) => t.split("_").map((e) => e.charAt(0).toUpperCase() + e.slice(1)).join(" "), zt = ({ experience: t, experienceInstanceId: e }, n) => ({
  experienceId: t.id,
  experienceName: t.name,
  experienceType: t.type,
  isCoreEvent: !0,
  localeName: t.context?.localeName || "default",
  localeId: t.context?.localeId || "default",
  timestamp: Date.now(),
  version: t.version,
  name: Zf(n),
  experienceInstanceId: e
}), me = ({ step: t }) => ({
  stepId: t.id,
  stepName: t.name,
  stepType: t.type
}), Jf = (t, e) => !t.blockedEvents[e.type], oa = (t) => {
  const e = (d) => {
    const h = "experience_started", v = zt(d, h);
    t("sendEvent")(h, v);
  }, n = (d) => {
    const h = "experience_completed", v = zt(d, h);
    t("sendEvent")(h, v);
  }, r = (d, { message: h }) => {
    const v = "experience_error", m = zt(d, v);
    t("sendEvent")(v, { ...m, message: h });
  }, i = (d) => {
    const h = "experience_dismissed", v = zt(d, h), m = me(d);
    t("sendEvent")(h, {
      ...v,
      ...m
    });
  }, o = (d) => {
    const h = "experience_snoozed", v = zt(d, h), m = me(d);
    t("sendEvent")(h, {
      ...v,
      ...m
    });
  }, s = (d) => {
    const h = "step_seen", v = zt(d, h), m = me(d);
    t("sendEvent")(h, {
      ...v,
      ...m
    });
  }, a = (d) => {
    const h = "step_completed", v = zt(d, h), m = me(d);
    t("sendEvent")(h, {
      ...v,
      ...m
    });
  }, c = (d, h) => {
    const v = zt(d, h.name), m = me(d), S = t("sendEvent"), { name: y, ...x } = h;
    S(y, {
      ...v,
      ...m,
      ...x
    });
  }, u = (d, { interactionType: h, interactionData: v }) => {
    const m = "step_interaction", S = zt(d, m), y = me(d);
    t("sendEvent")(m, {
      ...S,
      ...y,
      interactionType: h,
      interactionData: v
    });
  }, p = (d, { message: h, errorId: v }) => {
    const m = "step_error", S = zt(d, m), y = me(d);
    t("sendEvent")(m, {
      ...S,
      ...y,
      message: h,
      errorId: v
    });
  }, f = (d, { errorId: h }) => {
    const v = "step_recovered", m = zt(d, v), S = me(d);
    t("sendEvent")(v, {
      ...m,
      ...S,
      errorId: h
    });
  }, l = ut((d, { type: h, name: v = "" }) => {
    const m = h === "EXTENDED_EVENT" ? v : h;
    return {
      blockedEvents: {
        ...d.blockedEvents,
        [m]: !0
      }
    };
  });
  return {
    experienceActions: {
      experienceStarted: e,
      experienceError: r,
      experienceCompleted: n
    },
    stepActions: {
      // NOTE: see above why this "experience" event is included in stepActions
      experienceDismissed: i,
      experienceSnoozed: o,
      stepSeen: s,
      stepInteraction: u,
      stepError: p,
      stepRecovered: f,
      stepExtendedEvent: c,
      stepCompleted: a
    },
    helpers: {
      blockEvent: l,
      isEventEnabled: Jf
    }
  };
}, Qf = Tr({
  initial: "waitingForAsyncEvents",
  context: {
    runHooksDone: !1
  },
  states: {
    waitingForAsyncEvents: {
      on: {
        UPDATE_STEP: "update_step",
        ERROR: "error",
        RUN_HOOKS_DONE: {
          target: "",
          actions: ut({
            runHooksDone: !0
          })
        }
      }
    },
    update_step: {
      always: [
        {
          target: "done",
          cond: (t) => t.runHooksDone,
          actions: [Ut("RERENDER")]
        }
      ],
      on: {
        UPDATE_STEP: "",
        ERROR: "error",
        RUN_HOOKS_DONE: {
          target: "done",
          actions: [
            ut({
              runHooksDone: !0
            }),
            Ut("RERENDER")
          ]
        }
      }
    },
    error: {
      always: [
        {
          target: "done",
          cond: (t) => t.runHooksDone,
          actions: [Ut("FORCE_ERROR")]
        }
      ],
      on: {
        UPDATE_STEP: "",
        ERROR: "",
        RUN_HOOKS_DONE: {
          target: "done",
          actions: [
            ut({
              runHooksDone: !0
            }),
            Ut("FORCE_ERROR")
          ]
        }
      }
    },
    done: {
      type: "final"
    }
  }
}), td = Tr({
  initial: "waitingForAsyncEvents",
  context: {
    runHooksDone: !1
  },
  states: {
    waitingForAsyncEvents: {
      on: {
        RECOVER_STEP: "recover_step",
        RUN_HOOKS_DONE: {
          target: "",
          actions: ut({
            runHooksDone: !0
          })
        }
      }
    },
    recover_step: {
      always: [
        {
          target: "done",
          cond: (t) => t.runHooksDone,
          actions: [Ut("FORCE_RECOVER")]
        }
      ],
      on: {
        RUN_HOOKS_DONE: {
          target: "done",
          actions: [
            ut({
              runHooksDone: !0
            }),
            Ut("FORCE_RECOVER")
          ]
        }
      }
    },
    done: {
      type: "final"
    }
  }
}), ed = {
  initial: "waiting_to_render",
  on: {
    SET_STEP_CONTAINER_TARGET: {
      actions: ["setContainer", "runStepContainerChangeHooks"],
      target: ""
    },
    UPDATE_ROOT_STYLE: {
      actions: "updateRootStyle",
      target: "",
      // updateRootStyle should only be called if
      // step has custom container since otherwise,
      // it would affect the global appcues-container
      // where multiple steps may coexist.
      cond: "hasCustomContainer"
    },
    UPDATE_STEP_CONTENT: {
      actions: "setContent",
      target: ""
    },
    RUN_HOOKS_ERROR: "destroyed",
    BIND_ACTIONS_ERROR: "destroyed",
    STOP_STEP: [
      {
        cond: "hasPendingActions",
        target: "waitingPendingActions",
        actions: ["saveStopReason", "addStoppedCallback"],
        internal: !0
      },
      {
        target: "running_end_hooks",
        actions: ["saveStopReason", "addStoppedCallback"]
      }
    ],
    // Transitions by default are internal: false
    // meaning it will run entry, exit actions and also invoked services.
    // In this case we can't let it be false, otherwise the service instance (hooks and actions)
    // will not be the same and the sync callback calls will stop working
    // since the current callback instance was stopped to start a new one.
    // letting internal:true the service will be started just one time.
    // check https://xstate.js.org/docs/guides/transitions.html#internal-transitions
    // to understand better about internal config.
    PARENT_RECOVER_STEP: {
      actions: ["stepRecovered"],
      target: "rendering",
      internal: !0
    },
    EXPERIENCE_DISMISSED: {
      target: "",
      actions: [
        "experienceDismissed",
        Ut({ type: Ce, reason: Se.DISMISSED })
      ]
    },
    EXPERIENCE_SNOOZED: {
      target: "",
      actions: [
        "experienceSnoozed",
        Ut({ type: Ce, reason: Se.DISMISSED })
      ]
    },
    STEP_SEEN: {
      target: "",
      actions: ["queueStepSeen", "blockEvent"],
      cond: "isEventEnabled"
    },
    STEP_INTERACTION: {
      target: "",
      actions: ["stepInteraction"]
    },
    EXTENDED_EVENT: {
      actions: ["stepExtendedEvent", "blockEvent"],
      cond: "isEventEnabled"
    },
    RELOAD: [
      {
        target: "reload",
        actions: ["updateTheme", "updateStepContext"],
        cond: "didThemeChange"
      },
      {
        target: "reloading_traits",
        actions: [
          "setVirtualizedContent",
          "updateStepContext",
          "saveChangedStepTraits",
          "saveChangedExperienceTraits"
        ],
        cond: "shouldOnlyReloadTraits"
      },
      {
        target: "reload",
        actions: ["setVirtualizedContent", "updateStepContext"],
        cond: "shouldStepReload"
      },
      {
        target: "rendering",
        internal: !0,
        actions: [
          "setVirtualizedContent",
          "updateStepContext",
          "rebindActions"
        ],
        cond: "didContentChanged"
      }
    ],
    [Ce]: {
      actions: [Ut(Ce)]
    },
    FORWARD_TO_PARENT: [
      {
        actions: [
          Ut((t, { eventType: e, ...n }) => ({
            ...n,
            type: e
          }))
        ],
        internal: !0
      }
    ],
    ACTIONS_STARTED: {
      target: "",
      actions: "setActionsRunning",
      internal: !0
    },
    ACTIONS_FINISHED: {
      target: "",
      actions: "setActionsFinished",
      internal: !0
    }
  },
  invoke: [
    {
      id: "hooksService",
      src: "hooksService"
    },
    {
      id: "actionsService",
      src: "actionsService"
    },
    {
      id: "themeRemovalService",
      src: "themeRemovalService"
    }
  ],
  states: {
    waiting_to_render: {
      on: {
        START_STEP: "running_traits"
      }
    },
    reload: {
      entry: [
        "removeCustomContainer",
        "unmount",
        "resetRender",
        "clearOverrides",
        "runStepEndHooks"
      ],
      exit: ["removeStepHooks"],
      on: {
        RUN_HOOKS_DONE: {
          target: "running_traits",
          cond: "isHooksDoneEventEndType"
        }
      }
    },
    reloading_traits: {
      initial: "running_end_hooks",
      exit: ["clearChangedStepTraits", "clearChangedExperienceTraits"],
      onDone: {
        target: "rendering",
        actions: "ensuresElementsAreAccessible"
      },
      on: {
        ERROR: {
          target: "error",
          internal: !0,
          actions: "stepError"
        }
      },
      states: {
        running_end_hooks: {
          entry: ["runStepEndHooks"],
          on: {
            RUN_HOOKS_DONE: {
              target: "running_pre_begin_hooks",
              cond: "isHooksDoneEventEndType"
            }
          }
        },
        running_pre_begin_hooks: {
          entry: ["runStepPreBeginHooks"],
          exit: ["rebindActions"],
          // rebind action before step.begin hooks run
          on: {
            RUN_HOOKS_DONE: {
              target: "running_begin_hooks",
              cond: "isHooksDoneEventPreBeginType"
            }
          }
        },
        running_begin_hooks: {
          entry: ["runStepBeginHooks"],
          on: {
            RUN_HOOKS_DONE: {
              target: "done",
              cond: "isHooksDoneEventBeginType"
            }
          }
        },
        done: {
          type: "final"
        }
      }
    },
    running_traits: {
      invoke: {
        src: "runStepTraits"
      },
      on: {
        RUN_TRAITS_DONE: {
          target: "pre_begin",
          // We can only bind actions' callbacks after running the traits
          // because traits can register actions.
          // so the action service will only do something after receiving
          // the confirmation that the traits are done with its execution.
          actions: "rebindActions"
        },
        RUN_TRAITS_ERROR: "destroyed"
      }
    },
    pre_begin: {
      entry: ["runStepPreBeginHooks"],
      on: {
        ERROR: {
          target: "error",
          internal: !0,
          actions: "stepError"
        },
        RUN_HOOKS_DONE: {
          target: "begin",
          cond: "isHooksDoneEventPreBeginType"
        }
      }
    },
    begin: {
      entry: ["runStepBeginHooks"],
      on: {
        // Certain traits can dispatch errors while in begin state
        // like inline traits, in this case we still need to catch these errors
        // and we send it directly to error state, since the rendering flow didn't started.
        ERROR: {
          target: "error",
          internal: !0,
          actions: "stepError"
        },
        RUN_HOOKS_DONE: {
          target: "rendering",
          actions: "ensuresElementsAreAccessible",
          cond: "isHooksDoneEventBeginType"
        }
      }
    },
    rendering: {
      initial: "pre-render",
      on: {
        STEP_CONTAINER_REMOVED: {
          target: "error",
          internal: !1
        }
      },
      states: {
        "pre-render": {
          entry: ["runStepPreRenderHooks"],
          on: {
            RUN_HOOKS_DONE: [
              {
                target: "render",
                actions: ["applyOverrides"],
                cond: "isHooksDoneEventPreRenderType"
              }
            ]
          }
        },
        render: {
          invoke: {
            src: "render",
            onDone: [
              {
                target: "post-render",
                cond: "hasCustomContainer",
                actions: "startThemeRemovalListener"
              },
              {
                target: "post-render"
              }
            ]
          }
        },
        "post-render": {
          invoke: {
            id: "postRenderAsyncEventsHandler",
            src: Qf
          },
          entry: ["runStepPostRenderHooks"],
          on: {
            FORCE_ERROR: "#error",
            RERENDER: "pre-render",
            UPDATE_STEP: {
              target: "",
              actions: [gn("postRenderAsyncEventsHandler")]
            },
            ERROR: {
              target: "",
              actions: [
                gn("postRenderAsyncEventsHandler"),
                "stepError",
                "markErrorReported"
              ]
            },
            RUN_HOOKS_DONE: {
              target: "",
              cond: "isHooksDoneEventPostRenderType",
              actions: [
                "notifyExperienceStarted",
                "commitPendingStepSeen",
                gn("postRenderAsyncEventsHandler")
              ]
            }
          }
        }
      }
    },
    running_end_hooks: {
      entry: ["runStepEndHooks"],
      on: {
        RUN_HOOKS_DONE: [
          {
            cond: "shouldFireStepCompletedEvent",
            target: "calling_stopped_callbacks",
            actions: [
              "removeCustomContainer",
              "unmount",
              "stepCompleted",
              "removeStepHooks"
            ]
          },
          {
            cond: "isHooksDoneEventEndType",
            target: "calling_stopped_callbacks",
            actions: ["removeCustomContainer", "unmount", "removeStepHooks"]
          }
        ],
        RUN_HOOKS_ERROR: {
          target: "destroyed",
          actions: ["callStoppedCallbacks"]
        }
      }
    },
    calling_stopped_callbacks: {
      entry: ["callStoppedCallbacks", "deferTransitionToEnd"],
      on: {
        [Ps]: "end"
      }
    },
    end: {
      type: "final",
      entry: ["notifyStepStopped"]
    },
    error: {
      id: "error",
      invoke: [
        {
          id: "errorAsyncEventsHandler",
          src: td
        }
      ],
      entry: ["unmount", "runStepErrorHooks", "stopThemeRemovalListener"],
      on: {
        RUN_HOOKS_DONE: {
          target: "",
          cond: "isHooksDoneEventErrorType",
          actions: [gn("errorAsyncEventsHandler"), "autoRecover"]
        },
        RECOVER_STEP: {
          target: "",
          actions: [gn("errorAsyncEventsHandler")]
        },
        // Recovery routes through pre_begin so that step.prebegin hooks
        // (e.g. container validation) run before re-entering the begin/render
        // lifecycle, giving traits a chance to set up preconditions.
        FORCE_RECOVER: {
          target: "pre_begin",
          actions: ["resetRender", "stepRecovered"]
        },
        AUTO_RECOVER_STEP: {
          target: "pre_begin",
          actions: "resetRender",
          cond: "isAutoRecoverEvent"
        }
      }
    },
    destroyed: {
      entry: ["stepError", "unmount"]
    },
    waitingPendingActions: {
      on: {
        ACTIONS_FINISHED: {
          target: "running_end_hooks",
          actions: "setActionsFinished"
        }
      }
    }
  }
}, sa = (t, { createStepHooks: e, createHooksService: n, experience: r, get: i, experienceInstanceId: o }) => {
  const {
    virtualizeContent: s,
    createVnodeTree: a,
    wrapContent: c,
    applyOverridesToVnode: u
  } = i("vNodeHandlers"), { makeElementsAccessible: p } = i("accessibilityHandlers"), { applyOverrides: f, createOverrideCallback: l, clearOverrides: d } = tf({
    applyOverridesToVnode: u
  }), h = l("style"), v = i("getWindowReference"), { onRender: m, onRenderReset: S } = i("createRenderListener")(), {
    render: y,
    unmount: x,
    setContainer: T,
    resetRender: b,
    getContainer: A,
    hasCustomContainer: R,
    getRoot: O
  } = Kf({
    experience: r,
    onRender: m,
    onRenderReset: S,
    wrapContent: c,
    getWindowReference: v
  }), {
    addHook: P,
    runStepPreBeginHooks: D,
    runStepBeginHooks: L,
    runStepPreRenderHooks: $,
    runStepPostRenderHooks: q,
    runStepEndHooks: Y,
    runStepErrorHooks: G,
    removeStepHooks: nt,
    runStepContainerChangeHooks: J
  } = e({
    step: t,
    overrideStyle: h
  }), V = Qu({
    addHook: P
  }), ot = Ju(
    {
      overrideStyle: h,
      getContainer: A
    },
    i
  ), Q = n(
    {
      overrideStyle: h,
      getContainer: A,
      getRoot: O
    },
    i
  ), et = mu({
    getRoot: O,
    getWindowReference: v
  }), rt = Uu(i), gt = oa(i), xt = (U) => U.contentType === "text/html" ? s(Yf(Xf(U.content))) : a(U.content);
  return Tr(
    {
      ...ed,
      context: {
        id: `step-machine-${t.id}`,
        step: {
          ...t,
          /**
           * Even though we receive an step content as HTML
           * the first thing even before running the step is parsing it to a vnode tree
           *
           * The virtualizeContent lib, returns a vnode tree in the format that snabdom
           * understands. But it helps not only for rendering, but also to attach actions to an element for example,
           * since we use a tree traversal technique to find and match the element id with the actions callbacks.
           *
           */
          activeNodeIndex: 0,
          virtualizedContent: xt(t)
        },
        experience: r,
        blockedEvents: {},
        pendingStepSeen: !1,
        errorReported: !1,
        actionsRunning: !1,
        experienceInstanceId: o,
        stopReason: null,
        stoppedCallbacks: [],
        changedStepTraits: null,
        changedExperienceTraits: null
      }
    },
    {
      actions: {
        // injecting action coming from step level
        setContent: ku,
        updateRootStyle: ju,
        // injecting action coming from render
        unmount: x,
        setContainer: T,
        updateTheme: rt,
        resetRender: b,
        // injecting action coming from hooks
        runStepPreBeginHooks: D,
        runStepBeginHooks: L,
        runStepPreRenderHooks: $,
        runStepPostRenderHooks: q,
        runStepEndHooks: Y,
        runStepErrorHooks: G,
        runStepContainerChangeHooks: J,
        updateStepContext: $u,
        rebindActions: Cn(
          (U) => ({
            type: Rr,
            step: U.step,
            experience: U.experience
          }),
          { to: "actionsService" }
        ),
        removeStepHooks: () => nt(),
        clearOverrides: () => d(),
        setVirtualizedContent: Lu(
          xt
        ),
        // injecting action coming from overrides
        applyOverrides: f,
        // injecting actions coming from dom
        startThemeRemovalListener: qs,
        stopThemeRemovalListener: Eu,
        removeCustomContainer: vu({ getRoot: O }),
        ensuresElementsAreAccessible: Fu(
          p
        ),
        notifyExperienceStarted: Mu,
        notifyStepStopped: Hu,
        // core events
        ...gt.stepActions,
        blockEvent: gt.helpers.blockEvent,
        // step_seen is deferred to RUN_HOOKS_DONE of post-render so a step
        // whose trait fails to anchor (e.g. tooltip with broken selector)
        // doesn't emit step_seen ahead of the step_error it's about to fire.
        queueStepSeen: ut({ pendingStepSeen: !0 }),
        markErrorReported: ut({ errorReported: !0 }),
        // Side effect inside assign: XState v4 raises assign actions ahead of
        // non-assign actions in the same transition, so a sibling
        // `clearPendingStepSeen: assign(...)` would zero the flag before this
        // check runs. Reading and writing in one assign keeps them ordered.
        commitPendingStepSeen: ut((U) => (U.pendingStepSeen && !U.errorReported && gt.stepActions.stepSeen(U), { pendingStepSeen: !1 })),
        autoRecover: Bu,
        setActionsRunning: zu,
        setActionsFinished: qu,
        // stop reason handling
        saveStopReason: ut({
          stopReason: (U, W) => W.reason
        }),
        addStoppedCallback: ut({
          stoppedCallbacks: (U, W) => W.onStopped ? [...U.stoppedCallbacks, W.onStopped] : U.stoppedCallbacks
        }),
        callStoppedCallbacks: (U) => U.stoppedCallbacks.forEach((W) => {
          try {
            W();
          } catch {
          }
        }),
        deferTransitionToEnd: Cn({ type: Ps }, { delay: 0 }),
        saveChangedStepTraits: ut({
          changedStepTraits: (U, W) => W.changedStepTraits ?? null
        }),
        clearChangedStepTraits: ut({
          changedStepTraits: () => null
        }),
        saveChangedExperienceTraits: ut({
          changedExperienceTraits: (U, W) => W.changedExperienceTraits ?? null
        }),
        clearChangedExperienceTraits: ut({
          changedExperienceTraits: () => null
        })
      },
      services: {
        // injecting services coming from step level
        runStepTraits: V,
        // injecting services coming from render
        render: y,
        // injecting services coming from hooks
        hooksService: Q,
        // injecting services coming from steps
        actionsService: ot,
        // injecting services coming from dom
        themeRemovalService: et
      },
      guards: {
        hasCustomContainer: R,
        isAutoRecoverEvent: (U, W) => W.isAutoRecoverEvent,
        isEventEnabled: gt.helpers.isEventEnabled,
        didContentChanged: (U, W) => !xn(U.step.content, W.stepConfig.content),
        shouldOnlyReloadTraits: Wu,
        shouldStepReload: (U, W) => !xn(U.step.traits, W.stepConfig.traits) || !xn(U.step.actions, W.stepConfig.actions) || !xn(U.experience.traits, W.experience.traits),
        didThemeChange: (U, W) => U.experience.theme !== W.experience.theme,
        isHooksDoneEventPostRenderType: (U, W) => W.hookType === Ls,
        isHooksDoneEventPreRenderType: (U, W) => W.hookType === ks,
        isHooksDoneEventPreBeginType: (U, W) => W.hookType === xi,
        isHooksDoneEventBeginType: (U, W) => W.hookType === wi,
        isHooksDoneEventErrorType: (U, W) => W.hookType === $s,
        isHooksDoneEventEndType: (U, W) => W.hookType === hr,
        hasPendingActions: (U) => U.actionsRunning,
        shouldFireStepCompletedEvent: (U, W) => W.hookType === hr && // Require that the step has been seen, otherwise it cannot be completed
        U.blockedEvents.STEP_SEEN && U.stopReason !== Se.NAVIGATION && U.stopReason !== Se.DISMISSED
      }
    }
  );
}, nd = ({
  createStepHooks: t,
  createHooksService: e,
  get: n
}) => ut({
  stepMachines: ({ experience: r, experienceInstanceId: i }) => {
    const o = {
      experience: r,
      experienceInstanceId: i,
      createStepHooks: t,
      createHooksService: e,
      get: n
    };
    return r.steps.reduce((s, a) => (s[`${a.id}`] = xs(
      sa(a, o),
      `step-machine - ${a.id}`
    ), s), {});
  }
}), rd = ({
  createStepHooks: t,
  createHooksService: e,
  get: n
}) => ut({
  stepMachines: ({ experience: r, stepMachines: i }, o) => {
    const s = {
      experience: r,
      createStepHooks: t,
      createHooksService: e,
      get: n
    }, a = r.steps.find(
      (c) => c.id === o.id
    );
    return a ? {
      ...i,
      [`${o.id}`]: xs(
        sa(a, s),
        `step-machine - ${o.id}`
      )
    } : i;
  }
}), Dn = (t) => (e, { id: n, ...r }) => {
  e.stepMachines[n]?.send({
    ...r,
    type: t
  });
}, id = Dn(Ts), od = (t, e) => {
  const n = t.stepMachines[e.id];
  n && (n.state.done && e.onStopped ? e.onStopped() : n.send({
    ...e,
    type: bi
  }));
}, sd = Dn(Rs), ad = Dn(
  Cs
), cd = Dn(Vl), ld = Dn(Os), ud = (t, e) => {
  Object.values(t.stepMachines).forEach((n) => {
    n.send({
      type: bi,
      reason: e.reason
    });
  });
}, To = (t = [], e = []) => {
  const n = new Map(
    t.map((a) => [a.id, a])
  ), r = new Map(e.map((a) => [a.id, a])), i = e.filter((a) => {
    const c = n.get(a.id);
    return !c || c.type !== a.type;
  }), o = t.filter((a) => {
    const c = r.get(a.id);
    return !c || c.type !== a.type;
  }), s = e.filter((a) => {
    const c = n.get(a.id);
    if (!c || c.type !== a.type) return !1;
    const u = c.config || {}, p = a.config || {};
    return !xn(u, p);
  });
  return {
    addedTraits: i,
    removedTraits: o,
    changedTraits: s
  };
}, fd = ut((t, e) => {
  const n = To(
    t.experience.traits,
    e.experience.traits
  );
  return Object.entries(t.stepMachines).forEach(([r, i]) => {
    const o = t.experience.steps.find(
      (c) => c.id === r
    ), s = e.experience.steps.find((c) => c.id === r);
    if (!o || !s)
      return;
    const a = To(
      o.traits,
      s.traits
    );
    i.send({
      type: Yl,
      stepConfig: s,
      experience: e.experience,
      changedExperienceTraits: n,
      changedStepTraits: a
    });
  }), {
    experience: e.experience
  };
}), dd = (t) => {
  Object.values(t.stepMachines).forEach((e) => {
    e.send({
      type: Ti
    });
  });
}, pd = ut({
  experienceInstanceId: () => Hl()
}), hd = ut({
  stepMachines: (t, e) => Object.entries(t.stepMachines).reduce(
    (n, [r, i]) => (r !== e.id && (n[r] = i), n),
    {}
  )
}), gd = ut({
  experience: ({ experience: t }, e) => {
    const n = t.steps.findIndex((r) => r.id === e.id);
    return n === -1 ? t : rr(
      t,
      `steps.${n}.traits`,
      (r) => r.filter(({ once: i = !1 }) => !i)
    );
  }
}), vd = ({ addHook: t }) => ({ experience: e }) => (n) => {
  try {
    e.traits.forEach(
      (r) => Gs({
        getTrait: Ks,
        trait: r,
        addHook: (i, o) => {
          t(i, { callback: o, traitId: r.id });
        },
        registerAction: (i, o) => ce(
          `${e.id}.${r.type}.${i}`,
          o
        )
      })
    ), n(Rr);
  } catch {
    n(Fs);
  }
}, Ro = (t, e) => (n, { callback: r, traitId: i }) => {
  const o = t();
  o.get(n) || o.set(n, []);
  const s = o.get(n);
  e(n, [...s, { callback: r, traitId: i }]);
}, le = (t, e) => Cn(
  (n, r) => {
    let i = e;
    const o = r.changedExperienceTraits ?? n.changedExperienceTraits;
    o && (i = {
      ...i,
      onlyExperienceTraits: o.changedTraits.filter((a) => a.id != null).map(({ id: a }) => a)
    });
    const s = r.changedStepTraits ?? n.changedStepTraits;
    return s && (i = {
      ...i,
      onlyStepTraits: s.changedTraits.filter((a) => a.id != null).map(({ id: a }) => a)
    }), {
      type: Hs,
      hookType: t,
      experience: n.experience,
      step: n.step,
      ...i
    };
  },
  { to: "hooksService" }
), yd = le(tu), md = le(eu), Ed = le(xi), Sd = le(wi), bd = le(ks), xd = le(Ls), wd = le(hr), _d = ol(
  (t, e) => le($s, { errorEvent: e })
), Td = le(Ms), Rd = () => {
  const t = /* @__PURE__ */ new Map(), e = /* @__PURE__ */ new Map(), n = (i = {}, o) => () => (
    // eslint-disable-next-line unicorn/consistent-function-scoping
    ((s, a) => {
      a(async ({ type: c, hookType: u, experience: p, step: f, ...l }) => {
        if (c !== Hs) return;
        let d = {
          experience: p,
          step: f,
          callback: s,
          get: o,
          getContainer: i.getContainer
        };
        [xi, wi, Ms, hr].includes(
          u
        ) && (d = { ...d, ...i });
        const h = ({ callback: m, trait: S }) => {
          const y = {
            ...Ci({
              ...d,
              getAction: re,
              handleNavigation: o("handleNavigation")
            }),
            getTraitConfig: () => S.config
          };
          return {
            callback: m,
            context: y
          };
        }, v = (t.get(u) ?? []).filter(
          ({ traitId: m }) => !l.onlyExperienceTraits || l.onlyExperienceTraits && l.onlyExperienceTraits.includes(m)
        ).map(
          (m) => h({
            ...m,
            trait: (p.traits ?? []).find(
              (S) => S.id === m.traitId
            )
          })
        );
        try {
          if (await _o(v), f) {
            const m = (e.get(f.id)?.get(u) ?? []).filter(
              ({ traitId: S }) => !l.onlyStepTraits || l.onlyStepTraits && l.onlyStepTraits.includes(S)
            ).map(
              (S) => h({
                ...S,
                trait: (f.traits ?? []).find(
                  (y) => y.id === S.traitId
                )
              })
            );
            await _o(m);
          }
          s({ type: nu, hookType: u, ...l });
        } catch {
          s("RUN_HOOKS_ERROR");
        }
      });
    })
  ), r = ({ step: i }) => (e.get(i.id) || e.set(i.id, /* @__PURE__ */ new Map()), {
    addHook: Ro(
      () => e.get(i.id),
      (o, s) => e.get(i.id).set(o, s)
    ),
    removeStepHooks: () => e.set(i.id, /* @__PURE__ */ new Map()),
    runStepPreBeginHooks: Ed,
    runStepBeginHooks: Sd,
    runStepPreRenderHooks: bd,
    runStepPostRenderHooks: xd,
    runStepEndHooks: wd,
    runStepErrorHooks: _d,
    runStepContainerChangeHooks: Td
  });
  return {
    addHook: Ro(
      () => t,
      (i, o) => t.set(i, o)
    ),
    createStepHooks: r,
    createHooksService: n,
    runExperienceBeginHooks: yd,
    runExperienceEndHooks: md
  };
}, Cd = {
  id: "experience",
  initial: "idle",
  invoke: [
    {
      src: "hooksService",
      id: "hooksService"
    },
    {
      id: "themeRemovalService",
      src: "globalThemeRemovalService"
    }
  ],
  on: {
    RUN_HOOKS_ERROR: "destroyed",
    EXPERIENCE_STARTED: {
      target: "",
      actions: ["experienceStarted", "blockEvent"],
      cond: "isEventEnabled"
    },
    SHOW: "running-traits"
  },
  states: {
    idle: {
      on: {
        SHOW: [
          {
            target: "running-traits",
            actions: ["updateExperienceInstanceId"]
          },
          {
            target: "destroyed"
          }
        ]
      }
    },
    "running-traits": {
      invoke: {
        src: "runGlobalExperienceTraits"
      },
      on: {
        RUN_TRAITS_ERROR: "destroyed",
        RUN_TRAITS_DONE: "rendering-steps"
      }
    },
    "rendering-steps": {
      on: {
        STOP_EXPERIENCE: [
          {
            target: "end",
            actions: ["experienceCompleted", "stopSteps"],
            cond: "shouldFireCompletedEvent"
          },
          {
            target: "end",
            actions: ["stopSteps"]
          }
        ],
        START_STEP: [
          {
            target: "",
            cond: "doesStepInstanceExist",
            actions: "startStep"
          },
          {
            target: "",
            actions: ["startStepMachine", "startStep"]
          }
        ],
        STOP_STEP: {
          target: "",
          actions: "stopStep"
        },
        UPDATE_STEP: {
          target: "",
          actions: "updateStep"
        },
        SET_STEP_CONTAINER_TARGET: {
          target: "",
          actions: "setStepContainerTarget"
        },
        RECOVER_STEP: {
          target: "",
          actions: "recoverStep"
        },
        GLOBAL_CONTAINER_REMOVED: {
          target: "",
          actions: [
            "createGlobalThemeComponent",
            "startThemeRemovalListener",
            "notifyStepsContainerRemoved"
          ]
        },
        UPDATE_STEP_CONTENT: {
          target: "",
          actions: "updateStepContent"
        },
        SHOW: {
          target: "",
          actions: ["reloadSteps"]
        },
        STEP_STOPPED: [
          {
            target: "end-final",
            cond: "areAllStepsStopped",
            actions: [
              "experienceCompleted",
              "removeGlobalThemeComponent",
              "runExperienceEndHooks"
            ]
          },
          {
            target: "",
            actions: ["cleanStepMachines", "cleanRunOnceTraits"]
          }
        ]
      },
      entry: [
        "createGlobalThemeComponent",
        "startStepMachines",
        "runExperienceBeginHooks",
        "startThemeRemovalListener"
      ]
    },
    end: {
      entry: ["removeGlobalThemeComponent", "runExperienceEndHooks"],
      on: {
        [Ns]: { target: "end-final", cond: "areAllStepsStopped" }
      }
    },
    "end-final": {
      final: !0
    },
    destroyed: {
      entry: "experienceError",
      type: "final"
    }
  }
}, Od = (t, e) => {
  const {
    addHook: n,
    createStepHooks: r,
    createHooksService: i,
    runExperienceBeginHooks: o,
    runExperienceEndHooks: s
  } = Rd(), a = i({}, e), c = nd({
    createStepHooks: r,
    createHooksService: i,
    get: e
  }), u = rd({
    createStepHooks: r,
    createHooksService: i,
    get: e
  }), p = vd({
    addHook: n
  }), f = oa(e), l = pu(e), d = hu(e), h = yu(e);
  return Tr(
    {
      ...Cd,
      context: {
        experience: t,
        blockedEvents: {},
        experienceInstanceId: null
      }
    },
    {
      actions: {
        // experience
        startStep: id,
        stopStep: od,
        updateStep: sd,
        setStepContainerTarget: ad,
        recoverStep: cd,
        startStepMachines: c,
        stopSteps: ud,
        notifyStepsContainerRemoved: dd,
        updateStepContent: ld,
        reloadSteps: fd,
        updateExperienceInstanceId: pd,
        cleanStepMachines: hd,
        startStepMachine: u,
        // hooks
        runExperienceBeginHooks: o,
        runExperienceEndHooks: s,
        // dom
        createGlobalThemeComponent: l,
        removeGlobalThemeComponent: d,
        startThemeRemovalListener: qs,
        // traits
        cleanRunOnceTraits: gd,
        // core events
        ...f.experienceActions,
        blockEvent: f.helpers.blockEvent
      },
      services: {
        // experiences
        runGlobalExperienceTraits: p,
        // hooks
        hooksService: a,
        // dom
        globalThemeRemovalService: h
      },
      guards: {
        isEventEnabled: f.helpers.isEventEnabled,
        areAllStepsStopped: (v) => Object.values(v.stepMachines).every(
          (m) => m.state.done
        ),
        doesStepInstanceExist: (v, m) => v.stepMachines?.[m.id] !== void 0,
        shouldFireCompletedEvent: (v, m) => m.reason !== Se.NAVIGATION && m.reason !== Se.DISMISSED
      }
    }
  );
}, aa = Zs(
  [
    ta,
    ra,
    ia,
    na,
    Qs
  ],
  void 0,
  {
    experimental: {
      fragments: !0
    }
  }
);
function Ad(t) {
  const n = (t.ownerDocument || document).createElement("div");
  return t.append(n), aa(n, ae("div"));
}
const Nd = () => {
  let t = null;
  return {
    onRender: (e, n) => {
      !t && !e || (t || (t = Ad(e)), t = aa(t, n));
    },
    onRenderReset: () => {
      t = null;
    }
  };
};
var Kn = {}, Fr, Co;
function Pd() {
  return Co || (Co = 1, Fr = {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    menuitem: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
  }), Fr;
}
var Br, Oo;
function Id() {
  if (Oo) return Br;
  Oo = 1;
  var t = /([\w-]+)|=|(['"])([.\s\S]*?)\2/g, e = Pd();
  return Br = function(n) {
    var r = 0, i, o = !0, s = {
      type: "tag",
      name: "",
      voidElement: !1,
      attrs: {},
      children: []
    };
    return n.replace(t, function(a) {
      if (a === "=") {
        o = !0, r++;
        return;
      }
      o ? r === 0 ? ((e[a] || n.charAt(n.length - 2) === "/") && (s.voidElement = !0), s.name = a) : (s.attrs[i] = a.replace(/^['"]|['"]$/g, ""), i = void 0) : (i && (s.attrs[i] = i), i = a), r++, o = !1;
    }), s;
  }, Br;
}
var zr, Ao;
function Dd() {
  if (Ao) return zr;
  Ao = 1;
  var t = /(?:<!--[\S\s]*?-->|<(?:"[^"]*"|'[^']*'|[^'">])+>)/g, e = Id(), n = Object.create ? /* @__PURE__ */ Object.create(null) : {};
  function r(i, o, s, a, c) {
    var u = o.indexOf("<", a), p = o.slice(a, u === -1 ? void 0 : u);
    /^\s*$/.test(p) && (p = " "), (!c && u > -1 && s + i.length >= 0 || p !== " ") && i.push({
      type: "text",
      content: p
    });
  }
  return zr = function(o, s) {
    s || (s = {}), s.components || (s.components = n);
    var a = [], c, u = -1, p = [], f = {}, l = !1;
    return o.replace(t, function(d, h) {
      if (l) {
        if (d !== "</" + c.name + ">")
          return;
        l = !1;
      }
      var v = d.charAt(1) !== "/", m = d.indexOf("<!--") === 0, S = h + d.length, y = o.charAt(S), x;
      v && !m && (u++, c = e(d), c.type === "tag" && s.components[c.name] && (c.type = "component", l = !0), !c.voidElement && !l && y && y !== "<" && r(c.children, o, u, S, s.ignoreWhitespace), f[c.tagName] = c, u === 0 && a.push(c), x = p[u - 1], x && x.children.push(c), p[u] = c), (m || !v || c.voidElement) && (m || u--, !l && y !== "<" && y && (x = u === -1 ? a : p[u].children, r(x, o, u, S, s.ignoreWhitespace)));
    }), !a.length && o.length && r(a, o, 0, 0, s.ignoreWhitespace), a;
  }, zr;
}
const ca = /* @__PURE__ */ Cl(Vf);
var Ue = {}, No;
function kd() {
  if (No) return Ue;
  No = 1, Object.defineProperty(Ue, "__esModule", {
    value: !0
  }), Ue.createTextVNode = e, Ue.transformName = n, Ue.unescapeEntities = o;
  var t = ca;
  function e(s, a) {
    return (0, t.vnode)(void 0, void 0, void 0, o(s, a));
  }
  function n(s) {
    s = s.replace(/-(\w)/g, function(u, p) {
      return p.toUpperCase();
    });
    var a = s.charAt(0).toLowerCase();
    return "" + a + s.substring(1);
  }
  var r = new RegExp("&[a-z0-9#]+;", "gi"), i = null;
  function o(s, a) {
    return i || (i = a.createElement("div")), s.replace(r, function(c) {
      return i.innerHTML = c, i.textContent;
    });
  }
  return Ue;
}
var Po;
function Ld() {
  if (Po) return Kn;
  Po = 1, Object.defineProperty(Kn, "__esModule", {
    value: !0
  }), Kn.default = function(f) {
    var l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, d = l.context || document;
    if (!f)
      return null;
    var h = [], v = s((0, e.default)(f), h, d), m = void 0;
    return v ? v.length === 1 ? m = v[0] : m = v : m = a({ type: "text", content: f }, h, d), l.hooks && l.hooks.create && h.forEach(function(S) {
      l.hooks.create(S);
    }), m;
  };
  var t = Dd(), e = i(t), n = ca, r = kd();
  function i(f) {
    return f && f.__esModule ? f : { default: f };
  }
  function o(f, l, d) {
    return l in f ? Object.defineProperty(f, l, { value: d, enumerable: !0, configurable: !0, writable: !0 }) : f[l] = d, f;
  }
  function s(f, l, d) {
    if (f instanceof Array && f.length > 0)
      return f.map(function(h) {
        return a(h, l, d);
      });
  }
  function a(f, l, d) {
    var h = void 0;
    return f.type === "text" ? h = (0, r.createTextVNode)(f.content, d) : h = (0, n.h)(f.name, c(f, d), s(f.children, l, d)), l.push(h), h;
  }
  function c(f, l) {
    var d = {};
    if (!f.attrs)
      return d;
    var h = Object.keys(f.attrs).reduce(function(S, y) {
      if (y !== "style" && y !== "class") {
        var x = (0, r.unescapeEntities)(f.attrs[y], l);
        S ? S[y] = x : S = o({}, y, x);
      }
      return S;
    }, null);
    h && (d.attrs = h);
    var v = u(f);
    v && (d.style = v);
    var m = p(f);
    return m && (d.class = m), d;
  }
  function u(f) {
    try {
      return f.attrs.style.split(";").reduce(function(l, d) {
        var h = d.split(":"), v = (0, r.transformName)(h[0].trim());
        if (v) {
          var m = h[1].replace("!important", "").trim();
          l ? l[v] = m : l = o({}, v, m);
        }
        return l;
      }, null);
    } catch {
      return null;
    }
  }
  function p(f) {
    try {
      return f.attrs.class.split(" ").reduce(function(l, d) {
        return d = d.trim(), d && (l ? l[d] = !0 : l = o({}, d, !0)), l;
      }, null);
    } catch {
      return null;
    }
  }
  return Kn;
}
var qr, Io;
function $d() {
  return Io || (Io = 1, qr = Ld()), qr;
}
var Md = $d();
const Hd = /* @__PURE__ */ Ie(Md), la = "data-interaction-style", jd = (t) => t.replace(/([A-Z])/g, (e) => `-${e[0].toLowerCase()}`), ua = (t) => t.replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&#39;/g, "'").replace(/&quot;/g, '"'), fa = ({ nodeId: t, interactionId: e, state: n }) => {
  const r = e ? `[${la}="${e}"]` : `#${t}`;
  return Object.keys(n).map((i) => `${r}:${i} {
        ${Object.entries(n[i]).map(([o, s]) => {
    const a = ua(String(s));
    return `${jd(
      o
    )}:${a} !important`;
  }).join(";")}
      }`).join(" ");
}, da = (t) => t.data && t.data.attrs ? t.data.attrs.id : void 0, pa = (t, e) => Object.keys(e).reduce(
  (n, r) => ({
    ...n,
    [r]: {
      ...n[r],
      ...e[r]
    }
  }),
  t.data || {}
), Ni = (t, e) => {
  t && (e(t), t.children && t.children.forEach((n) => Ni(n, e)));
}, ha = (t) => {
  if (typeof t == "string")
    return ua(t);
  if (t == null)
    return ui([]);
  const {
    is: e = "div",
    children: n = [],
    style: r,
    behaviors: i,
    ...o
  } = t.props, { state: s, ...a } = r ?? {}, c = t.props.id, u = t.props[la], p = {
    ...Object.keys(a).length > 0 && { style: a },
    ...Object.keys(o).length > 0 && { attrs: o }
  }, f = ae(e, p, n.map(ha));
  return s ? ui([
    ae("style", fa({ nodeId: c, interactionId: u, state: s })),
    f
  ]) : f;
}, ga = (t, e) => {
  const n = da(t), r = e(n) ?? {};
  return {
    ...t,
    data: pa(t, r),
    children: t.children?.map(
      (i) => ga(i, e)
    )
  };
}, Ud = ({ step: t }) => {
  const e = De(t.id), n = ae(
    "div",
    {
      attrs: {
        [Us]: e
      },
      style: {
        // this solution can adding extra height to the page, so we need a way to avoid this scenario
        // display: 'inline-block',
        // position: 'relative',
        width: "100%",
        display: "contents"
      }
    },
    [t.virtualizedContent]
  );
  return {
    step: {
      ...t,
      virtualizedContent: n
    }
  };
}, Fd = (t, e) => (t.data = {
  ...t.data,
  on: e.on,
  hook: e.hook
}, t), Bd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  applyOverridesToVnode: ga,
  createStyleState: fa,
  createVnodeTree: ha,
  findId: da,
  injectHandlers: Fd,
  mergeVnodeData: pa,
  traverseTree: Ni,
  virtualizeContent: Hd,
  wrapContent: Ud
}, Symbol.toStringTag, { value: "Module" })), Do = (t, e) => e.includes(t.data?.attrs?.id) && typeof t.data?.attrs?.tabindex != "string" && typeof t.data?.attrs?.tabIndex != "number", zd = (t) => {
  t.data.attrs.tabindex = 0, t.sel = "button", t.data.style = {
    ...t.data.style,
    border: t.data?.style?.border ?? "none",
    ...t?.children?.length > 0 && {
      backgroundColor: t.data?.style?.backgroundColor ?? "transparent"
    }
  };
}, qd = ({ virtualizedContent: t, index: e }, { interactiveEls: n = [], focusableEls: r = [] }) => (Ni(t, (i) => {
  Do(i, n) ? zd(i) : Do(i, r) && (i.data.attrs = {
    ...i.data.attrs,
    tabindex: 0,
    role: "dialog",
    "aria-labelledby": `content-${e}`,
    "aria-describedby": `content-${e}`
  }), i.data?.class?.canvas && (i.data.attrs = {
    ...i.data.attrs,
    id: `content-${e}`
  });
}), t), Wd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  makeElementsAccessible: qd
}, Symbol.toStringTag, { value: "Module" })), Vd = "@appcues/close", ko = {
  markComplete: !0
}, Gd = ({ markComplete: t = ko.markComplete } = ko, { stopExperience: e, step: n }) => {
  t ? e() : n.dismissExperience();
};
ce(Vd, Gd);
const Kd = "@appcues/redirectTo";
function Xd(t, e) {
  if (/^https?:\/\//i.test(e))
    return e;
  try {
    return new URL(e, t.location.origin).href;
  } catch {
    return e;
  }
}
const Yd = ({ url: t = "", openInNewWindow: e = !1 } = {}, { reportError: n, getWindowReference: r }) => {
  if (!t) {
    n("Can't redirect to undefined URL");
    return;
  }
  const i = r(), o = Xd(i, t);
  i.open(o, e ? "_blank" : "_self", "noopener");
};
ce(Kd, Yd);
const Zd = "@appcues/trackEvent", Jd = ({ name: t, properties: e = {} }, { sendCustomEvent: n }) => {
  n(t, e);
};
ce(Zd, Jd);
const Qd = "@appcues/triggerFlow", tp = ({ flowId: t, url: e, prefetch: n = !1 } = {}, { showFlow: r }) => {
  r({ flowId: t, url: e, prefetch: n });
};
ce(Qd, tp);
const ep = (t) => Object.keys(t).length === 0, np = (t) => t === "date.now" ? Date.now() : null, rp = (t) => typeof t == "string" && t.startsWith("{") && t.endsWith("}"), ip = (t) => Object.entries(t).reduce((e, [n, r]) => {
  if (rp(r)) {
    const i = r.slice(1, -1), o = np(i);
    return { ...e, [n]: o ?? r };
  }
  return { ...e, [n]: r };
}, {}), op = "@appcues/setUserProperties", sp = (t, { updateUserProfile: e }) => {
  if (!ep(t)) {
    const n = ip(t);
    e(n);
  }
};
ce(op, sp);
const ap = "@appcues/toggleActions", cp = ({ actions: t = [], target: e } = {}, n) => {
  const r = n.querySelector(e.selector);
  r.length !== 0 && t.forEach((i) => {
    const o = `toggleActions_${i.id}`, s = n.getAction(i.type), [a] = r, c = !a.getAttribute(o);
    s && c && (s(i.config, n), a.setAttribute(o, !0)), c || a.removeAttribute(o);
  });
};
ce(ap, cp);
const lp = /([\.\*\+\^\$\[\]\\\(\)\|\{\}\,\-\:\?])/g, Lo = /^([a-zA-Z]{2,3}|[a-zA-Z]{5,8})(-[a-zA-Z]{4})?(-(?:[a-zA-Z]{2}|\d{3}))?(-(?:[a-zA-Z\d]{5,8}|\d[a-zA-Z\d]{3}))?$/;
class Ne {
  // eslint-disable-line consistent-this
  /**
   * @param {string} locale
   */
  constructor(e) {
    if (typeof e != "string")
      throw new TypeError("A string argument is expected");
    if (!Lo.test(e))
      throw new RangeError("A proper locale must be provided");
    this._locale = e;
  }
  // Private functions - star
  /**
   * @param {null|undefined|string} [str]
   * @returns {null|undefined|string}
   */
  static _escapeRegExpPattern(e) {
    return typeof e != "string" ? e : e.replace(lp, "\\$1");
  }
  /**
   * @param {string|null} [str]
   * @param {boolean} [reserveReturnValue]
   */
  static _toLowerCase(e, n) {
    return typeof e != "string" ? n && e : e.toLowerCase();
  }
  /**
   * @param {string|null} [str]
   * @param {boolean} [reserveReturnValue]
   */
  static _toUpperCase(e, n) {
    return typeof e != "string" ? n && e : e.toUpperCase();
  }
  /**
   * @param {string|null} [str]
   * @param {string|null|string[]|boolean} [delimiter]
   * @param {boolean} [reserveReturnValue]
   */
  static _trim(e, n, r) {
    const i = [];
    let o;
    const s = function(c) {
      i.push("^" + c + "+|" + c + "+$");
    };
    if (typeof n == "boolean" && (r = n, n = null), typeof e != "string")
      return r ? e : void 0;
    if (Array.isArray(n) && n.map((c) => {
      const u = this._escapeRegExpPattern(c);
      s(u);
    }), typeof n == "string") {
      const c = this._escapeRegExpPattern(n);
      s(c);
    }
    n || s("\\s");
    const a = "(" + i.join("|") + ")";
    for (o = new RegExp(a, "g"); e.match(o); )
      e = e.replace(o, "");
    return e;
  }
  /**
   * @typedef {{
   *   lang: string,
   *   script: string|undefined,
   *   countryCode: string|undefined
   * }} LocaleInfo
   */
  /**
   * @param {string|null} [strLocale]
   * @returns {undefined|LocaleInfo}
   */
  static _parseLocale(e) {
    if (typeof e != "string")
      return;
    const n = Lo.exec(e);
    let r, i, o;
    if (!e || !n)
      return;
    const s = this._trim(n[2], ["-", "_"]), a = this._trim(n[3], ["-", "_"]);
    return r = /** @type {string} */
    this._toLowerCase(n[1]), i = this._toLowerCase(s) || i, o = this._toUpperCase(a) || o, {
      lang: r,
      script: i,
      countryCode: o
    };
  }
  // Private functions - End
  _isRtlLang() {
    const { lang: e, script: n } = (
      /** @type {LocaleInfo} */
      Ne._parseLocale(this._locale)
    );
    return n ? Ne._RTL_SCRIPTS.indexOf(n) >= 0 : Ne._BIDI_RTL_LANGS.indexOf(e) >= 0;
  }
  // Public functions - star
  get textInfo() {
    return { direction: this._isRtlLang() ? "rtl" : "ltr" };
  }
  // Public functions - End
}
Ne._RTL_SCRIPTS = [
  "adlm",
  "arab",
  "armi",
  "avst",
  "chrs",
  "cprt",
  "elym",
  "hatr",
  "hebr",
  "hung",
  "khar",
  "lydi",
  "mand",
  "mani",
  "mend",
  "merc",
  "mero",
  "narb",
  "nbat",
  "nkoo",
  "orkh",
  "ougr",
  "palm",
  "phli",
  "phlp",
  "phnx",
  "prti",
  "rohg",
  "samr",
  "sarb",
  "sogd",
  "sogo",
  "syrc",
  "thaa",
  "yezi"
];
Ne._BIDI_RTL_LANGS = [
  // Const BIDI_RTL_LANGS Array
  // BIDI_RTL_LANGS ref: http://en.wikipedia.org/wiki/Right-to-left
  // Table of scripts in Unicode: https://en.wikipedia.org/wiki/Script_(Unicode)
  "ae",
  // Avestan
  "aeb",
  // Tunisian Arabic
  "ajt",
  // Tunisian Arabic (old)
  "apc",
  // Levantine Arabic
  "apd",
  // Sudanese Arabic
  "ar",
  // 'العربية', Arabic
  "ara",
  // Arabic
  "arb",
  // Standard Arabic
  "arc",
  // Aramaic
  "arq",
  // Algerian Arabic
  "ars",
  // Najdi Arabic
  "ary",
  // Moroccan Arabic
  "arz",
  // Egyptian Arabic
  "ave",
  // Avestan
  "avl",
  // Eastern Egyptian Bedawi Arabic
  "bal",
  // Baluchi
  "bcc",
  // 'بلوچی مکرانی', Southern Balochi
  "bej",
  // Beja; Bedawiyet
  "bft",
  // Balti
  "bgn",
  // Western Balochi
  "bqi",
  // 'بختياري', Bakthiari
  "brh",
  // Brahui
  "cja",
  // Cham, Western
  "ckb",
  // 'Soranî / کوردی', Sorani
  "cld",
  // Chaldean Neo-Aramaic
  "dcc",
  // Deccan
  "dgl",
  // Andaandi
  "div",
  // Divehi
  "drw",
  // Darwazi (old)
  "dv",
  // Dhivehi
  "fa",
  // 'فارسی', Persian
  "fas",
  // Persian
  "fia",
  // Nobiin
  "fub",
  // Fulfulde (Adamawa)
  "gbz",
  // Dari, Zoroastrian
  "gjk",
  // Koli, Kachi
  "gju",
  // Gujari
  "glk",
  // 'گیلکی', Gilaki
  "grc",
  // Greek, Ancient (to 1453)
  "gwc",
  // Kalami
  "gwt",
  // Gawar-Bati
  "haz",
  // Hazaragi
  "he",
  // 'עברית', Hebrew
  "heb",
  // Hebrew
  "hnd",
  // Hindko, Southern
  "hno",
  // Hindko, Northern
  "iw",
  // Hebrew (old)
  "ji",
  // Yiddish (old)
  "kas",
  // Kashmiri
  "kby",
  // Kanuri, Manga
  "khw",
  // Khowar
  "ks",
  // Kashmiri
  "kvx",
  // Koli, Parkari
  "kxp",
  // Koli, Wadiyara
  "kzh",
  // Kenuzi-Dongola (old)
  "lad",
  // Ladino
  "lah",
  // Lahnda
  "lki",
  // Laki
  "lrc",
  // Luri, Northern
  "luz",
  // Luri, Southern
  "mde",
  // Maba (Chad)
  "mfa",
  // Malay, Pattani
  "mki",
  // Dhatki
  "mvy",
  // Kohistani, Indus
  "myz",
  // Mandaic, Classical
  "mzn",
  // 'مازِرونی', Mazanderani
  "nqo",
  // N'Ko
  "oru",
  // Ormuri
  "ota",
  // Turkish, Ottoman (1500–1928)
  "otk",
  // Turkish, Old
  "oui",
  // Uighur, Old
  "pal",
  // Pahlavi
  "pbu",
  // Pashto, Northern
  "per",
  // Persian
  "pes",
  // Western Farsi
  "phl",
  // Phalura
  "phn",
  // Phoenician
  "pnb",
  // 'پنجابی', Western Punjabi
  "pra",
  // Prakrit languages
  "prd",
  // Dari (Persian)
  "prs",
  // 'دری', Darī
  "ps",
  // 'پښتو', Pashto,
  "pus",
  // Pushto
  "rhg",
  // Rohingya
  "rmt",
  // Domari
  "scl",
  // Shina
  "sd",
  // 'سنڌي', Sindhi
  "sdh",
  // Kurdish, Southern
  "shu",
  // Arabic (Chadian)
  "skr",
  // Saraiki
  "smp",
  // Samaritan
  "snd",
  // Sindhi
  "sog",
  // Sogdian
  "swb",
  // Comorian
  "syr",
  // Syriac
  "tnf",
  // Tangshewi (old)
  "trw",
  // Torwali
  "ug",
  // 'Uyghurche / ئۇيغۇرچە', Uyghur
  "uig",
  // Uighur
  "ur",
  // 'اردو', Urdu
  "urd",
  // Urdu
  "wni",
  // Comorian, Ndzwani
  "xco",
  // Chorasmian
  "xld",
  // Lydian
  "xmn",
  // Manichaean Middle Persian
  "xmr",
  // Meroitic
  "xna",
  // North Arabian, Ancient
  "xpr",
  // Parthian
  "xsa",
  // Sabaean
  "ydd",
  // Yiddish, Eastern
  "yi",
  // 'ייִדיש', Yiddish
  "yid",
  // Yiddish
  "zdj"
  // Comorian, Ngazidja
];
const up = "@appcues/content-direction";
function fp(t) {
  try {
    return new Ne(t).textInfo;
  } catch {
    return { direction: "ltr" };
  }
}
const $o = ({ updateRootStyle: t, getTraitConfig: e }) => {
  const n = navigator.languages ? navigator.languages[0] : navigator.language || navigator.userLanguage, { currentLanguage: r = n, forceDirection: i = null } = e(), o = fp(r);
  t(
    {
      direction: i ?? o.direction
    },
    { forceUpdate: !0 }
  );
}, dp = ({ addHook: t }) => {
  t("step.begin", $o), t("step.container_change", $o);
};
St(up, dp);
const va = ["top", "right", "bottom", "left"], Mo = ["start", "end"], Ho = /* @__PURE__ */ va.reduce((t, e) => t.concat(e, e + "-" + Mo[0], e + "-" + Mo[1]), []), On = Math.min, qe = Math.max, vr = Math.round, Kt = (t) => ({
  x: t,
  y: t
}), pp = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, hp = {
  start: "end",
  end: "start"
};
function di(t, e, n) {
  return qe(t, On(e, n));
}
function tn(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function en(t) {
  return t.split("-")[0];
}
function oe(t) {
  return t.split("-")[1];
}
function ya(t) {
  return t === "x" ? "y" : "x";
}
function Pi(t) {
  return t === "y" ? "height" : "width";
}
const gp = /* @__PURE__ */ new Set(["top", "bottom"]);
function Or(t) {
  return gp.has(en(t)) ? "y" : "x";
}
function Ii(t) {
  return ya(Or(t));
}
function vp(t, e, n) {
  n === void 0 && (n = !1);
  const r = oe(t), i = Ii(t), o = Pi(i);
  let s = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return e.reference[o] > e.floating[o] && (s = jo(s)), [s, jo(s)];
}
function yp(t) {
  return t.replace(/start|end/g, (e) => hp[e]);
}
function jo(t) {
  return t.replace(/left|right|bottom|top/g, (e) => pp[e]);
}
function mp(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function ma(t) {
  return typeof t != "number" ? mp(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function yr(t) {
  const {
    x: e,
    y: n,
    width: r,
    height: i
  } = t;
  return {
    width: r,
    height: i,
    top: n,
    left: e,
    right: e + r,
    bottom: n + i,
    x: e,
    y: n
  };
}
function Uo(t, e, n) {
  let {
    reference: r,
    floating: i
  } = t;
  const o = Or(e), s = Ii(e), a = Pi(s), c = en(e), u = o === "y", p = r.x + r.width / 2 - i.width / 2, f = r.y + r.height / 2 - i.height / 2, l = r[a] / 2 - i[a] / 2;
  let d;
  switch (c) {
    case "top":
      d = {
        x: p,
        y: r.y - i.height
      };
      break;
    case "bottom":
      d = {
        x: p,
        y: r.y + r.height
      };
      break;
    case "right":
      d = {
        x: r.x + r.width,
        y: f
      };
      break;
    case "left":
      d = {
        x: r.x - i.width,
        y: f
      };
      break;
    default:
      d = {
        x: r.x,
        y: r.y
      };
  }
  switch (oe(e)) {
    case "start":
      d[s] -= l * (n && u ? -1 : 1);
      break;
    case "end":
      d[s] += l * (n && u ? -1 : 1);
      break;
  }
  return d;
}
const Ep = async (t, e, n) => {
  const {
    placement: r = "bottom",
    strategy: i = "absolute",
    middleware: o = [],
    platform: s
  } = n, a = o.filter(Boolean), c = await (s.isRTL == null ? void 0 : s.isRTL(e));
  let u = await s.getElementRects({
    reference: t,
    floating: e,
    strategy: i
  }), {
    x: p,
    y: f
  } = Uo(u, r, c), l = r, d = {}, h = 0;
  for (let v = 0; v < a.length; v++) {
    const {
      name: m,
      fn: S
    } = a[v], {
      x: y,
      y: x,
      data: T,
      reset: b
    } = await S({
      x: p,
      y: f,
      initialPlacement: r,
      placement: l,
      strategy: i,
      middlewareData: d,
      rects: u,
      platform: s,
      elements: {
        reference: t,
        floating: e
      }
    });
    p = y ?? p, f = x ?? f, d = {
      ...d,
      [m]: {
        ...d[m],
        ...T
      }
    }, b && h <= 50 && (h++, typeof b == "object" && (b.placement && (l = b.placement), b.rects && (u = b.rects === !0 ? await s.getElementRects({
      reference: t,
      floating: e,
      strategy: i
    }) : b.rects), {
      x: p,
      y: f
    } = Uo(u, l, c)), v = -1);
  }
  return {
    x: p,
    y: f,
    placement: l,
    strategy: i,
    middlewareData: d
  };
};
async function mr(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: r,
    y: i,
    platform: o,
    rects: s,
    elements: a,
    strategy: c
  } = t, {
    boundary: u = "clippingAncestors",
    rootBoundary: p = "viewport",
    elementContext: f = "floating",
    altBoundary: l = !1,
    padding: d = 0
  } = tn(e, t), h = ma(d), m = a[l ? f === "floating" ? "reference" : "floating" : f], S = yr(await o.getClippingRect({
    element: (n = await (o.isElement == null ? void 0 : o.isElement(m))) == null || n ? m : m.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(a.floating)),
    boundary: u,
    rootBoundary: p,
    strategy: c
  })), y = f === "floating" ? {
    x: r,
    y: i,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, x = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(a.floating)), T = await (o.isElement == null ? void 0 : o.isElement(x)) ? await (o.getScale == null ? void 0 : o.getScale(x)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, b = yr(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: y,
    offsetParent: x,
    strategy: c
  }) : y);
  return {
    top: (S.top - b.top + h.top) / T.y,
    bottom: (b.bottom - S.bottom + h.bottom) / T.y,
    left: (S.left - b.left + h.left) / T.x,
    right: (b.right - S.right + h.right) / T.x
  };
}
const Sp = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: n,
      y: r,
      placement: i,
      rects: o,
      platform: s,
      elements: a,
      middlewareData: c
    } = e, {
      element: u,
      padding: p = 0
    } = tn(t, e) || {};
    if (u == null)
      return {};
    const f = ma(p), l = {
      x: n,
      y: r
    }, d = Ii(i), h = Pi(d), v = await s.getDimensions(u), m = d === "y", S = m ? "top" : "left", y = m ? "bottom" : "right", x = m ? "clientHeight" : "clientWidth", T = o.reference[h] + o.reference[d] - l[d] - o.floating[h], b = l[d] - o.reference[d], A = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(u));
    let R = A ? A[x] : 0;
    (!R || !await (s.isElement == null ? void 0 : s.isElement(A))) && (R = a.floating[x] || o.floating[h]);
    const O = T / 2 - b / 2, P = R / 2 - v[h] / 2 - 1, D = On(f[S], P), L = On(f[y], P), $ = D, q = R - v[h] - L, Y = R / 2 - v[h] / 2 + O, G = di($, Y, q), nt = !c.arrow && oe(i) != null && Y !== G && o.reference[h] / 2 - (Y < $ ? D : L) - v[h] / 2 < 0, J = nt ? Y < $ ? Y - $ : Y - q : 0;
    return {
      [d]: l[d] + J,
      data: {
        [d]: G,
        centerOffset: Y - G - J,
        ...nt && {
          alignmentOffset: J
        }
      },
      reset: nt
    };
  }
});
function bp(t, e, n) {
  return (t ? [...n.filter((i) => oe(i) === t), ...n.filter((i) => oe(i) !== t)] : n.filter((i) => en(i) === i)).filter((i) => t ? oe(i) === t || (e ? yp(i) !== i : !1) : !0);
}
const xp = function(t) {
  return t === void 0 && (t = {}), {
    name: "autoPlacement",
    options: t,
    async fn(e) {
      var n, r, i;
      const {
        rects: o,
        middlewareData: s,
        placement: a,
        platform: c,
        elements: u
      } = e, {
        crossAxis: p = !1,
        alignment: f,
        allowedPlacements: l = Ho,
        autoAlignment: d = !0,
        ...h
      } = tn(t, e), v = f !== void 0 || l === Ho ? bp(f || null, d, l) : l, m = await mr(e, h), S = ((n = s.autoPlacement) == null ? void 0 : n.index) || 0, y = v[S];
      if (y == null)
        return {};
      const x = vp(y, o, await (c.isRTL == null ? void 0 : c.isRTL(u.floating)));
      if (a !== y)
        return {
          reset: {
            placement: v[0]
          }
        };
      const T = [m[en(y)], m[x[0]], m[x[1]]], b = [...((r = s.autoPlacement) == null ? void 0 : r.overflows) || [], {
        placement: y,
        overflows: T
      }], A = v[S + 1];
      if (A)
        return {
          data: {
            index: S + 1,
            overflows: b
          },
          reset: {
            placement: A
          }
        };
      const R = b.map((D) => {
        const L = oe(D.placement);
        return [D.placement, L && p ? (
          // Check along the mainAxis and main crossAxis side.
          D.overflows.slice(0, 2).reduce(($, q) => $ + q, 0)
        ) : (
          // Check only the mainAxis.
          D.overflows[0]
        ), D.overflows];
      }).sort((D, L) => D[1] - L[1]), P = ((i = R.filter((D) => D[2].slice(
        0,
        // Aligned placements should not check their opposite crossAxis
        // side.
        oe(D[0]) ? 2 : 3
      ).every((L) => L <= 0))[0]) == null ? void 0 : i[0]) || R[0][0];
      return P !== a ? {
        data: {
          index: S + 1,
          overflows: b
        },
        reset: {
          placement: P
        }
      } : {};
    }
  };
};
function Fo(t, e) {
  return {
    top: t.top - e.height,
    right: t.right - e.width,
    bottom: t.bottom - e.height,
    left: t.left - e.width
  };
}
function Bo(t) {
  return va.some((e) => t[e] >= 0);
}
const wp = function(t) {
  return t === void 0 && (t = {}), {
    name: "hide",
    options: t,
    async fn(e) {
      const {
        rects: n
      } = e, {
        strategy: r = "referenceHidden",
        ...i
      } = tn(t, e);
      switch (r) {
        case "referenceHidden": {
          const o = await mr(e, {
            ...i,
            elementContext: "reference"
          }), s = Fo(o, n.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: Bo(s)
            }
          };
        }
        case "escaped": {
          const o = await mr(e, {
            ...i,
            altBoundary: !0
          }), s = Fo(o, n.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: Bo(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, _p = /* @__PURE__ */ new Set(["left", "top"]);
async function Tp(t, e) {
  const {
    placement: n,
    platform: r,
    elements: i
  } = t, o = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), s = en(n), a = oe(n), c = Or(n) === "y", u = _p.has(s) ? -1 : 1, p = o && c ? -1 : 1, f = tn(e, t);
  let {
    mainAxis: l,
    crossAxis: d,
    alignmentAxis: h
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return a && typeof h == "number" && (d = a === "end" ? h * -1 : h), c ? {
    x: d * p,
    y: l * u
  } : {
    x: l * u,
    y: d * p
  };
}
const Rp = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var n, r;
      const {
        x: i,
        y: o,
        placement: s,
        middlewareData: a
      } = e, c = await Tp(e, t);
      return s === ((n = a.offset) == null ? void 0 : n.placement) && (r = a.arrow) != null && r.alignmentOffset ? {} : {
        x: i + c.x,
        y: o + c.y,
        data: {
          ...c,
          placement: s
        }
      };
    }
  };
}, Cp = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: r,
        placement: i
      } = e, {
        mainAxis: o = !0,
        crossAxis: s = !1,
        limiter: a = {
          fn: (m) => {
            let {
              x: S,
              y
            } = m;
            return {
              x: S,
              y
            };
          }
        },
        ...c
      } = tn(t, e), u = {
        x: n,
        y: r
      }, p = await mr(e, c), f = Or(en(i)), l = ya(f);
      let d = u[l], h = u[f];
      if (o) {
        const m = l === "y" ? "top" : "left", S = l === "y" ? "bottom" : "right", y = d + p[m], x = d - p[S];
        d = di(y, d, x);
      }
      if (s) {
        const m = f === "y" ? "top" : "left", S = f === "y" ? "bottom" : "right", y = h + p[m], x = h - p[S];
        h = di(y, h, x);
      }
      const v = a.fn({
        ...e,
        [l]: d,
        [f]: h
      });
      return {
        ...v,
        data: {
          x: v.x - n,
          y: v.y - r,
          enabled: {
            [l]: o,
            [f]: s
          }
        }
      };
    }
  };
};
function Ar() {
  return typeof window < "u";
}
function nn(t) {
  return Ea(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function Mt(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function ue(t) {
  var e;
  return (e = (Ea(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function Ea(t) {
  return Ar() ? t instanceof Node || t instanceof Mt(t).Node : !1;
}
function Wt(t) {
  return Ar() ? t instanceof Element || t instanceof Mt(t).Element : !1;
}
function Yt(t) {
  return Ar() ? t instanceof HTMLElement || t instanceof Mt(t).HTMLElement : !1;
}
function zo(t) {
  return !Ar() || typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof Mt(t).ShadowRoot;
}
const Op = /* @__PURE__ */ new Set(["inline", "contents"]);
function kn(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: r,
    display: i
  } = Vt(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + r + n) && !Op.has(i);
}
const Ap = /* @__PURE__ */ new Set(["table", "td", "th"]);
function Np(t) {
  return Ap.has(nn(t));
}
const Pp = [":popover-open", ":modal"];
function Nr(t) {
  return Pp.some((e) => {
    try {
      return t.matches(e);
    } catch {
      return !1;
    }
  });
}
const Ip = ["transform", "translate", "scale", "rotate", "perspective"], Dp = ["transform", "translate", "scale", "rotate", "perspective", "filter"], kp = ["paint", "layout", "strict", "content"];
function Di(t) {
  const e = ki(), n = Wt(t) ? Vt(t) : t;
  return Ip.some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !e && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !e && (n.filter ? n.filter !== "none" : !1) || Dp.some((r) => (n.willChange || "").includes(r)) || kp.some((r) => (n.contain || "").includes(r));
}
function Lp(t) {
  let e = be(t);
  for (; Yt(e) && !Je(e); ) {
    if (Di(e))
      return e;
    if (Nr(e))
      return null;
    e = be(e);
  }
  return null;
}
function ki() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const $p = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function Je(t) {
  return $p.has(nn(t));
}
function Vt(t) {
  return Mt(t).getComputedStyle(t);
}
function Pr(t) {
  return Wt(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function be(t) {
  if (nn(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    zo(t) && t.host || // Fallback.
    ue(t)
  );
  return zo(e) ? e.host : e;
}
function Sa(t) {
  const e = be(t);
  return Je(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : Yt(e) && kn(e) ? e : Sa(e);
}
function Er(t, e, n) {
  var r;
  e === void 0 && (e = []), n === void 0 && (n = !0);
  const i = Sa(t), o = i === ((r = t.ownerDocument) == null ? void 0 : r.body), s = Mt(i);
  if (o) {
    const a = pi(s);
    return e.concat(s, s.visualViewport || [], kn(i) ? i : [], a && n ? Er(a) : []);
  }
  return e.concat(i, Er(i, [], n));
}
function pi(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
function ba(t) {
  const e = Vt(t);
  let n = parseFloat(e.width) || 0, r = parseFloat(e.height) || 0;
  const i = Yt(t), o = i ? t.offsetWidth : n, s = i ? t.offsetHeight : r, a = vr(n) !== o || vr(r) !== s;
  return a && (n = o, r = s), {
    width: n,
    height: r,
    $: a
  };
}
function xa(t) {
  return Wt(t) ? t : t.contextElement;
}
function We(t) {
  const e = xa(t);
  if (!Yt(e))
    return Kt(1);
  const n = e.getBoundingClientRect(), {
    width: r,
    height: i,
    $: o
  } = ba(e);
  let s = (o ? vr(n.width) : n.width) / r, a = (o ? vr(n.height) : n.height) / i;
  return (!s || !Number.isFinite(s)) && (s = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: s,
    y: a
  };
}
const Mp = /* @__PURE__ */ Kt(0);
function wa(t) {
  const e = Mt(t);
  return !ki() || !e.visualViewport ? Mp : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function Hp(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== Mt(t) ? !1 : e;
}
function An(t, e, n, r) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const i = t.getBoundingClientRect(), o = xa(t);
  let s = Kt(1);
  e && (r ? Wt(r) && (s = We(r)) : s = We(t));
  const a = Hp(o, n, r) ? wa(o) : Kt(0);
  let c = (i.left + a.x) / s.x, u = (i.top + a.y) / s.y, p = i.width / s.x, f = i.height / s.y;
  if (o) {
    const l = Mt(o), d = r && Wt(r) ? Mt(r) : r;
    let h = l, v = pi(h);
    for (; v && r && d !== h; ) {
      const m = We(v), S = v.getBoundingClientRect(), y = Vt(v), x = S.left + (v.clientLeft + parseFloat(y.paddingLeft)) * m.x, T = S.top + (v.clientTop + parseFloat(y.paddingTop)) * m.y;
      c *= m.x, u *= m.y, p *= m.x, f *= m.y, c += x, u += T, h = Mt(v), v = pi(h);
    }
  }
  return yr({
    width: p,
    height: f,
    x: c,
    y: u
  });
}
function Ir(t, e) {
  const n = Pr(t).scrollLeft;
  return e ? e.left + n : An(ue(t)).left + n;
}
function _a(t, e) {
  const n = t.getBoundingClientRect(), r = n.left + e.scrollLeft - Ir(t, n), i = n.top + e.scrollTop;
  return {
    x: r,
    y: i
  };
}
function jp(t) {
  let {
    elements: e,
    rect: n,
    offsetParent: r,
    strategy: i
  } = t;
  const o = i === "fixed", s = ue(r), a = e ? Nr(e.floating) : !1;
  if (r === s || a && o)
    return n;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = Kt(1);
  const p = Kt(0), f = Yt(r);
  if ((f || !f && !o) && ((nn(r) !== "body" || kn(s)) && (c = Pr(r)), Yt(r))) {
    const d = An(r);
    u = We(r), p.x = d.x + r.clientLeft, p.y = d.y + r.clientTop;
  }
  const l = s && !f && !o ? _a(s, c) : Kt(0);
  return {
    width: n.width * u.x,
    height: n.height * u.y,
    x: n.x * u.x - c.scrollLeft * u.x + p.x + l.x,
    y: n.y * u.y - c.scrollTop * u.y + p.y + l.y
  };
}
function Up(t) {
  return Array.from(t.getClientRects());
}
function Fp(t) {
  const e = ue(t), n = Pr(t), r = t.ownerDocument.body, i = qe(e.scrollWidth, e.clientWidth, r.scrollWidth, r.clientWidth), o = qe(e.scrollHeight, e.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -n.scrollLeft + Ir(t);
  const a = -n.scrollTop;
  return Vt(r).direction === "rtl" && (s += qe(e.clientWidth, r.clientWidth) - i), {
    width: i,
    height: o,
    x: s,
    y: a
  };
}
const qo = 25;
function Bp(t, e) {
  const n = Mt(t), r = ue(t), i = n.visualViewport;
  let o = r.clientWidth, s = r.clientHeight, a = 0, c = 0;
  if (i) {
    o = i.width, s = i.height;
    const p = ki();
    (!p || p && e === "fixed") && (a = i.offsetLeft, c = i.offsetTop);
  }
  const u = Ir(r);
  if (u <= 0) {
    const p = r.ownerDocument, f = p.body, l = getComputedStyle(f), d = p.compatMode === "CSS1Compat" && parseFloat(l.marginLeft) + parseFloat(l.marginRight) || 0, h = Math.abs(r.clientWidth - f.clientWidth - d);
    h <= qo && (o -= h);
  } else u <= qo && (o += u);
  return {
    width: o,
    height: s,
    x: a,
    y: c
  };
}
const zp = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function qp(t, e) {
  const n = An(t, !0, e === "fixed"), r = n.top + t.clientTop, i = n.left + t.clientLeft, o = Yt(t) ? We(t) : Kt(1), s = t.clientWidth * o.x, a = t.clientHeight * o.y, c = i * o.x, u = r * o.y;
  return {
    width: s,
    height: a,
    x: c,
    y: u
  };
}
function Wo(t, e, n) {
  let r;
  if (e === "viewport")
    r = Bp(t, n);
  else if (e === "document")
    r = Fp(ue(t));
  else if (Wt(e))
    r = qp(e, n);
  else {
    const i = wa(t);
    r = {
      x: e.x - i.x,
      y: e.y - i.y,
      width: e.width,
      height: e.height
    };
  }
  return yr(r);
}
function Ta(t, e) {
  const n = be(t);
  return n === e || !Wt(n) || Je(n) ? !1 : Vt(n).position === "fixed" || Ta(n, e);
}
function Wp(t, e) {
  const n = e.get(t);
  if (n)
    return n;
  let r = Er(t, [], !1).filter((a) => Wt(a) && nn(a) !== "body"), i = null;
  const o = Vt(t).position === "fixed";
  let s = o ? be(t) : t;
  for (; Wt(s) && !Je(s); ) {
    const a = Vt(s), c = Di(s);
    !c && a.position === "fixed" && (i = null), (o ? !c && !i : !c && a.position === "static" && !!i && zp.has(i.position) || kn(s) && !c && Ta(t, s)) ? r = r.filter((p) => p !== s) : i = a, s = be(s);
  }
  return e.set(t, r), r;
}
function Vp(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: r,
    strategy: i
  } = t;
  const s = [...n === "clippingAncestors" ? Nr(e) ? [] : Wp(e, this._c) : [].concat(n), r], a = s[0], c = s.reduce((u, p) => {
    const f = Wo(e, p, i);
    return u.top = qe(f.top, u.top), u.right = On(f.right, u.right), u.bottom = On(f.bottom, u.bottom), u.left = qe(f.left, u.left), u;
  }, Wo(e, a, i));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function Gp(t) {
  const {
    width: e,
    height: n
  } = ba(t);
  return {
    width: e,
    height: n
  };
}
function Kp(t, e, n) {
  const r = Yt(e), i = ue(e), o = n === "fixed", s = An(t, !0, o, e);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = Kt(0);
  function u() {
    c.x = Ir(i);
  }
  if (r || !r && !o)
    if ((nn(e) !== "body" || kn(i)) && (a = Pr(e)), r) {
      const d = An(e, !0, o, e);
      c.x = d.x + e.clientLeft, c.y = d.y + e.clientTop;
    } else i && u();
  o && !r && i && u();
  const p = i && !r && !o ? _a(i, a) : Kt(0), f = s.left + a.scrollLeft - c.x - p.x, l = s.top + a.scrollTop - c.y - p.y;
  return {
    x: f,
    y: l,
    width: s.width,
    height: s.height
  };
}
function Wr(t) {
  return Vt(t).position === "static";
}
function Vo(t, e) {
  if (!Yt(t) || Vt(t).position === "fixed")
    return null;
  if (e)
    return e(t);
  let n = t.offsetParent;
  return ue(t) === n && (n = n.ownerDocument.body), n;
}
function Ra(t, e) {
  const n = Mt(t);
  if (Nr(t))
    return n;
  if (!Yt(t)) {
    let i = be(t);
    for (; i && !Je(i); ) {
      if (Wt(i) && !Wr(i))
        return i;
      i = be(i);
    }
    return n;
  }
  let r = Vo(t, e);
  for (; r && Np(r) && Wr(r); )
    r = Vo(r, e);
  return r && Je(r) && Wr(r) && !Di(r) ? n : r || Lp(t) || n;
}
const Xp = async function(t) {
  const e = this.getOffsetParent || Ra, n = this.getDimensions, r = await n(t.floating);
  return {
    reference: Kp(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function Yp(t) {
  return Vt(t).direction === "rtl";
}
const Zp = {
  convertOffsetParentRelativeRectToViewportRelativeRect: jp,
  getDocumentElement: ue,
  getClippingRect: Vp,
  getOffsetParent: Ra,
  getElementRects: Xp,
  getClientRects: Up,
  getDimensions: Gp,
  getScale: We,
  isElement: Wt,
  isRTL: Yp
}, Jp = Rp, Qp = xp, th = Cp, eh = wp, nh = Sp, rh = (t, e, n) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: Zp,
    ...n
  }, o = {
    ...i.platform,
    _c: r
  };
  return Ep(t, e, {
    ...i,
    platform: o
  });
};
var Vr, Go;
function ih() {
  if (Go) return Vr;
  Go = 1;
  var t = "Expected a function", e = NaN, n = "[object Symbol]", r = /^\s+|\s+$/g, i = /^[-+]0x[0-9a-f]+$/i, o = /^0b[01]+$/i, s = /^0o[0-7]+$/i, a = parseInt, c = typeof Ft == "object" && Ft && Ft.Object === Object && Ft, u = typeof self == "object" && self && self.Object === Object && self, p = c || u || Function("return this")(), f = Object.prototype, l = f.toString, d = Math.max, h = Math.min, v = function() {
    return p.Date.now();
  };
  function m(b, A, R) {
    var O, P, D, L, $, q, Y = 0, G = !1, nt = !1, J = !0;
    if (typeof b != "function")
      throw new TypeError(t);
    A = T(A) || 0, S(R) && (G = !!R.leading, nt = "maxWait" in R, D = nt ? d(T(R.maxWait) || 0, A) : D, J = "trailing" in R ? !!R.trailing : J);
    function V(tt) {
      var pt = O, _t = P;
      return O = P = void 0, Y = tt, L = b.apply(_t, pt), L;
    }
    function ot(tt) {
      return Y = tt, $ = setTimeout(rt, A), G ? V(tt) : L;
    }
    function Q(tt) {
      var pt = tt - q, _t = tt - Y, Dt = A - pt;
      return nt ? h(Dt, D - _t) : Dt;
    }
    function et(tt) {
      var pt = tt - q, _t = tt - Y;
      return q === void 0 || pt >= A || pt < 0 || nt && _t >= D;
    }
    function rt() {
      var tt = v();
      if (et(tt))
        return gt(tt);
      $ = setTimeout(rt, Q(tt));
    }
    function gt(tt) {
      return $ = void 0, J && O ? V(tt) : (O = P = void 0, L);
    }
    function xt() {
      $ !== void 0 && clearTimeout($), Y = 0, O = q = P = $ = void 0;
    }
    function U() {
      return $ === void 0 ? L : gt(v());
    }
    function W() {
      var tt = v(), pt = et(tt);
      if (O = arguments, P = this, q = tt, pt) {
        if ($ === void 0)
          return ot(q);
        if (nt)
          return $ = setTimeout(rt, A), V(q);
      }
      return $ === void 0 && ($ = setTimeout(rt, A)), L;
    }
    return W.cancel = xt, W.flush = U, W;
  }
  function S(b) {
    var A = typeof b;
    return !!b && (A == "object" || A == "function");
  }
  function y(b) {
    return !!b && typeof b == "object";
  }
  function x(b) {
    return typeof b == "symbol" || y(b) && l.call(b) == n;
  }
  function T(b) {
    if (typeof b == "number")
      return b;
    if (x(b))
      return e;
    if (S(b)) {
      var A = typeof b.valueOf == "function" ? b.valueOf() : b;
      b = S(A) ? A + "" : A;
    }
    if (typeof b != "string")
      return b === 0 ? b : +b;
    b = b.replace(r, "");
    var R = o.test(b);
    return R || s.test(b) ? a(b.slice(2), R ? 2 : 8) : i.test(b) ? e : +b;
  }
  return Vr = m, Vr;
}
var oh = ih();
const Ca = /* @__PURE__ */ Ie(oh);
var Gr, Ko;
function sh() {
  if (Ko) return Gr;
  Ko = 1;
  var t = 200, e = "__lodash_hash_undefined__", n = 1 / 0, r = "[object Function]", i = "[object GeneratorFunction]", o = /[\\^$.*+?()[\]{}|]/g, s = /^\[object .+?Constructor\]$/, a = typeof Ft == "object" && Ft && Ft.Object === Object && Ft, c = typeof self == "object" && self && self.Object === Object && self, u = a || c || Function("return this")();
  function p(C, j) {
    var g = C ? C.length : 0;
    return !!g && l(C, j, 0) > -1;
  }
  function f(C, j, g, w) {
    for (var I = C.length, N = g + -1; ++N < I; )
      if (j(C[N], N, C))
        return N;
    return -1;
  }
  function l(C, j, g) {
    if (j !== j)
      return f(C, d, g);
    for (var w = g - 1, I = C.length; ++w < I; )
      if (C[w] === j)
        return w;
    return -1;
  }
  function d(C) {
    return C !== C;
  }
  function h(C, j) {
    return C.has(j);
  }
  function v(C, j) {
    return C?.[j];
  }
  function m(C) {
    var j = !1;
    if (C != null && typeof C.toString != "function")
      try {
        j = !!(C + "");
      } catch {
      }
    return j;
  }
  function S(C) {
    var j = -1, g = Array(C.size);
    return C.forEach(function(w) {
      g[++j] = w;
    }), g;
  }
  var y = Array.prototype, x = Function.prototype, T = Object.prototype, b = u["__core-js_shared__"], A = (function() {
    var C = /[^.]+$/.exec(b && b.keys && b.keys.IE_PROTO || "");
    return C ? "Symbol(src)_1." + C : "";
  })(), R = x.toString, O = T.hasOwnProperty, P = T.toString, D = RegExp(
    "^" + R.call(O).replace(o, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), L = y.splice, $ = pe(u, "Map"), q = pe(u, "Set"), Y = pe(Object, "create");
  function G(C) {
    var j = -1, g = C ? C.length : 0;
    for (this.clear(); ++j < g; ) {
      var w = C[j];
      this.set(w[0], w[1]);
    }
  }
  function nt() {
    this.__data__ = Y ? Y(null) : {};
  }
  function J(C) {
    return this.has(C) && delete this.__data__[C];
  }
  function V(C) {
    var j = this.__data__;
    if (Y) {
      var g = j[C];
      return g === e ? void 0 : g;
    }
    return O.call(j, C) ? j[C] : void 0;
  }
  function ot(C) {
    var j = this.__data__;
    return Y ? j[C] !== void 0 : O.call(j, C);
  }
  function Q(C, j) {
    var g = this.__data__;
    return g[C] = Y && j === void 0 ? e : j, this;
  }
  G.prototype.clear = nt, G.prototype.delete = J, G.prototype.get = V, G.prototype.has = ot, G.prototype.set = Q;
  function et(C) {
    var j = -1, g = C ? C.length : 0;
    for (this.clear(); ++j < g; ) {
      var w = C[j];
      this.set(w[0], w[1]);
    }
  }
  function rt() {
    this.__data__ = [];
  }
  function gt(C) {
    var j = this.__data__, g = fe(j, C);
    if (g < 0)
      return !1;
    var w = j.length - 1;
    return g == w ? j.pop() : L.call(j, g, 1), !0;
  }
  function xt(C) {
    var j = this.__data__, g = fe(j, C);
    return g < 0 ? void 0 : j[g][1];
  }
  function U(C) {
    return fe(this.__data__, C) > -1;
  }
  function W(C, j) {
    var g = this.__data__, w = fe(g, C);
    return w < 0 ? g.push([C, j]) : g[w][1] = j, this;
  }
  et.prototype.clear = rt, et.prototype.delete = gt, et.prototype.get = xt, et.prototype.has = U, et.prototype.set = W;
  function tt(C) {
    var j = -1, g = C ? C.length : 0;
    for (this.clear(); ++j < g; ) {
      var w = C[j];
      this.set(w[0], w[1]);
    }
  }
  function pt() {
    this.__data__ = {
      hash: new G(),
      map: new ($ || et)(),
      string: new G()
    };
  }
  function _t(C) {
    return de(this, C).delete(C);
  }
  function Dt(C) {
    return de(this, C).get(C);
  }
  function Zt(C) {
    return de(this, C).has(C);
  }
  function Nt(C, j) {
    return de(this, C).set(C, j), this;
  }
  tt.prototype.clear = pt, tt.prototype.delete = _t, tt.prototype.get = Dt, tt.prototype.has = Zt, tt.prototype.set = Nt;
  function kt(C) {
    var j = -1, g = C ? C.length : 0;
    for (this.__data__ = new tt(); ++j < g; )
      this.add(C[j]);
  }
  function Jt(C) {
    return this.__data__.set(C, e), this;
  }
  function ke(C) {
    return this.__data__.has(C);
  }
  kt.prototype.add = kt.prototype.push = Jt, kt.prototype.has = ke;
  function fe(C, j) {
    for (var g = C.length; g--; )
      if (Le(C[g][0], j))
        return g;
    return -1;
  }
  function rn(C) {
    if (!Qt(C) || cn(C))
      return !1;
    var j = he(C) || m(C) ? D : s;
    return j.test(ln(C));
  }
  function on(C, j, g) {
    var w = -1, I = p, N = C.length, M = !0, F = [], z = F;
    if (N >= t) {
      var K = sn(C);
      if (K)
        return S(K);
      M = !1, I = h, z = new kt();
    } else
      z = F;
    t:
      for (; ++w < N; ) {
        var Z = C[w], at = Z;
        if (Z = Z !== 0 ? Z : 0, M && at === at) {
          for (var dt = z.length; dt--; )
            if (z[dt] === at)
              continue t;
          F.push(Z);
        } else I(z, at, g) || (z !== F && z.push(at), F.push(Z));
      }
    return F;
  }
  var sn = q && 1 / S(new q([, -0]))[1] == n ? function(C) {
    return new q(C);
  } : xe;
  function de(C, j) {
    var g = C.__data__;
    return an(j) ? g[typeof j == "string" ? "string" : "hash"] : g.map;
  }
  function pe(C, j) {
    var g = v(C, j);
    return rn(g) ? g : void 0;
  }
  function an(C) {
    var j = typeof C;
    return j == "string" || j == "number" || j == "symbol" || j == "boolean" ? C !== "__proto__" : C === null;
  }
  function cn(C) {
    return !!A && A in C;
  }
  function ln(C) {
    if (C != null) {
      try {
        return R.call(C);
      } catch {
      }
      try {
        return C + "";
      } catch {
      }
    }
    return "";
  }
  function un(C) {
    return C && C.length ? on(C) : [];
  }
  function Le(C, j) {
    return C === j || C !== C && j !== j;
  }
  function he(C) {
    var j = Qt(C) ? P.call(C) : "";
    return j == r || j == i;
  }
  function Qt(C) {
    var j = typeof C;
    return !!C && (j == "object" || j == "function");
  }
  function xe() {
  }
  return Gr = un, Gr;
}
var ah = sh();
const ch = /* @__PURE__ */ Ie(ah), Oa = 10, Aa = 15, lh = (t, e, n, r) => {
  const i = `-${Aa / 2}px`, { staticSide: o, rotation: s, shadowOpacity: a } = {
    top: {
      staticSide: "bottom",
      rotation: 45,
      shadowOpacity: 40
    },
    bottom: {
      staticSide: "top",
      rotation: 225,
      shadowOpacity: 7
    },
    right: {
      staticSide: "left",
      rotation: 135,
      shadowOpacity: 7
    },
    left: {
      staticSide: "right",
      rotation: -45,
      shadowOpacity: 40
    }
  }[t.split("-")[0]];
  return {
    boxShadow: `1px 1px 1px hsl(0deg 0% 13% / ${a}%)`,
    transform: `rotate(${s}deg)`,
    clipPath: "polygon(0% 100%, 100% 100%, 100% 0%)",
    left: e != null ? `${e}px` : "",
    top: n != null ? `${n}px` : "",
    right: "",
    bottom: "",
    [o]: i,
    zIndex: r
  };
}, Xo = (t, e) => {
  const n = t.slice(1);
  return e.find(
    ({ config: r, type: i }) => i === "@appcues/overlay" && n === r.rootId
  );
}, uh = (t, e) => {
  const n = Oa + Aa / 2;
  return e.includes("start") ? t - n : t + n;
}, fh = ({
  placementUnit: t,
  distance: e,
  skidding: n,
  placement: r,
  targetEl: i
}) => {
  const o = r.startsWith("left") || r.startsWith("right"), s = o ? e : n, a = o ? n : e;
  if (t !== "percentage" || !i)
    return {
      mainAxis: e,
      crossAxis: n
    };
  const { width: c, height: u } = i.getBoundingClientRect(), p = o ? c * s / 100 : u * a / 100, f = o ? u * a / 100 : c * s / 100;
  return {
    mainAxis: p,
    crossAxis: f
  };
}, Sr = (t, e) => {
  try {
    const n = e(), r = n.document, i = n.getComputedStyle(t), { overflow: o, overflowY: s, overflowX: a } = i, c = /* @__PURE__ */ new Set([o, s, a]);
    if (i.position === "fixed" || i.position === "sticky" || c.has("auto") || c.has("hidden"))
      return !0;
    const { host: u = null } = t?.getRootNode() ?? {}, p = u?.tagName?.includes(Pn) || u?.tagName?.includes(In);
    return t.parentElement === null && u && !p ? Sr(u.parentElement, e) : t.parentElement !== null && t.parentElement !== r.body ? Sr(t.parentElement, e) : !1;
  } catch {
    return !1;
  }
};
function Yo(t) {
  return t === "fixed" || t === "relative" || t === "absolute" || t === "sticky";
}
function Zo(t) {
  return t.display === "flex" || t.display === "inline-flex";
}
function Na(t, e, n, r, i) {
  let o = i, s = e.zIndex;
  const a = e.position, c = t.parentElement, u = c ? r.getComputedStyle(c) : {};
  if (s !== "" && s !== "auto" && !Yo(a) && !Zo(u) && (s = "auto"), (!o || s !== "" && s !== "auto" && (Yo(a) || Zo(u))) && (o = s), c && c !== n.body && c !== n.documentElement)
    return Na(c, u, n, r, o);
  if (/^\d+$/.test(o)) {
    let p = Number.parseInt(o, 10);
    p += 1, o = p;
  }
  return o;
}
const dh = (t, e) => {
  const n = e(), r = n.document, i = n.getComputedStyle(t);
  return Na(t, i, r, n);
}, ph = ({
  targetEl: t,
  rootStyle: e,
  shouldAutoCalculateZIndex: n,
  getWindowReference: r
}) => {
  let i = e;
  if (n) {
    const o = dh(t, r);
    i = { ...e, zIndex: o };
  }
  return i;
}, hh = () => {
  const t = /* @__PURE__ */ new Map();
  function e(i) {
    i.composedPath().forEach((o) => {
      (t.get(o) ?? {})[i.type]?.map((a) => a(i));
    });
  }
  return {
    addEventListener: (i, o, s) => {
      t.get(i) || t.set(i, {});
      const a = t.get(i);
      a[o] || (a[o] = []), a[o].includes(s) || (a[o] = [...a[o], s], t.set(i, a)), a[o].length === 1 && i.addEventListener(o, e, !0);
    },
    removeEventListener: (i, o, s) => {
      const a = t.get(i);
      if (!a)
        return;
      const c = (a[o] ?? []).filter(
        (u) => u !== s
      );
      a[o] = c, t.set(i, a), a[o].length === 0 && i.removeEventListener(o, e, !0);
    }
  };
}, { addEventListener: br, removeEventListener: xr } = hh(), gh = () => {
  const t = /* @__PURE__ */ new Map(), e = /* @__PURE__ */ new Map(), n = (o) => {
    if (e.has(o)) return;
    const s = setInterval(() => {
      t.get(o).forEach((c) => c());
    }, o);
    e.set(o, s);
  }, r = (o, s) => {
    const a = t.get(s);
    if (a) {
      const c = a.filter((p) => p !== o);
      if (c.length > 0) {
        t.set(s, c);
        return;
      }
      const u = e.get(s);
      clearInterval(u), t.delete(s), e.delete(s);
    }
  };
  return (o, s) => {
    const a = t.get(s) ?? [];
    return t.set(s, [...a, o]), n(s), () => r(o, s);
  };
}, vh = gh(), Pe = (t, e) => {
  if (!e) return t;
  const { order: n, text: r } = e;
  let i = [...t];
  return r && r !== "" && (i = i.filter(
    (o) => o.textContent.replace(/\r\n|\r|\n/g, " ").toLowerCase().trim() === r.toString().toLowerCase().trim()
  )), n != null ? i.length > n ? [i[n]] : [] : i;
}, yh = "@appcues/overlay", mh = {
  top: "top",
  "top-left": "top-start",
  "top-right": "top-end",
  right: "right",
  "right-top": "right-start",
  "right-bottom": "right-end",
  bottom: "bottom",
  "bottom-right": "bottom-end",
  "bottom-left": "bottom-start",
  left: "left",
  "left-bottom": "left-end",
  "left-top": "left-start",
  center: "top-start"
}, Eh = (t) => {
  let e, n, r, i = [], o, s = () => {
  }, a;
  function c() {
    t();
  }
  const u = Ca(c, 100);
  function p() {
    const f = e.getBoundingClientRect();
    a && (f.x !== a.x || f.y !== a.y || f.width !== a.width || f.height !== a.height) && u(), a = f;
  }
  return {
    setElements(f, l, d) {
      return e = f, n = l, r = d, i = [], this;
    },
    start() {
      r && (i = ch([...Er(r)])), i.forEach((f) => {
        br(f, "scroll", u), br(f, "resize", u);
      }), o = new ResizeObserver(u), o.observe(n), a = e.getBoundingClientRect(), s = vh(p, 200);
    },
    remove() {
      i.forEach((f) => {
        xr(f, "scroll", u), xr(f, "resize", u);
      }), o?.unobserve(n), s();
    }
  };
}, Sh = ({ addHook: t, registerAction: e }) => {
  let n, r = !1, i = !1, o, s, a, c, u, p, f = !1, l = "absolute", d, h;
  t(
    "step.begin",
    ({
      onElementRemoved: v,
      querySelector: m,
      reportError: S,
      step: y,
      updateStyle: x,
      getWindowReference: T,
      getTraitConfig: b
    }) => {
      const { traits: A } = y.getConfig(), {
        arrowId: R = "arrow",
        target: O,
        rootId: P,
        placement: D = "auto",
        distance: L,
        skidding: $,
        placementUnit: q = "pixels",
        shouldAutoCalculateZIndex: Y = !0
      } = b(), G = Xo(O.selector, A), J = A.find((Q) => Q.type === "@appcues/toggle")?.config?.startHidden ?? !0;
      J || x(P, { position: "absolute" }), a = () => {
        const Q = y.querySelector(`#${P}`), et = y.querySelector(`#${R}`), rt = Pe(
          m(O.selector),
          O.filters
        );
        return {
          matchingElements: rt,
          targetEl: rt[0],
          rootEl: Q[0],
          arrowEl: et[0]
        };
      };
      const V = async () => {
        const { targetEl: Q, rootEl: et, arrowEl: rt } = a();
        if (!r && Q && et) {
          r = !0;
          const gt = fh({
            placement: D,
            targetEl: Q,
            distance: L,
            skidding: $,
            placementUnit: q
          }), xt = [
            Jp(({ placement: kt }) => ({
              ...gt,
              crossAxis: rt && /start|end/gm.test(kt) ? uh($, kt) : gt.crossAxis
            }))
          ];
          D === "auto" && xt.push(
            th(),
            Qp({
              crossAxis: !0
            })
          ), rt && xt.push(nh({ element: rt, padding: Oa })), xt.push(eh());
          const {
            middlewareData: U,
            strategy: W,
            x: tt,
            y: pt,
            placement: _t
          } = await rh(Q, et, {
            middleware: xt,
            placement: mh[D] ?? "auto",
            strategy: l
          }), { referenceHidden: Dt } = U.hide;
          if (rt) {
            const { x: kt, y: Jt } = U.arrow;
            x(R, {
              ...lh(_t, kt, Jt),
              transition: "top 200ms, left 200ms, right 200ms, bottom 200ms"
            });
          }
          const Zt = {
            left: `${tt}px`,
            position: W,
            top: `${pt}px`
          }, Nt = ph({
            targetEl: Q,
            rootStyle: Zt,
            shouldAutoCalculateZIndex: Y,
            getWindowReference: T
          });
          Q.style.visibility === "hidden" && (Nt.visibility = "hidden", p = Q.style.visibility), Dt && et.style.visibility !== "hidden" && (u = et.style.visibility, f = !0, Nt.visibility = "hidden"), !Dt && f && (Nt.visibility = u ?? "visible", f = !1), !Dt && Q.style.visibility !== "hidden" && Q.style.visibility !== "" && p === "hidden" && (Nt.visibility = "visible"), D === "center" && (Nt.transform = "translate(-50%, 50%)"), Nt.transition = "top 200ms, left 200ms, right 200ms, bottom 200ms", x(P, Nt);
        }
      };
      d = () => {
        r = !1, V();
      }, c = Eh(d);
      const ot = () => Pe(m(O.selector), O.filters);
      n = async () => {
        o && o(), s && s();
        const { matchingElements: Q, rootEl: et } = a(), rt = Q.length === 1, gt = Q.length > 1, xt = Q.length === 0, U = () => {
          G || (s = v({
            getTarget: ot,
            onRemoved: () => {
              r = !1, h = S(`Target got removed => ${O.selector}`), c.remove();
            }
          }));
        };
        if (rt && !et) {
          h = S(
            `Could not find root element #${P} for overlay positioning.`
          );
          return;
        }
        if (rt) {
          const W = G ? m(G.config.target.selector) : null;
          if (J) {
            const tt = W != null ? Sr(
              W[0]?.parentElement,
              T
            ) : !1;
            l = Sr(
              Q[0]?.parentElement,
              T
            ) || tt ? "fixed" : "absolute", x(P, { position: l });
          }
          await V(), U(), c.setElements(
            Q[0],
            et,
            W ? W[0] : null
          ).start();
          return;
        }
        gt && S(
          `Found ${Q.length} elements for selector ${O.selector}.`
        ), xt && (h = S(
          `Could not find element for selector ${O.selector}.`
        ));
      };
    }
  ), t("step.postrender", async () => {
    i || (await n(), i = !0);
  }), t("step.end", () => {
    o && o(), s && s(), c.remove(), r = !1, i = !1;
  }), t(
    "step.error",
    ({ step: v, getTraitConfig: m, onElementInserted: S, querySelector: y }) => {
      r = !1, i = !1;
      const { target: x } = m(), { traits: T } = v.getConfig(), b = () => Pe(y(x.selector), x.filters);
      Xo(x.selector, T) || (o = S({
        getTarget: b,
        onInserted: () => {
          i = !1, v.recover({ errorId: h });
        }
      }));
    }
  );
};
St(yh, Sh);
const bh = "@appcues/persistent", xh = ({ addHook: t }) => {
  t("experience.begin", ({ steps: e }) => {
    e.map((n) => n.start());
  });
};
St(bh, xh);
const wh = {
  left: "beforebegin",
  "inner-left": "afterbegin",
  right: "afterend",
  "inner-right": "beforeend"
}, _h = "@appcues/inline", or = "appcues-hide", Th = `.${or} { display: none !important; }`, Rh = ({
  distanceUnit: t,
  yOffset: e,
  xOffset: n,
  targetEl: r
}) => {
  if (t !== "%" || !r)
    return {
      x: `${n}px`,
      y: `${e}px`
    };
  const { width: i, height: o } = r.getBoundingClientRect();
  return {
    x: `${i * n / 100}px`,
    y: `${o * e / 100}px`
  };
};
function Ch({ addHook: t }) {
  let e, n, r, i = [], o = [], s = null, a = null;
  const c = (p) => {
    if (s) return;
    const { document: f } = p();
    s = f.createElement("style"), s.textContent = Th, f.head.append(s);
  }, u = () => {
    i.forEach((p) => p.classList.remove(or)), i = [], o.forEach((p) => {
      const f = p.firstChild;
      f && p.replaceWith(f);
    }), o = [], s && (s.remove(), s = null);
  };
  t(
    "step.begin",
    ({
      step: p,
      getTraitConfig: f,
      reportError: l,
      onElementRemoved: d,
      updateRootStyle: h,
      querySelector: v,
      getWindowReference: m
    }) => {
      const {
        target: S,
        placement: y = "right",
        verticalAlignment: x = "bottom",
        allowOverlap: T = !1,
        xOffset: b = 0,
        yOffset: A = 0,
        distanceUnit: R = "px",
        sticky: O = !1,
        rootDisplay: P = "inline-block",
        clearContainer: D = !1
      } = f();
      e && e(), n && n();
      const L = Pe(
        v(S.selector),
        S.filters
      ), $ = L.length === 1, q = L.length > 1, Y = L.length === 0, G = (V) => {
        const ot = m().document.createElement("div");
        if (a && (a.remove(), a = null), u(), D && y.includes("inner"))
          if (D === "hide") {
            c(m);
            const { document: et } = m();
            Array.from(V.childNodes).forEach((rt) => {
              if (rt.nodeType === Node.ELEMENT_NODE)
                rt.classList.add(or), i.push(rt);
              else if (rt.nodeType === Node.TEXT_NODE && rt.textContent.trim()) {
                const gt = et.createElement("span");
                gt.classList.add(or), rt.replaceWith(gt), gt.append(rt), o.push(gt);
              }
            });
          } else
            for (; V.firstChild; )
              V.firstChild.remove();
        if (V.insertAdjacentElement(
          wh[y],
          ot
        ) == null) {
          l(`can't insert inline container on the ${y}`);
          return;
        }
        a = ot, p.setStepContainerTarget(ot);
      }, nt = () => Pe(v(S.selector), S.filters), J = () => {
        n = d({
          getTarget: nt,
          onRemoved: () => {
            r = l(`Target got removed => ${S.selector}`);
          }
        });
      };
      if ($) {
        G(L[0]);
        const V = {
          display: P,
          verticalAlign: x
        }, { x: ot, y: Q } = Rh({
          distanceUnit: R,
          xOffset: b,
          yOffset: A,
          targetEl: L[0]
        });
        if (T)
          V.position = "absolute", V.transform = `translate(${ot}, ${Q})`;
        else {
          const et = y.includes("left") ? "right" : "left";
          V[`margin-${et}`] = ot, V[`margin-${x}`] = Q;
        }
        if (O) {
          V.position = "sticky";
          const et = y.includes("left") ? "top" : "bottom";
          V[et] = 0, V.zIndex = Cu;
        }
        h(V), J();
        return;
      }
      q && l(
        `Found ${L.length} elements for selector ${S.selector}.`
      ), Y && (r = l(
        `Could not find element for selector ${S.selector}.`
      ));
    }
  ), t(
    "step.error",
    ({ step: p, getTraitConfig: f, onElementInserted: l, querySelector: d }) => {
      const { target: h } = f();
      e = l({
        getTarget: () => Pe(d(h.selector), h.filters),
        onInserted: () => {
          p.recover({ errorId: r });
        }
      });
    }
  ), t("step.end", () => {
    e && e(), n && n(), a && (a.remove(), a = null), u();
  });
}
St(_h, Ch);
const Oh = (t, e, n) => {
  const { height: r, width: i, left: o, top: s } = t.getBoundingClientRect();
  return Math.floor(
    Math.hypot(e - (o + i / 2), n - (s + r / 2)) / 2
  );
}, Ah = (t, e) => {
  const { height: n, width: r } = t.getBoundingClientRect(), i = Math.floor(Math.hypot(n, r) / 4);
  return Math.max(e, 0) + i;
}, Nh = (t) => t.key === "Escape", Ph = (t, e) => ![...t.composedPath()].filter((i) => i.nodeType === Node.ELEMENT_NODE).some((i) => i?.contains?.(e) ?? !1), Xn = (t, e) => ({
  remove: () => {
    t.removeEventListener("keydown", e), t.removeEventListener("click", e, !0);
  },
  start: () => {
    t.addEventListener("click", e, !0), t.addEventListener("keydown", e);
  }
}), Kr = (t, e, n) => e.length === 0 ? (n("Element not found"), !1) : e.length > 1 ? (n(`More than one element found with id: ${t}`), !1) : !0, Ih = "@appcues/toggle.style", Pa = ({ targetId: t, styles: e = {} }, { updateStyle: n }) => {
  n(t, e);
}, Jo = {
  [Ih]: Pa
}, Dh = ({ addHook: t, registerAction: e }, {
  startHidden: n = !0,
  targetId: r,
  transition: i,
  closeOnClickOutside: o = !0,
  closeRadius: s
}) => {
  let a, c, u, p = !1, f = [], l = null, d = [];
  const h = () => {
    f.forEach((S) => S.remove()), f = [];
  };
  n && t("step.begin", ({ updateStyle: S, getWindowReference: y }) => {
    S(r, {
      opacity: "0",
      visibility: "hidden",
      "pointer-events": "none"
    }), d = [...y().document.querySelectorAll("iframe")];
  }), t("step.end", () => {
    o && h(), l?.remove(), l = null;
  }), t("step.error", () => {
    o && h(), l?.remove(), l = null;
  });
  const v = ({ on: S } = {}, y) => {
    const { reportError: x, step: T, updateStyle: b, getWindowReference: A } = y, R = A().document, O = T.querySelector(`#${r}`);
    if (!Kr(r, O, x)) return;
    o && h();
    const P = {};
    i || (P.visibility = "hidden", P["pointer-events"] = "none"), b(r, {
      ...P,
      opacity: "0"
    }), i && setTimeout(() => {
      b(r, {
        visibility: "hidden",
        "pointer-events": "none"
      });
    }, i.duration * 1e3), s && p && (xr(R, "mousemove", a), d.forEach((D) => {
      D.contentDocument?.body && xr(
        D.contentDocument.body,
        "mousemove",
        a
      );
    }), p = !1), S?.close?.forEach(
      (D) => Jo[D.type](D.config, y)
    );
  }, m = ({ on: S } = {}, y) => {
    const { reportError: x, step: T, updateStyle: b, getWindowReference: A } = y, R = A().document, O = T.querySelector(`#${r}`);
    if (!Kr(r, O, x)) return;
    const P = {};
    if (i && (P.transition = `opacity ${i.duration}s ${i.easing}`), b(r, {
      ...P,
      visibility: "visible",
      opacity: "1",
      "pointer-events": "auto"
    }), S?.open?.forEach(
      (D) => Jo[D.type](D.config, y)
    ), o && f.length === 0) {
      const D = T.querySelector(":first-child")[0];
      u = ($) => {
        (Nh($) || Ph($, O[0])) && v({ on: S }, y);
      };
      const L = d.map(($) => $.contentDocument?.body ? Xn(
        $.contentDocument.body,
        u
      ) : null).filter(Boolean);
      f.push(
        Xn(R, u),
        Xn(D, u),
        ...L
      ), f.forEach(($) => $.start());
    }
    if (l || (c = (D) => {
      if (D.type === "keydown" && !["Enter", " "].includes(D.key))
        return;
      const L = [...D.composedPath()];
      ["a", "button"].includes(L[0].tagName.toLowerCase()) && v({ on: S }, y);
    }, l = Xn(O[0], c), l.start()), s && !p) {
      const D = Ah(O[0], s);
      a = Ca((L) => {
        Oh(
          O[0],
          L.clientX,
          L.clientY
        ) > D && v({ on: S }, { reportError: x, step: T, updateStyle: b, getWindowReference: A });
      }, 60), br(R, "mousemove", a), d.forEach((L) => {
        L.contentDocument?.body && br(
          L.contentDocument.body,
          "mousemove",
          a
        );
      }), p = !0;
    }
  };
  e("run", ({ on: S } = {}, y) => {
    const { step: x, reportError: T, getWindowReference: b } = y, A = x.querySelector(`#${r}`);
    if (!Kr(r, A, T)) return;
    if (b().getComputedStyle(A[0]).visibility === "hidden") {
      m({ on: S }, y);
      return;
    }
    v({ on: S }, y);
  }), e("open", m), e("close", v), e("style", Pa);
}, kh = "@appcues/toggle";
St(kh, Dh);
const Lh = "@appcues/coreEvents", $h = ({ registerAction: t }) => {
  t("step_seen", (e, { step: n }) => {
    n.seen();
  }), t("extended_event", ({ name: e, ...n }, { step: r }) => {
    r.extendedEvent(e, n);
  }), t("step_interaction", (e, { step: n }) => {
    n.interaction(e.interactionType, e.interactionData);
  }), t("experience_dismissed", (e, { step: n }) => {
    n.dismissExperience();
  }), t("experience_snoozed", (e, { step: n }) => {
    n.snoozeExperience();
  });
};
St(Lh, $h);
const Mh = (t, e = {}, n = () => window) => {
  let r = e;
  const i = [], o = n().document, s = (p) => {
    const { el: f, callbackFn: l } = p.detail;
    i.push([f, l]), f[l].apply(p.target, [r]);
  };
  return o.addEventListener(`${t}:connect`, s), {
    getState: () => r,
    setState: (p) => {
      r = { ...r, ...p }, i.forEach(([f, l]) => {
        f[l].apply(f, [r]);
      });
    },
    destroy: () => {
      o.removeEventListener(`${t}:connect`, s);
    }
  };
}, Hh = "@appcues/store", jh = ({ addHook: t, registerAction: e }, { id: n, initialState: r = {} }) => {
  let i;
  t("step.begin", ({ getWindowReference: o }) => {
    i = Mh(n, r, o);
  }), t("step.end", () => {
    i && i.destroy();
  }), e("setState", ({ stateKey: o }, s, a) => {
    i && i.setState({ [o]: a?.detail });
  });
};
St(Hh, jh);
const Ia = {
  slide_in_down: [
    {
      transform: "translate3d(0, -100%, 0)",
      visibility: "visible"
    },
    {
      transform: "translate3d(0, 0, 0)"
    }
  ],
  slide_out_down: [
    {
      transform: "translate3d(0, 0, 0)",
      offset: 0
    },
    {
      transform: "translate3d(0, 100%, 0)",
      offset: 0.99
    },
    {
      visibility: "hidden",
      offset: 1
    }
  ],
  slide_in_up: [
    {
      transform: "translate3d(0, 100%, 0)",
      visibility: "visible"
    },
    {
      transform: "translate3d(0, 0, 0)"
    }
  ],
  pulse: [
    {
      transform: "scale3d(1, 1, 1)"
    },
    {
      transform: "scale3d(1.05, 1.05, 1.05)"
    },
    {
      transform: "scale3d(1, 1, 1)"
    }
  ]
}, Uh = "@appcues/animate", Fh = 500, Bh = "none", zh = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])', qh = (t) => {
  let e = t?.activeElement;
  for (; e?.shadowRoot?.activeElement; )
    e = e.shadowRoot.activeElement;
  return e;
}, Xr = /* @__PURE__ */ new WeakMap(), Wh = (t) => {
  const e = Ia[t?.effect] || t?.keyframes, n = Array.isArray(e) ? e[e.length - 1] : null;
  return n ? Number(n.opacity) === 0 || n.visibility === "hidden" || n.display === "none" : !1;
}, Yn = (t, e) => new Promise((n) => {
  const {
    keyframes: r,
    duration: i = Fh,
    iterations: o,
    effect: s,
    fill: a = Bh,
    easing: c = "linear",
    composite: u
  } = e, p = Ia[s] || r, f = {
    duration: i,
    iterations: o,
    fill: a,
    easing: c,
    ...u ? { composite: u } : {}
  };
  if (!p) {
    n();
    return;
  }
  const l = t.animate(p, f);
  l?.addEventListener ? l.addEventListener("finish", n, { once: !0 }) : n();
}), Vh = ({ addHook: t, registerAction: e }, n) => {
  n.phase === "exit" ? t("step.end", ({ querySelector: r }) => {
    const { target: i } = n;
    if (!i) return;
    const o = r(i.selector);
    if (o.length !== 0)
      return Yn(o[0], n);
  }) : t("step.postrender", ({ querySelector: r }) => {
    const { target: i } = n;
    if (!i) return;
    const o = r(i.selector);
    o.length !== 0 && Yn(o[0], n);
  }), e(
    "toggle",
    ({ toggleGroupId: r, target: i, animations: o, autoFocus: s = !0 }, { querySelector: a, getWindowReference: c }) => {
      const u = a(i.selector);
      if (u.length === 0) return;
      const [p] = u, l = p.getAttribute(r) === o[0].id ? o[1] : o[0];
      if (!l) return;
      const d = Wh(l);
      d || (p.inert = !1);
      const h = s ? qh(c?.()?.document) : null, v = Yn(p, l);
      l.id && p.setAttribute(r, l.id);
      const m = () => l.id != null && p.getAttribute(r) !== l.id;
      if (!s) {
        d && v.then(() => {
          m() || (p.inert = !0);
        });
        return;
      }
      v.then(() => {
        if (!m())
          if (d) {
            const S = Xr.get(p);
            S?.isConnected && S.focus({ preventScroll: !0 }), Xr.delete(p), p.inert = !0;
          } else
            h && Xr.set(p, h), (p.querySelector(zh) ?? p).focus({ preventScroll: !0 });
      });
    }
  ), e("run", async (r, i) => {
    const { querySelector: o, getAction: s } = i, {
      toggleGroupId: a,
      target: c,
      animation: u,
      ignoreToggleGroup: p = !1,
      onFinish: f = []
    } = r;
    if (!c) return;
    const l = o(c.selector);
    if (l.length === 0) return;
    const d = l[0], h = d.getAttribute(a);
    (!h || h === u.id) && !p || (await Yn(d, u ?? r), f.forEach((v) => {
      s(v.type)(v?.config ?? {}, i);
    }), p || d.setAttribute(a, u.id));
  });
};
St(Uh, Vh);
const Da = {
  pixels: "px",
  percentage: "%"
};
function Gh(t, e, n, r) {
  const i = Da[n] || "px";
  switch (t) {
    case "left":
      return {
        left: 0,
        transform: `translateX(${e}${i})`,
        ...r && {
          right: "unset"
        }
      };
    case "center":
      return {
        left: "50%",
        transform: `translateX(calc(-50% + ${e}${i}))`,
        ...r && {
          right: "unset"
        }
      };
    default:
      return {
        right: 0,
        transform: `translateX(-${e}${i})`,
        ...r && {
          left: "unset"
        }
      };
  }
}
function Kh(t, e, n, r) {
  const i = Da[n] || "px";
  switch (t) {
    case "top":
      return {
        top: 0,
        transform: `translateY(${e}${i})`,
        ...r && {
          bottom: "unset"
        }
      };
    case "center":
      return {
        top: "50%",
        transform: `translateY(calc(-50% + ${e}${i}))`,
        ...r && {
          bottom: "unset"
        }
      };
    default:
      return {
        bottom: 0,
        transform: `translateY(-${e}${i})`,
        ...r && {
          top: "unset"
        }
      };
  }
}
const Xh = "@appcues/floating", Yh = ({ addHook: t }) => {
  t("step.begin", ({ getTraitConfig: e, updateStyle: n, updateRootStyle: r }) => {
    const {
      target: i,
      strategy: o = "fixed",
      xOffset: s = 0,
      yOffset: a = 0,
      xPosition: c = "left",
      yPosition: u = "top",
      placementUnit: p = "pixels",
      unsetOppositeDirection: f = !1,
      applyToRoot: l = !1
    } = e(), d = [
      Gh(
        c,
        s,
        p,
        f
      ),
      Kh(
        u,
        a,
        p,
        f
      )
    ].reduce((v, m) => {
      const { transform: S, ...y } = m;
      return S && (v.transform = v.transform ? `${v.transform} ${S}` : S), { ...v, ...y };
    }, {}), h = {
      position: o,
      ...d
    };
    if (l) {
      r(h, { forceUpdate: !0 });
      return;
    }
    n(i.selector, h);
  });
};
St(Xh, Yh);
const Zh = "@appcues/dismissible";
function Qo(t) {
  return `_experience_dismissed_${t}`;
}
const Jh = ({ addHook: t, registerAction: e }, { strategy: n = "permanent" }) => {
  function r(i, o) {
    return n === "session" ? o().sessionStorage.getItem(Qo(i)) === "1" : !1;
  }
  t(
    "experience.begin",
    ({ stopExperience: i, getExperienceId: o, getWindowReference: s }) => {
      r(o(), s) && i();
    }
  ), e(
    "dismiss",
    (i, { stopExperience: o, updateUserProfile: s, getExperienceId: a, getWindowReference: c }) => {
      const u = Qo(a());
      n === "session" ? c().sessionStorage.setItem(u, "1") : n === "permanent" && s({ [u]: "permanently_dismissed" }), o();
    }
  );
};
St(Zh, Jh);
const Qh = "@appcues/experienceStyle", tg = ({ addHook: t }) => {
  t("step.begin", ({ updateRootStyle: e, getTraitConfig: n }) => {
    const r = n();
    e(r, { forceUpdate: !0 });
  }), t("step.container_change", ({ updateRootStyle: e, getTraitConfig: n }) => {
    const r = n();
    e(r, { forceUpdate: !0 });
  }), t("step.end", ({ updateRootStyle: e, getTraitConfig: n }) => {
    const r = Object.keys(n()).reduce((i, o) => (i[o] = null, i), {});
    e(r, { forceUpdate: !0 });
  });
};
St(Qh, tg);
const eg = "@appcues/rootStyle", ts = ({ getTraitConfig: t, updateRootStyle: e }) => {
  const { forceUpdate: n = !1, ...r } = t();
  e(r, { forceUpdate: n });
};
function ng({ addHook: t }) {
  t("step.begin", ts), t("step.container_change", ts);
}
St(eg, ng);
var rg = "appcues:launchpad_close", ig = "appcues:launchpad_search", og = "appcues:launchpad_search_error", sg = "appcues:launchpad_search_response", Li = function(t, e) {
  return window.addEventListener(t, e), function() {
    return window.removeEventListener(t, e);
  };
}, ag = function(t) {
  return Li(rg, t);
}, cg = function(t, e, n) {
  var r = new CustomEvent(ig, {
    detail: {
      integrationId: t,
      query: e,
      experienceId: n
    }
  });
  window.dispatchEvent(r);
}, lg = function(t, e) {
  return Li("".concat(sg, ":").concat(t), e);
}, ug = function(t, e) {
  return Li("".concat(og, ":").concat(t), e);
};
const fg = "@appcues/sdk-middleware-events", dg = ({ addHook: t }, { onLaunchpadClose: e }) => {
  let n;
  t("step.begin", (r) => {
    n = ag(() => {
      e.forEach((i) => {
        r.getAction(i.type)?.(i.config, r);
      });
    });
  }), t("step.end", () => {
    n?.();
  });
};
St(fg, dg);
const pg = "@appcues/knowledge-base-integration", Zn = (t, { querySelector: e, reportError: n }) => {
  const r = e(t), i = r.length > 1, o = r.length === 0;
  return i && n(
    "The target element is duplicated, please provide a more specific selector"
  ), o && n("The target element is not found"), r[0];
}, hg = ({ addHook: t, registerAction: e }, n) => {
  const { integrationConnected: r = !1 } = n;
  let i, o, s, a, c;
  const u = () => {
    r && o?.prev();
  }, p = (f) => {
    if (!r) return;
    const { integrationId: l } = n, { inputValue: d } = f.detail;
    s.setAttribute("searchTerm", d), s.setAttribute("state", "loading"), i.setAttribute("loading", !0), a && (a.scrollTop = 0), o?.next(), cg(l, d, c);
  };
  t("step.begin", ({ getExperienceId: f }) => {
    c = f(), lg(c, (l) => {
      const d = l.detail, h = d.results?.length === 0 ? "empty" : "showing_results";
      s.setAttribute("state", h), s.setAttribute("results", JSON.stringify(d.results)), i.setAttribute("loading", !1);
    }), ug(c, () => {
      s.setAttribute("state", "error"), i.setAttribute("loading", !1);
    });
  }), t("step.end", () => {
    i?.removeEventListener("onSearch", p), i?.removeEventListener("onCancel", u);
  }), e("bindListeners", (f, l) => {
    const { navigation: d } = n;
    (!o || !i) && (o = Zn(d.selector, l), i = Zn("appcues-search-header", l), s = Zn("appcues-search-results", l), a = Zn("#launchpad-container", l), i?.addEventListener("onSearch", p), i?.addEventListener("onCancel", u));
  });
};
St(pg, hg);
const gg = "@appcues/sequential", es = (t, e) => t.findIndex((n) => n.getConfig()?.id === e), vg = ({ addHook: t, registerAction: e }) => {
  let n;
  const r = (s, { steps: a }) => {
    n !== 0 && a[n].stop(() => {
      n -= 1, a[n].start();
    });
  }, i = (s, { steps: a }) => {
    if (n === a.length - 1) {
      a[n].stop();
      return;
    }
    a[n].stop(() => {
      n += 1, a[n].start();
    });
  }, o = (s, { step: a, steps: c }) => {
    const u = es(c, s.stepId);
    u !== -1 && a.stop(() => {
      n = u, c[n].start();
    });
  };
  t("experience.begin", ({ steps: s, getTraitConfig: a, reportError: c }) => {
    const { startStepId: u } = a() ?? {};
    if (u) {
      const p = es(s, u);
      p === -1 && c(
        `startStepId "${u}" did not match any step; starting at 0`
      ), n = p !== -1 ? p : 0;
    } else
      n = 0;
    s[n].start();
  }), e("next", i), e("prev", r), e("goTo", o);
};
St(gg, vg);
const yg = "@appcues/delay", mg = 3e5, Eg = ({ addHook: t }, e) => {
  let n = null;
  t("step.begin", () => {
    const r = e?.duration;
    if (!r) return;
    const i = Math.min(r, mg);
    return new Promise((o) => {
      n = setTimeout(o, i);
    });
  }), t("step.end", () => {
    n !== null && (clearTimeout(n), n = null);
  });
};
St(yg, Eg);
const $i = "appcues-cutout-backdrop", ns = "appcues-custom-backdrop", Sg = "hard", hi = "apc-spotlight", bg = `
  dialog { all: unset; }
  :-internal-dialog-in-top-layer { all: unset; }
`, xg = `
  ::backdrop { backdrop-filter: var(--backdrop-blur); background-color: var(--backdrop-color); }
`, wg = ({ backdropBlur: t, backdropColor: e }) => ({
  ...t && { "--backdrop-blur": t },
  ...e && { "--backdrop-color": e }
}), _g = ({
  getWindowReference: t,
  backdropZIndex: e,
  backdropBlur: n,
  backdropColor: r
}) => {
  if (t().document.querySelector(
    `#${ns}`
  ))
    return null;
  const o = t().document.createElement("div");
  return o.id = ns, o.style.cssText = `
    z-index: ${e};
    position: fixed;
    inset: 0;
    backdrop-filter: ${n};
    background-color: ${r};
    pointer-events: none;
  `, o;
}, yn = 1500, rs = 0.67, Tg = (t) => {
  Object.assign(t.style, {
    position: "fixed",
    top: "0",
    left: "0",
    width: "100vw",
    height: "100vh",
    overflow: "hidden",
    pointerEvents: "none"
  });
}, ka = (t, e) => {
  const { top: n, left: r, width: i, height: o } = e;
  Object.assign(t.style, {
    position: "absolute",
    top: `${n - yn}px`,
    left: `${r - yn}px`,
    height: `${o ? o + 2 * yn : 0}px`,
    width: `${i ? i + 2 * yn : 0}px`,
    boxSizing: "border-box",
    border: `${yn}px solid transparent`,
    pointerEvents: "none",
    borderImage: `radial-gradient(transparent 2%, rgba(0,0,0,${rs}) 28%) 49% 49% 49% 49%`,
    boxShadow: `0 0 0 2500px rgba(0,0,0,${rs})`
  });
}, Rg = ({ document: t, rect: e, zIndex: n }) => {
  const r = t.createElement("div");
  r.id = $i, Tg(r), r.style.zIndex = n;
  const i = t.createElement("div");
  return i.className = hi, ka(i, e), r.append(i), r;
}, Cg = ({ container: t, rect: e }) => {
  const n = t.firstElementChild;
  n && ka(n, e);
}, Og = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: Rg,
  update: Cg
}, Symbol.toStringTag, { value: "Module" })), La = 0.5, Ag = (t) => {
  Object.assign(t.style, {
    position: "fixed",
    top: "0",
    left: "0",
    width: "100vw",
    height: "100vh",
    pointerEvents: "none"
  });
}, $a = (t, e, n) => {
  const { top: r, left: i, width: o, height: s } = n;
  Object.assign(t.style, {
    position: "absolute",
    top: `${r}px`,
    left: `${i}px`,
    width: `${o}px`,
    height: `${s}px`,
    overflow: "hidden",
    pointerEvents: "none"
  }), Object.assign(e.style, {
    position: "relative",
    width: `${o}px`,
    height: `${s}px`,
    boxShadow: `0px 0px 0px 2000px rgba(0,0,0,${La})`,
    borderRadius: "0px",
    pointerEvents: "none"
  });
}, Jn = (t, e, n, r, i) => {
  Object.assign(t.style, {
    position: "absolute",
    top: `${e}px`,
    left: `${n}px`,
    width: `${r}px`,
    height: `${i}px`,
    background: `rgba(0,0,0,${La})`,
    pointerEvents: "all"
  });
}, Ma = ([t, e, n, r], i, o) => {
  const { top: s, left: a, right: c, bottom: u, width: p } = i, f = o.innerWidth, l = o.innerHeight;
  Jn(t, 0, a, p, Math.max(0, s)), Jn(e, 0, c, Math.max(0, f - c), l), Jn(n, u, a, p, Math.max(0, l - u)), Jn(r, 0, 0, Math.max(0, a), l);
}, Ng = ({ document: t, win: e, rect: n, zIndex: r }) => {
  const i = t.createElement("div");
  i.id = $i, Ag(i), i.style.zIndex = r;
  const o = t.createElement("div"), s = t.createElement("div");
  s.className = hi, $a(o, s, n), o.append(s), i.append(o);
  const a = ["top", "right", "bottom", "left"].map((c) => {
    const u = t.createElement("div");
    return u.className = hi, u.setAttribute("aria-label", `${c}-panel`), i.append(u), u;
  });
  return Ma(a, n, e), i;
}, Pg = ({ container: t, win: e, rect: n }) => {
  const r = t.children[0], i = r?.firstElementChild;
  r && i && $a(r, i, n);
  const o = [...t.children].slice(1);
  o.length === 4 && Ma(o, n, e);
}, Ig = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  build: Ng,
  update: Pg
}, Symbol.toStringTag, { value: "Module" })), Mi = {
  soft: Og,
  hard: Ig
}, Dg = (t) => t in Mi, kg = ({
  getWindowReference: t,
  target: e,
  backdropType: n,
  zIndex: r
}) => {
  const i = t();
  let o;
  try {
    o = i.document.querySelector(e);
  } catch {
    o = null;
  }
  if (!o) return null;
  const s = o.getBoundingClientRect(), a = { document: i.document, win: i, rect: s, zIndex: r };
  return Mi[n].build(a);
}, Lg = ({
  container: t,
  getWindowReference: e,
  target: n,
  backdropType: r
}) => {
  const i = e();
  let o;
  try {
    o = i.document.querySelector(n);
  } catch {
    o = null;
  }
  if (!o || !t) return;
  const s = o.getBoundingClientRect();
  Mi[r].update({ container: t, win: i, rect: s });
}, $g = /* @__PURE__ */ new Set([
  Pn,
  In
]), Mg = (t) => t.id === $i || $g.has(t.tagName), Hg = (t, e) => {
  if (!e) return null;
  try {
    return t.querySelector(e);
  } catch {
    return null;
  }
}, jg = (t, { targetSelector: e } = {}) => {
  const { body: n } = t.document, r = /* @__PURE__ */ new Set(), i = Hg(n, e);
  for (const o of n.children)
    !Mg(o) && !o.inert && !o.contains(i) && (o.inert = !0, r.add(o));
  return () => {
    for (const o of r)
      o.inert = !1;
  };
}, Ug = "@appcues/dialog", Fg = ({ addHook: t }, e) => {
  const {
    backdrop: n,
    variables: r,
    customBackdrop: i,
    target: o,
    autoFocus: s = !0
  } = e, { dialogZIndex: a, backdropZIndex: c, backdropBlur: u, backdropColor: p } = r || {}, f = {
    backdrop: null,
    dialog: null
  };
  let l, d, h, v, m, S;
  const y = (T, b, A) => {
    f[T]?.remove();
    const R = A.document.createElement("style");
    R.textContent = b, l.prepend(R), f[T] = R;
  }, x = () => {
    v && m && (v.removeEventListener("scroll", m, !0), v.removeEventListener("resize", m));
  };
  if (n === !0 && !i && !o) {
    const T = ({ getTraitConfig: b, updateRootStyle: A }) => {
      const { variables: R } = b();
      A(wg(R || {}), {
        forceUpdate: !0
      });
    };
    t("step.begin", T), t("step.container_change", T);
  }
  t("step.postrender", ({ step: T, getWindowReference: b, getTraitConfig: A }) => {
    const R = A(), O = R.backdrop ?? n, P = R.customBackdrop ?? i, D = R.target ?? o, L = R.autoFocus ?? s, $ = R.variables ?? r ?? {}, q = $.dialogZIndex ?? a, Y = $.backdropZIndex ?? c, G = $.backdropBlur ?? u, nt = $.backdropColor ?? p;
    [l] = T.querySelector("dialog") ?? [];
    const J = b();
    if (l) {
      O === !0 && P ? (d?.remove(), d = _g({
        getWindowReference: b,
        backdropZIndex: Y,
        backdropBlur: G,
        backdropColor: nt
      }), d && J.document.body.append(d)) : (d?.remove(), d = void 0), O === !0 && !P && !D ? y("backdrop", xg, J) : (f.backdrop?.remove(), f.backdrop = null), y("dialog", bg, J), l.style.zIndex = q, l.removeAttribute("autofocus");
      const V = O === !0 && !P && !D ? "showModal" : "show";
      if (V === "show" && !D) return;
      const ot = V === "show" ? { x: J.scrollX, y: J.scrollY } : null, Q = l.open;
      l[V](), ot && (J.scrollX !== ot.x || J.scrollY !== ot.y) && J.scrollTo(ot.x, ot.y), V === "show" && L && !Q && l.focus({ preventScroll: !0 });
    }
    x(), S?.(), h?.remove(), h = void 0, D && Dg(O) && (v = b(), h = kg({
      getWindowReference: b,
      target: D,
      backdropType: O,
      zIndex: (q ?? 2) - 1
    }), h && (v.document.body.append(h), m = () => Lg({
      container: h,
      getWindowReference: b,
      target: D,
      backdropType: O
    }), v.addEventListener("scroll", m, !0), v.addEventListener("resize", m), O === Sg && (S = jg(v, {
      targetSelector: D
    }))));
  }), t("step.end", () => {
    l?.close(), f.backdrop?.remove(), f.dialog?.remove(), d?.remove(), h?.remove(), x(), S?.();
  });
};
St(Ug, Fg);
const Bg = "@appcues/experienceTheme", zg = ({ addHook: t }) => {
  let e = null;
  function n({
    getContainer: i,
    getExperienceId: o,
    getWindowReference: s,
    getTraitConfig: a
  }) {
    const { css: c } = a(), u = i();
    if (!c || e && e.parentNode === u)
      return;
    const p = o();
    u && (e = s().document.createElement("style"), e.id = `appcues-experience-style-${p}`, e.textContent = c, u.prepend(e));
  }
  function r() {
    e && (e.remove(), e = null);
  }
  t("step.begin", n), t("experience.end", r);
};
St(Bg, zg);
const qg = "@appcues/navigation", Wg = ({ addHook: t }, e) => {
  t("step.begin", async ({ handleNavigation: n, reportError: r }) => {
    if (e?.type)
      try {
        await n(e);
      } catch (i) {
        r(i?.message ?? "Navigation failed");
      }
  });
};
St(qg, Wg);
const Vg = "@appcues/scroll-into-view", Gg = ({ addHook: t }) => {
  let e = !1;
  t(
    "step.postrender",
    ({ getTraitConfig: n, querySelector: r, getWindowReference: i }) => {
      if (e) return;
      const {
        target: o,
        behavior: s = "smooth",
        block: a = "nearest",
        inline: c = "nearest"
      } = n();
      if (!o?.selector) return;
      const u = Pe(
        r(o.selector),
        o.filters
      );
      if (u.length === 0) return;
      const p = u[0], { innerWidth: f, innerHeight: l } = i(), { top: d, left: h, bottom: v, right: m } = p.getBoundingClientRect();
      if (d >= 0 && h >= 0 && v <= l && m <= f) {
        e = !0;
        return;
      }
      p.scrollIntoView({ behavior: s, block: a, inline: c }), e = !0;
    }
  ), t("step.end", () => {
    e = !1;
  });
};
St(Vg, Gg);
const Kg = (t) => class extends t.HTMLElement {
  constructor() {
    super();
    const n = this.ownerDocument || t.document;
    this.hideContentStyles = n.createElement("style"), this.hideContentStyles.innerHTML = `
        * {
          visibility: hidden;
        }
      `;
    try {
      this.attachShadow({ mode: "open" });
    } catch {
    }
    this.webComponentStyles = n.createElement("style"), this.webComponentStyles.innerHTML = `
        :host {
          all: initial;
          font-family: inherit;
          display: inline;
        }
      `;
  }
  async connectedCallback() {
    this.shadowRoot.append(this.hideContentStyles), this.shadowRoot.append(...this.childNodes), this.getAttribute("themeId") && await Ws(this), this.shadowRoot.prepend(this.webComponentStyles), this.hideContentStyles.remove();
  }
}, Yr = /* @__PURE__ */ new WeakMap(), Xg = (t = () => window) => {
  const e = t();
  if (Yr.has(e))
    return Yr.get(e);
  if (!e.customElements.get(Tn)) {
    const r = Kg(e);
    e.customElements.define(Tn, r);
  }
  const n = e.customElements.whenDefined(Tn);
  return Yr.set(e, n), n;
}, Yg = !1;
function Jg({
  runningExperiences: t = /* @__PURE__ */ new Map(),
  sendEvent: e = () => {
  },
  sendCustomEvent: n = () => {
  },
  showFlow: r = () => {
  },
  updateUserProfile: i = () => {
  },
  handleNavigation: o = () => {
  },
  createRenderListener: s = Nd,
  vNodeHandlers: a = Bd,
  accessibilityHandlers: c = Wd,
  getWindowReference: u = () => window,
  apiOverrides: p = {}
} = {}) {
  Ou(p);
  const f = /* @__PURE__ */ new Map(), l = {
    sendEvent: e,
    sendCustomEvent: n,
    showFlow: r,
    updateUserProfile: i,
    handleNavigation: o,
    createRenderListener: s,
    vNodeHandlers: a,
    accessibilityHandlers: c,
    getWindowReference: u,
    apiOverrides: p
  }, d = (b) => b ? l?.[b] ? l[b] : () => {
    throw new Error(`can't find external dependency called ${b}`);
  } : l, h = ({ reason: b = Se.NAVIGATION } = {}) => {
    t.forEach((A) => {
      A.experienceService.send({ type: Ce, reason: b }), A.experienceService.subscribe((R) => {
        R.matches("end-final") && A.experienceService.stop();
      });
    }), t.clear();
  }, v = (b, { reason: A = Se.NAVIGATION } = {}) => {
    t.has(b) && (t.get(b).experienceService.send({ type: Ce, reason: A }), t.delete(b));
  };
  return {
    registerAction: ce,
    registerTrait: St,
    show: async (b) => {
      Xg(u), await u().customElements.whenDefined(Tn);
      const A = rr(
        rr(
          b,
          "traits",
          (O) => (O ?? []).map((P, D) => ({
            ...P,
            id: P.id || `${P.type}:${D}`
          }))
        ),
        "steps",
        (O) => (O ?? []).map(
          (P) => rr(
            P,
            "traits",
            (D) => (D ?? []).map((L, $) => ({
              ...L,
              id: L.id || `${L.type}:${$}`
            }))
          )
        )
      ), R = t.get(b.id)?.experienceService ?? ws(Od(A, d), {
        devTools: Yg
      }).start();
      R.send({
        type: so,
        experience: A
      }), t.set(b.id, {
        experienceService: R,
        experience: A
      });
    },
    stopAll: h,
    stop: v,
    pause: (b) => {
      if (f.get(b)) return;
      const R = t.get(b);
      R && (v(b), f.set(b, {
        experienceService: R.experienceService,
        experience: R.experience
      }));
    },
    resume: (b) => {
      const A = f.get(b);
      A && (A.experienceService.send({ type: so }), t.set(b, {
        experienceService: A.experienceService,
        experience: A.experience
      }), f.delete(b));
    },
    getRunningExperiences: () => [...t].map(([, { experience: b }]) => b),
    isExperiencePaused: (b) => f.has(b)
  };
}
export {
  Jg as default
};
